import type { Dict } from '../types';

export const tr: Dict = {
  'chat.amrCard.switchTitle': 'Model çağrısı başarısız oldu — bu çalıştırma duraklatıldı',
  'chat.amrCard.switchBody': 'DANIA Studio\'ın resmi model hizmetine geçin — API anahtarı yapılandırması gerekmez. Oturum açma, yetkilendirme ve bakiye yükleme sonrası bu çalıştırma otomatik olarak yeniden denenir.',
  'chat.amrCard.chipOfficial': 'Resmi hizmet',
  'chat.amrCard.chipNoKey': 'API anahtarı gerekmez',
  'chat.amrCard.chipAutoRetry': 'Giriş sonrası otomatik yeniden deneme',
  'chat.amrCard.switchCta': 'DANIA Studio\'ye geç ve yeniden dene',
  'chat.amrError.authMessage': 'DANIA Studio hesabınız henüz yetkilendirilmedi. Yetkilendirin ve bu çalıştırma otomatik olarak yeniden denensin.',
  'chat.amrError.balanceMessage': 'DANIA Studio bakiyeniz bitti. Çalıştırmaya devam etmek için bakiye yükleyin.',
  'chat.amrError.authorizeCta': 'Yetkilendir ve yeniden dene',
  'chat.amrError.rechargeCta': 'DANIA Studio bakiyesi yükle',
  'chat.amrBalanceGate.title': 'Yükseltin, üretmeye devam edin',
  'chat.amrBalanceGate.message': 'Kredi yetersiz (kalan {balance}). Planınızı yükseltin veya bakiye yükleyin, görev hemen başlayabilir.',
  'chat.amrBalanceGate.benefitsTitle': 'DANIA Studio Cloud size neler sunar',
  'chat.amrBalanceGate.benefit1': 'API anahtarı gerekmez, çok sayıda model',
  'chat.amrBalanceGate.benefit2': 'SOTA tasarım ajanı dahili, kurulum gerekmez',
  'chat.amrBalanceGate.benefit3': 'Resmî ve güvenilir hizmet',
  'chat.amrBalanceGate.benefit4': 'Sürekli gelişiyor: tek tıkla yayınlama, çok modlu, ekipler ve dahası',
  'chat.amrBalanceGate.laterCta': 'Şimdi değil',
  'chat.amrBalanceGate.plansCta': 'Planı yükselt',
  'chat.amrBalanceGate.signedOutTitle': 'Oturum açın, üretmeye başlayın',
  'chat.amrBalanceGate.signedOutMessage': 'DANIA Studio Cloud ajanını kullanıyorsunuz — oturum açın, bu görev hemen başlayabilir.',
  'chat.amrBalanceGate.signInCta': 'Oturum aç',
  'chat.amrBalanceGate.watchingWallet': 'Bakiyeniz güncellenince otomatik olarak devam edeceğiz.',
  'chat.amrLowBalance.title': 'Krediniz azalıyor',
  'chat.amrLowBalance.message': 'Yalnızca {balance} kaldı — bu görevi bitirmeye yetmeyebilir. Önce bakiye yükleyin veya planınızı yükseltin.',
  'chat.amrLowBalance.rechargeCta': 'Bakiye yükle',
  'chat.amrLowBalance.proceedCta': 'Yine de başlat',
  'chat.amrLowBalance.dontRemind': 'Bir daha sorma',
  'chat.antigravityError.launchTerminalCta': 'Terminal üzerinden giriş yap',
  'chat.antigravityError.launchSwitchModelCta': 'Terminalde modeli değiştir',
  'chat.connectionDropped': 'Yanıt tamamlanmadan model hizmetiyle bağlantı koptu — genellikle kararsız bir ağ veya proxy nedeniyle. Lütfen yeniden deneyin.',
  'chat.runError.title.authRequired': 'Yetkilendirme gerekli',
  'chat.runError.title.balance': 'Yetersiz bakiye',
  'chat.runError.title.connectionDropped': 'Bağlantı koptu',
  'chat.runError.title.signInRequired': 'Oturum açma gerekli',
  'chat.runError.title.rateLimited': 'Kullanım sınırına ulaşıldı',
  'chat.runError.title.generic': 'Görev başarısız',
  'chat.runError.signInMessage.amr': 'DANIA Studio aracısı henüz oturum açmadı — kullanmaya başlamak için oturum açın.',
  'chat.runError.signInMessage.other': '{agent} oturum açmadı. Oturum durumunu yerel olarak kontrol edin. Daha kararlı ve hesaplı DANIA Studio aracısını öneririz.',
  'chat.runError.agentFallback': 'aracı',
  'chat.runError.sourceLabel': 'Hata kaynağı',
  'chat.runError.sourceExpandAria': 'Hata kaynağını genişlet',
  'chat.runError.sourceCollapseAria': 'Hata kaynağını daralt',
  'common.cancel': 'İptal et',
  'chat.selectFromLibrary': 'Kitaplıktan içe aktar',
  'chat.importFigma': 'Figma\'dan içe aktar',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the DANIA Studio project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': 'Kitaplıktan içe aktar',
  'designFiles.library.title': 'Kitaplıktan içe aktar',
  'libraryPicker.title': 'Kitaplıktan içe aktar',
  'libraryPicker.searchPlaceholder': 'Kitaplıkta ara…',
  'libraryPicker.empty': 'Kitaplığınızda henüz öğe yok',
  'libraryPicker.allKinds': 'Tümü',
  'libraryPicker.add': 'İçe aktar',
  'libraryPicker.loading': 'Yükleniyor…',
  'common.save': 'Kaydet',
  'common.close': 'Kapat',
  'common.clear': 'Temizle',
  'common.delete': 'Sil',
  'common.rename': 'Yeniden adlandır',
  'common.edit': 'Düzenle',
  'common.preview': 'Önizleme',
  'common.share': 'Paylaş',
  'common.search': 'Ara',
  'common.searchEllipsis': 'Ara…',
  'common.loading': 'Yükleniyor…',
  'common.all': 'Hepsi',
  'common.none': 'Hiçbiri',
  'common.default': 'Varsayılan',
  'common.installed': 'kuruldu',
  'common.notInstalled': 'kurulmadı',
  'common.active': 'aktif',
  'common.offline': 'çevrim dışı',
  'common.selected': 'seçili',
  'common.create': 'Oluştur',
  'common.openPreview': 'Önizlemeyi aç',
  'common.exitFullscreen': 'Tam ekrandan çık',
  'common.fullscreen': 'Tam ekran',
  'common.openInNewTab': 'Yeni sekmede aç',
  'common.exportPdf': 'PDF olarak dışa aktar',
  'common.exportZip': 'ZIP olarak indir',
  'common.exportHtml': 'Tekil HTML olarak dışa aktar',
  'common.exportImage': 'Görüntü olarak dışa aktar',
  'common.exportImageFailed': 'Görüntü yakalama başarısız oldu. Lütfen tekrar deneyin veya tarayıcınızın ekran görüntüsü aracını kullanın.',
  'common.justNow': 'şimdi',
  'common.minutesAgo': '{n} dakika önce',
  'common.hoursAgo': '{n} saat önce',
  'common.daysAgo': '{n} gün önce',
  'common.weeksAgo': '{n}h önce',
  'common.now': 'şimdi',
  'common.minutesShort': '{n}d',
  'common.hoursShort': '{n}s',
  'common.daysShort': '{n}g',
  'common.untitled': 'Başlıksız',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'Step 2: click Download Page here, wait for the saved snapshot success, then return to the left Next Step card and click Continue extraction.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': 'Köken',
  'plugins.availableDetails.provenanceLine': '{source} kaynağından · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': '{source} kaynağından · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Yükle',
  'plugins.availableDetails.version': 'Sürüm',
  'plugins.availableDetails.pluginVersion': 'Eklenti sürümü',
  'plugins.availableDetails.copyInstallCommand': 'Yükleme komutunu kopyala',
  'plugins.availableDetails.copied': 'Kopyalandı',
  'plugins.availableDetails.deprecatedPrefix': 'Kullanımdan kaldırıldı: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Bu sürüm kullanımdan kaldırılmış olarak işaretlendi.',
  'plugins.availableDetails.yanked': 'Geri çekildi.',
  'plugins.availableDetails.yankedWithReason': 'Geri çekildi: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (kullanımdan kaldırıldı)',
  'plugins.availableDetails.versionYankedSuffix': ' (geri çekildi)',
  'plugins.availableDetails.ref': 'Referans',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'İzinler',
  'plugins.availableDetails.capabilitySummary': 'Yetenek özeti',
  'plugins.actions.copyInstallCommand': 'Kurulum komutunu kopyala',
  'plugins.actions.copyPluginId': 'Eklenti ID’sini kopyala',
  'plugins.actions.copyReadmeBadge': 'README rozetini kopyala',
  'plugins.actions.openSourceGithub': 'Kaynağı GitHub’da aç',
  'plugins.actions.openSource': 'Kaynağı aç',
  'plugins.actions.openHomepage': 'Ana sayfayı aç',
  'plugins.actions.openMarketplace': 'Marketplace’te aç',
  'app.brand': 'DANIA Studio',
  'app.brandPill': 'Önizleme Araştırması',
  'app.brandSubtitle': 'Nexu Labs tarafından',
  'app.welcomeLoading': 'Çalışma alanı yükleniyor…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'DANIA Studio’a hoş geldiniz',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Bir brief ile başlayın',
  'settings.onboardingCreateBody': 'İstediğiniz siteyi, uygulamayı, sunumu, görseli veya videoyu tanımlayın. DANIA Studio bir proje oluşturacak ve çalışmayı düzenlenebilir tutacak.',
  'settings.onboardingMemoryTitle': 'Çalışma bağlamını kaydet',
  'settings.onboardingMemoryBody': 'Tercihleri, proje bilgilerini ve tekrar eden kuralları ekleyin; böylece gelecekteki sohbetler doğru bağlamı alır.',
  'settings.onboardingMemoryCalloutTitle': 'Belleğinize kaydedildi',
  'settings.onboardingMemoryCalloutBody': 'Bu yanıtlar Bellek profilinizin temelini oluşturur. DANIA Studio bunu her görevde yeniden kullanır ve siz çalışırken öğrenmeye devam eder.',
  'settings.onboardingMemoryBenefitIntent': 'Kısa bir istekten ne demek istediğinizi anlar',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Tekrarlanan kurulum sorularını atlar',
  'settings.onboardingMemoryBenefitPersonalized': 'Çıktıyı rolünüze, kitlenize ve zevkinize göre uyarlar',
  'settings.onboardingSystemsTitle': 'Kendi tasarım sisteminizi getirin',
  'settings.onboardingSystemsBody': 'Üretilen çalışmaların gerçek renkleri, tipografiyi ve ürün dilini izlemesi için bir marka sistemi seçin veya oluşturun.',
  'settings.onboardingExecutionTitle': 'Üretimin nasıl çalışacağını seçin',
  'settings.onboardingExecutionBody': 'Tek tıkla kurulum ve kullanıma hazır varsayılanlarla resmi CLI. Daha iyi fiyatlandırmayla birçok model arasından seçim yapmak için tek bir anahtar kullanın.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Resmi olarak önerilir',
  'settings.onboardingAmrCloudBenefitReady': 'Dağıtım gerekmez',
  'settings.onboardingAmrCloudBenefitModels': 'Claude Opus 4.8 desteği',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': 'Yakında',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Görsel ve video',
  'settings.onboardingAmrCloudUpcomingSkills': 'Çok sayıda Skills',
  'settings.onboardingAmrCloudUpcomingRouting': 'Akıllı yönlendirme',
  'settings.onboardingAmrModelSourceLabel': 'DANIA Studio CLI',
  'settings.onboardingAmrCloudAuthorizeAction': 'DANIA Studio yetkilendir',
  'settings.onboardingAmrCloudAuthorizedAction': 'Yetkilendirildi',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Tasarım sistemi oluştur',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Güncel kalın',
  'settings.onboardingNewsletterTitle': 'Gelişmeleri kaçırmayın',
  'settings.onboardingNewsletterBody': 'Ürün güncellemelerini, yeni şablonları, tasarım sistemlerini ve elçi çalışmalarını gelen kutunuzda alın. İsteğe bağlı — atlayabilirsiniz.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'DANIA Studio’a giriş yap',
  'settings.onboardingCloudBody': 'Giriş yap ve bulut yapay zekâsıyla hemen tasarlamaya başla — karmaşık kurulum gerekmez.',
  'settings.onboardingCloudSignIn': 'DANIA Studio’a giriş yap',
  'settings.onboardingCloudContinue': 'Devam et (giriş yapıldı)',
  'settings.onboardingCloudAlternative': 'Yerel bir CLI ya da kendi API anahtarını kullan',
  'settings.onboardingCloudRights': 'Tüm hakları saklıdır.',
  'settings.onboardingCloudOr': 'veya',
  'settings.onboardingGateTooltipNoRuntime': 'Sonraki adımlar yapay zekâ ile çalışır — devam etmek için bir çalışma yöntemi seçin.',
  'settings.onboardingGateTooltipAmr': 'Sonraki adımlar yapay zekâ ile çalışır — devam etmek için DANIA Studio’ye giriş yapın.',
  'settings.onboardingGateTooltipLocal': 'Sonraki adımlar yapay zekâ ile çalışır — devam etmek için kullanılabilir bir yerel CLI seçin.',
  'settings.onboardingGateTooltipByok': 'Sonraki adımlar yapay zekâ ile çalışır — devam etmek için model anahtarınızı ekleyip test edin.',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': 'Resmi',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'About you',
  'settings.onboardingProfileBody': 'Optional details for better defaults.',
  'settings.onboardingRoleLabel': 'Your role',
  'settings.onboardingOrgSizeLabel': 'Organization size',
  'settings.onboardingUseCaseLabel': 'Use case',
  'settings.onboardingSourceLabel': 'Where did you hear about us?',
  'settings.onboardingSelectPlaceholder': 'Select one',
  'settings.onboardingSelectMultiplePlaceholder': 'Select one or more',
  'settings.onboardingOrgSolo': 'Solo / personal (1)',
  'settings.onboardingOrgTeam': 'Small team (2-10)',
  'settings.onboardingOrgStartup': 'Startup / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'Growth company (51-200)',
  'settings.onboardingOrgMidMarket': 'Mid-market (201-1000)',
  'settings.onboardingOrgEnterprise': 'Enterprise (1000+)',
  'settings.onboardingRolePm': '📋 Product manager',
  'settings.onboardingRoleDesigner': '🎨 Designer',
  'settings.onboardingRoleEngineer': '💻 Engineer',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleAgency': '📣 Pazarlama ajansı',
  'settings.onboardingRoleGrowth': '📈 Growth',
  'settings.onboardingRoleOps': '⚙️ Operations',
  'settings.onboardingRoleFounder': '🚀 Founder / executive',
  'settings.onboardingRoleStudent': '🎓 Student / educator',
  'settings.onboardingRoleOther': '✨ Other',
  'settings.onboardingUseProduct': '🎨 Product design',
  'settings.onboardingUseDesignSystem': '🧩 Design system',
  'settings.onboardingUsePrototype': '📱 Prototype / app UI',
  'settings.onboardingUseLanding': '🌐 Landing pages',
  'settings.onboardingUseAds': '📣 Ads / social content',
  'settings.onboardingUseDashboard': '📊 Dashboards / internal tools',
  'settings.onboardingUseDeck': '🖥️ Presentation / deck',
  'settings.onboardingUseMarketing': '📈 Marketing / growth',
  'settings.onboardingUseEngineering': '🤝 Engineering handoff',
  'settings.onboardingUseAgency': '💼 Agency / client work',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceFriend': '👥 Friend or coworker',
  'settings.onboardingSourceSocial': '📱 Social media',
  'settings.onboardingSourceProductHunt': '🅿️ Product Hunt',
  'settings.onboardingSourceCommunity': '💬 Design / AI community',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceBlog': '📰 Blog or newsletter',
  'settings.onboardingSourceAiTool': '✨ AI tool recommendation',
  'settings.onboardingSourceSearch': '🔍 Search',
  'settings.onboardingSourceEvent': '🎤 Event or community',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'Ayarlar',
  'settings.title': 'Yürütme modu',
  'settings.subtitle': 'Yerel CLI ile BYOK arasında seçim yapın.',
  'settings.modeAria': 'Çalıştırma modu',
  'settings.protocolAria': 'API protokolü',
  'settings.modeDaemon': 'Yerel CLI',
  'settings.modeDaemonHelp': 'Yerel kod ajanı CLI ile çalıştır',
  'settings.modeDaemonOffline': 'Arka plan servisi çalışmıyor',
  'settings.modeDaemonOfflineMeta': 'Arka plan servisi devre dışı',
  'settings.modeDaemonInstalledMeta': '{count} kuruldu',
  'settings.modeApi': 'API sağlayıcısı',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'BYOK proje dosyalarını okuyamaz, yazamaz veya düzenleyemez. Kod değişiklikleri gerektiğinde Local CLI kullanın.',
  'settings.codeAgent': 'Kod ajanı',
  'settings.codeAgentHint': 'Yerel PATH taranarak tespit edildi. Oluşum akışının yaşanacağı CLI aracınızı seçin.',
  'settings.rescan': '↻ Yeniden tara',
  'settings.rescanTitle': 'PATH’ı yeniden tara',
  'settings.rescanRunning': 'Taranıyor...',
  'settings.rescanSuccess': 'Tarama tamamlandı. {count} kullanılabilir.',
  'settings.designSystemRenameFailed': 'Yeniden adlandırma başarısız. Daemon’u kontrol edip tekrar deneyin.',
  'settings.rescanFailed': 'Tarama başarısız. Daemon’u kontrol edip tekrar deneyin.',
  'settings.test': 'Test et',
  'settings.testTitle': 'Bağlantıyı doğrulamak için minik bir test istemi gönderin',
  'settings.testRunning': 'Bağlantı test ediliyor…',
  'settings.byokReadyToTest': 'Teste hazır',
  'settings.testCancel': 'İptal',
  'settings.testRetry': 'Testi yeniden dene',
  'settings.required': 'zorunlu',
  'settings.testMissingFields': 'Bağlantıyı test etmek için {fields} alanını doldurun.',
  'settings.testSuccessApi': 'Bağlandı. {ms} ms içinde yanıtladı — \'{sample}\'',
  'settings.testSuccessCli': '{agentName}, {ms} ms içinde yanıtladı — \'{sample}\'',
  'settings.testAuthFailed': 'Kimlik doğrulama başarısız. API anahtarınızı kontrol edin.',
  'settings.testForbidden': 'Erişim yasak. Hesabı, bölgeyi veya kuruluşu doğrulayın.',
  'settings.testNotFoundModel': 'Bu uçta \'{model}\' modeli bulunamadı.',
  'settings.testInvalidModelId': '\'{model}\' model id geçersiz. Özel id harf veya rakamla başlamalı ve boşluk içermemelidir.',
  'settings.testInvalidBaseUrl': 'Base URL geçersiz veya erişilemez.',
  'settings.testRateLimited': 'Sağlayıcı testi hız sınırladı. Yapılandırma geçerli görünüyor.',
  'settings.testUpstream': 'Sağlayıcı {status} döndürdü. Birazdan tekrar deneyin.',
  'settings.testTimeout': 'Test {ms} ms sonra zaman aşımına uğradı.',
  'settings.testAgentMissing': '{agentName} yüklü değil veya PATH\'te yok.',
  'settings.testAgentSpawn': '{agentName} başlatılamadı: {detail}.',
  'settings.testUnknown': 'Test başarısız: {detail}',
  'settings.agentInstall.install': 'Yükle',
  'settings.agentInstall.docs': 'Dokümanlar',
  'settings.agentInstall.pathHint': 'Bir CLI\'yi npm veya Homebrew ile kurduysan ancak hâlâ kurulu değil olarak görünüyorsa, aracın bin dizininin DANIA Studio daemon\'unun devraldığı PATH içinde olduğundan emin ol (macOS\'te Terminal ve GUI uygulamalarının PATH\'i farklı olabilir). QUICKSTART.md içindeki "Local agent CLI and PATH" bölümüne bak.',
  'settings.agentInstall.stepOpenLinks': 'Tercih ettiğin ajan için Yükle veya Dokümanlar bağlantısını aç.',
  'settings.agentInstall.stepAuth': 'DANIA Studio\'a dönmeden önce sağlayıcı CLI\'sinde kimlik doğrulaması yap (oturum aç veya API kimlik bilgileri ekle).',
  'settings.agentInstall.stepRescan': 'Bu bölümde Yeniden tara\'ya tıkla.',
  'settings.agentInstall.stepSelect': 'Ajan yüklü olarak göründüğünde kartını seç.',
  'settings.noAgentsDetected': 'Hiçbir ajan tespit edilemedi. Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen, veya GitHub Copilot CLI’lardan birini kurun ve yeniden tarayın.',
  'settings.agentInstalledGroup': 'CLI\'larınız ({count})',
  'settings.agentInstallGroup': 'Kurulabilir ({count})',
  'settings.agentAuthRequired': 'Kimlik doğrulama gerekli',
  'settings.agentAuthUnknown': 'Kimlik doğrulama durumu bilinmiyor',
  'settings.amrCloud': 'DANIA Studio',
  'settings.amrAuthorize': 'Yetkilendir',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Birçok model',
  'settings.amrPromoBonus': 'Sınırlı bonus: +%100',
  'settings.amrSignInToContinue': 'Devam etmek için oturum açın',
  'settings.amrSignIn': 'Oturum aç',
  'settings.amrSignedIn': 'Oturum açıldı',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh AMR wallet balance',
  'settings.amrNotSignedIn': 'Oturum açılmadı',
  'settings.amrSigningIn': 'Giriş yapılıyor…',
  'settings.amrActivationHint': 'Oturum açma sayfası açılmadı mı? Yeniden açmak için aşağıdaki düğmeye dokunun.',
  'settings.amrActivationBrowserFailed': 'Tarayıcı otomatik olarak açılamadı. Devam etmek için aşağıdaki oturum açma sayfasını açın.',
  'settings.amrActivationOpen': 'Oturum açma sayfasını aç',
  'settings.amrCancelSignIn': 'Oturum açmayı iptal et',
  'settings.amrAccountStatus': 'DANIA Studio hesap durumu',
  'settings.amrConsole': 'Yönet',
  'settings.amrBalance': 'Bakiye',
  'settings.amrPlan': 'Plan',
  'settings.amrUpgrade': 'Yükselt',
  'settings.amrLoginErrorCompact': 'DANIA Studio oturum açma başarısız oldu.',
  'settings.advanced': 'Gelişmiş',
  'settings.amrLogin': 'Oturum aç',
  'settings.amrLogout': 'Oturumu kapat',
  'settings.amrLoggingIn': 'Giriş yapılıyor…',
  'settings.amrLoggingOut': 'Çıkış yapılıyor…',
  'settings.amrLoggedInAs': '{email} olarak oturum açıldı',
  'settings.amrLoggedInWithPlan': '{email} olarak giriş yapıldı · {plan}',
  'settings.amrLoggedInPill': 'Oturum açıldı',
  'settings.amrNotLoggedIn': 'Oturum açılmadı',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Sağlayıcıyı hızlı doldur',
  'settings.providerPreset': 'Ağ geçidi ön ayarı',
  'settings.protocolGroupProtocols': 'Protokoller',
  'settings.protocolGroupGateways': 'Ağ geçitleri',
  'settings.customProvider': 'Özel sağlayıcı',
  'settings.apiKey': 'API anahtarı',
  'settings.apiKeyGetLink': 'Anahtar al ↗',
  'settings.showKey': 'Anahtarı göster',
  'settings.hideKey': 'Anahtarı gizle',
  'settings.show': 'Göster',
  'settings.hide': 'Gizle',
  'settings.model': 'Model',
  'settings.apiKeyInvalid': 'Geçersiz API key.',
  'settings.apiKeyCleaned': 'API key içindeki fazladan boşluklar kaldırıldı.',
  'settings.modelsLoadedFromAccount': '✓ Hesabınızdan {count} model yüklendi.',
  'settings.modelsLoadedCount': '✓ {count} model yüklendi.',
  'settings.modelSourceAccount': 'Hesabınızdan',
  'settings.modelSourceSuggested': 'Önerilen',
  'modelCapability.fast': 'Hızlı',
  'modelCapability.value': 'Değer',
  'modelCapability.balanced': 'Genel',
  'modelCapability.reasoning': 'Akıl',
  'modelCapability.premium': 'En iyi',
  'modelCapability.coding': 'Kod',
  'modelCapability.fastDescription': 'Hız önemli olduğunda günlük istemler için iyi.',
  'modelCapability.valueDescription': 'Rutin işler için daha düşük maliyet.',
  'modelCapability.balancedDescription': 'Çoğu görev için güvenilir varsayılan seçenek.',
  'modelCapability.reasoningDescription': 'Karmaşık mantık ve planlama için daha iyi.',
  'modelCapability.premiumDescription': 'En yüksek yetenek, genelde daha yüksek maliyet.',
  'modelCapability.codingDescription': 'Kod ve teknik düzenlemeler için ayarlı.',
  'modelCost.upToHalf': 'En düşük maliyet',
  'modelCost.halfToOne': 'Düşük maliyet',
  'modelCost.oneToFour': 'Yüksek maliyet',
  'modelCost.overFour': 'En yüksek maliyet',
  'settings.fetchModels': 'Modelleri getir',
  'settings.fetchModelsTitle': 'Bu sağlayıcıdan kullanılabilir modelleri getir',
  'settings.fetchModelsRunning': 'Modeller getiriliyor…',
  'settings.fetchModelsMissingFields': 'Modelleri getirmek için {fields} alanını doldurun.',
  'settings.fetchModelsInvalidBaseUrl': 'Modelleri getirmek için geçerli bir Base URL girin.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI dağıtım adlarını kullanır, bu nedenle model keşfi burada kullanılamaz.',
  'settings.fetchModelsUnsupportedOllama': 'Ollama Cloud model keşfi henüz kullanılamıyor. Bir model seçin veya yazın.',
  'settings.fetchModelsSuccess': '{count} model getirildi.',
  'settings.fetchModelsEmpty': 'Uyumlu metin modeli döndürülmedi.',
  'settings.fetchModelsUnsupported': 'Bu protokol için model keşfi kullanılamıyor.',
  'settings.fetchModelsFailed': 'Modeller getirilemedi: {detail}',
  'settings.suggestedModelsHint': 'Bunlar bu protokol için önerilen modellerdir. Sağlayıcınız farklı modelleri destekleyebilir.',
  'settings.baseUrl': 'Temel URL',
  'settings.baseUrlInvalid': 'Genel bir http:// veya https:// URL kullanın.',
  'settings.baseUrlCustomize': 'Özelleştir',
  'settings.baseUrlDefaultHint': 'Varsayılan uç nokta. Genellikle değiştirmeniz gerekmez.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Bunu Azure portalında bulun → kaynağınız → Endpoint.',
  'settings.azureDeploymentModel': 'Dağıtım adı',
  'settings.azureCustomDeploymentName': 'Özel dağıtım adı',
  'settings.azureDeploymentModelHint': 'Azure OpenAI icin bu alan /openai/deployments/<model> icindeki dagitim adi olarak kullanilir. Azureda olusturdugunuz dagitim adini girin.',
  'settings.azureModelFetchHint': 'Azure kaynağınızdaki dağıtım adını girin. Azure dağıtımları otomatik olarak getirilemez.',
  'settings.apiVersion': 'API sürümü',
  'settings.byokImageModel': 'Görüntü oluşturma modeli',
  'settings.byokVideoModel': 'Video oluşturma modeli',
  'settings.byokVideoI2vHint': 'Görüntüden videoya modeli: referans görüntü gerekir (belirtmezseniz projedeki en yeni görüntü kullanılır)',
  'settings.byokSpeechModel': 'Konuşma modeli',
  'settings.byokSpeechVoice': 'Ses',
  'settings.byokModelDefaultOption': 'Varsayılan',
  'settings.maxTokens': 'Maks. token (isteğe bağlı)',
  'settings.maxTokensHint': 'Yanıt uzunluğu sınırı. Her modelin ayarlanmış bir varsayılanı vardır (yer tutucuda görünür); kullanmak için boş bırakın, üzerine yazmak için bir sayı girin.',
  'settings.apiHint': 'İstekler yerel daemon proxy üzerinden ayarladığınız Base URLye gönderilir. Anahtar yalnızca bu tarayıcıda saklanır ve sağlayıcı istekleriyle birlikte gönderilir.',
  'settings.skipForNow': 'Şimdilik atla',
  'settings.getStarted': 'Başla',
  'settings.envConfigure': 'Yürütme modu',
  'settings.localCli': 'Yerel CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'Ajan seçilmedi',
  'settings.language': 'Dil',
  'settings.languageHint': 'Arayüz dilini değiştirin. Bu tarayıcıya kaydedilir.',
  'settings.appearance': 'Görünüm',
  'settings.appearanceHint': 'Açık, koyu veya sistem ayarını takip et.',
  'settings.themeSystem': 'Sistem',
  'settings.themeLight': 'Açık',
  'settings.themeDark': 'Koyu',
  'settings.agentModelHead': 'Model için:',
  'settings.modelPicker': 'Model',
  'settings.modelSourceLive': 'CLI\'dan canlı',
  'settings.modelSourceFallback': 'Yerleşik liste',
  'settings.reasoningPicker': 'Akıl yürütme eforu',
  'settings.modelPickerHint': 'Bir `models` komutu açığa çıkaran CLI’lardan getirilir. "Varsayılan" seçimi CLI’ın kendi ayarına bırakır; "Özel…" CLI’ın kabul edeceği herhangi bir model kimliği seçmenize izin verir.',
  'settings.modelPickerLiveHint': 'Modeller kurulu CLI\'dan yenilendi. Varsayılan seçenek hâlâ CLI yapılandırmasını kullanır.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Modeller kurulu CLI\'dan yenilendi.',
  'settings.modelPickerFallbackHint': 'Yerleşik varsayılanlar gösteriliyor. CLI\'dan canlı modelleri almak için Yeniden tara\'ya tıklayın.',
  'settings.cliEnvTitle': 'Gelişmiş: proxy ve özel yollar',
  'settings.cliEnvHint': 'Seçili CLI ortamını geçersiz kılmak için bunları kullanın: API key, proxy base URL, özel home veya standart dışı binary yolları. Base URL yoksa CLI kendi varsayılan endpointini kullanır. Gizli bilgiler yerel uygulama yapılandırmasında kalır ve yalnızca seçili CLI bunları görür.',
  'settings.cliEnvClaudeConfigDir': 'Claude Code yapılandırma dizini',
  'settings.cliEnvClaudeBaseUrl': 'Claude proxy Base URL',
  'settings.cliEnvClaudeApiKey': 'Claude CLI API key',
  'settings.cliEnvCodexHome': 'Codex home',
  'settings.cliEnvCodexBin': 'Codex çalıştırılabilir dosya yolu',
  'settings.cliEnvCodexBaseUrl': 'Codex/OpenAI proxy Base URL',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI CLI API key',
  'settings.modelCustom': 'Özel (aşağıya yazın)…',
  'settings.modelCustomLabel': 'Özel model kimliği',
  'settings.modelCustomPlaceholder': 'örn. anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Medya sağlayıcıları',
  'settings.mediaProvidersHint': 'Görsel, video ve ses oluşumu için API anahtarları. Yerel saklanır ve yerel arka plan servisiyle senkronize edilir.',
  'settings.mcpServerTitle': 'MCP sunucusu',
  'settings.mcpServerHint': 'DANIA Studio\'ı kodlama ajanınız için MCP sunucusu olarak yayınlayın.',
  'settings.externalMcpTitle': 'Dış MCP',
  'settings.externalMcpHint': 'Dış servislerden (Higgsfield, GitHub, …) MCP araçları ekleyin.',
  'settings.mediaProviderApiKey': 'API anahtarı',
  'settings.mediaProviderBaseUrl': 'Temel URL',
  'settings.mediaProviderConfigured': 'Ayarlandı',
  'settings.mediaProviderUnset': 'Ayarlanmadı',
  'settings.mediaProviderClear': 'Temizle',
  'settings.mediaProviderClearConfirm': 'Kayıtlı {name} ayarları silinsin mi? {name}\'ı tekrar kullanmak için bunları yeniden girmeniz gerekecek.',
  'settings.mediaProviderPlaceholder': 'API anahtarı yapıştır',
  'settings.mediaProviderBaseUrlPlaceholder': 'Varsayılan temel URL’yi görmezden gel',
  'settings.mediaProviderReload': 'Daemon’dan yeniden yükle',
  'settings.mediaProviderReloadError': 'Medya sağlayıcı ayarları yerel daemon’dan yeniden yüklenemedi.',
  'settings.mediaProviderReloadSuccess': 'Medya sağlayıcı ayarları yerel daemon’dan yeniden yüklendi.',
  'settings.mediaProviderLoadError': 'Medya sağlayıcı ayarları yerel daemon’dan yüklenemedi. Şimdilik tarayıcıya kaydedilen ayarlar kullanılıyor.',
  'settings.mediaProviderComingSoonHint': 'Bunları yol haritası için takip ediyoruz; daemon henüz bir istemci göndermediği için yapılandırılacak bir şey yok.',
  'settings.privacy': 'Gizlilik',
  'settings.privacyHint': 'DANIA Studio ekibiyle hangi veriler paylaşılır',
  'settings.privacyConsentKicker': 'DANIA Studio\'ı geliştirmemize yardımcı olun',
  'settings.privacyConsentLead': 'DANIA Studio, geliştirmemize yardımcı olmak için kullanım verilerini ekibimizle paylaşabilir. Buna şunlar dahildir:',
  'settings.privacyConsentFooter': 'Bu seçenekleri istediğiniz zaman Ayarlar → Gizlilik bölümünden değiştirebilirsiniz.',
  'settings.privacyConsentShare': 'Kullanım verilerini paylaş',
  'settings.privacyConsentDecline': 'Paylaşma',
  'settings.privacyConsentAccept': 'Anladım',
  'settings.privacyConsentBannerFooter': 'Veri paylaşımı varsayılan olarak açıktır. Ayarlar → Gizlilik bölümünden istediğiniz zaman kapatabilirsiniz.',
  'settings.privacyConsentPolicyLink': 'Gizlilik politikasını okuyun',
  'settings.privacyMetrics': 'Anonim metrikler',
  'settings.privacyMetricsHint': 'Çalıştırma sayıları, Token kullanımı, hata oranı, süre. Hiçbir komut istemi veya proje verisi içermez.',
  'settings.privacyContent': 'Conversation content',
  'settings.privacyContentHint': 'Promptlar, asistan yanıtları, araç giriş/çıkışları ve kalite incelemesi için gereken tam bağlam dosyaları. Gizli bilgiler gönderilmeden önce kaldırılır.',
  'settings.privacyInstallationId': 'Anonim kimlik',
  'settings.privacyOptedOut': 'vazgeçildi',
  'settings.privacyDataDeletion': 'Verilerimi sil',
  'settings.privacyDataDeletionHint': 'Anonim kimliğinizi döndürür ve göndermeyi durdurur. Mevcut izler, saklama politikamız uyarınca zamanla silinir.',
  'settings.about': 'Hakkında',
  'settings.aboutHint': 'Sürüm ve çalışma zamanı detayları',
  'settings.appVersion': 'Sürüm',
  'settings.appChannel': 'Kanal',
  'settings.appRuntime': 'Çalışma zamanı',
  'settings.appPlatform': 'Platform',
  'settings.appArchitecture': 'Mimari',
  'settings.runtimePackaged': 'Paketlenmiş uygulama',
  'settings.runtimeDevelopment': 'Geliştirme',
  'settings.versionUnavailable': 'Arka plan servisi devre dışıyken sürüm detayları mevcut değildir.',
  'settings.installLatest': 'En son sürümü yükle',
  'settings.alreadyLatest': 'En son sürüme sahipsiniz',
  'settings.updateCheck': 'Güncellemeleri denetle',
  'settings.updateNow': 'Şimdi güncelle',
  'settings.updateRecheck': 'Tekrar denetle',
  'settings.updateRetry': 'Tekrar dene',
  'settings.updateViewReleases': 'Sürüm notları',
  'settings.updateActionFailed': 'Güncelleme işlemi tamamlanamadı.',
  'settings.updateQuitFailed': 'Yükleyici açıldı, ancak DANIA Studio otomatik kapanamadı.',
  'settings.updateStatusNotChecked': 'Henüz denetlenmedi',
  'settings.updateStatusDevelopment': 'Geliştirme sürümleri uygulama içi güncellemeyi desteklemez.',
  'settings.updateStatusUnsupported': 'Bu ortam uygulama içi güncellemeyi desteklemez.',
  'settings.updateStatusChecking': 'Güncellemeler denetleniyor...',
  'settings.updateStatusUpToDate': 'Zaten en son sürümdesiniz.',
  'settings.updateStatusAvailable': '{version} sürümü bulundu. İndirme hazırlanıyor.',
  'settings.updateStatusAvailableUnknown': 'Yeni sürüm bulundu. İndirme hazırlanıyor.',
  'settings.updateStatusDownloading': 'Güncelleme indiriliyor...',
  'settings.updateStatusDownloadingPercent': 'Güncelleme indiriliyor {percent}%.',
  'settings.updateStatusReady': '{version} sürümü kuruluma hazır.',
  'settings.updateStatusReadyUnknown': 'Güncelleme kuruluma hazır.',
  'settings.updateStatusInstalling': 'Güncelleme kuruluyor...',
  'settings.updateStatusFailed': 'Denetim başarısız. Tekrar deneyin.',
  'settings.mcpTitle': 'MCP sunucusu',
  'settings.mcpHint': 'Kodlama agent\'larının (Cursor, Claude Code, VS Code…) DANIA Studio projelerinizi doğrudan okumasına izin verin.',
  'settings.mcpDaemonError': 'Kurulum yollarını çözümlemek için yerel daemon\'a ulaşılamadı ({error}). DANIA Studio\'ın çalıştığından emin olun, ardından bu paneli yeniden açın.',
  'settings.mcpBuildDaemon': 'Önce daemon\'ı derleyin.',
  'settings.mcpNodeMissing': 'Node ikili dosyası eksik.',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js eksik. `pnpm --filter @open-design/daemon build` komutunu çalıştırın ve yenileyin.',
  'settings.mcpMethodCli': 'CLI komutu',
  'settings.mcpInstructionCli': 'Bunu terminalinizde çalıştırın.',
  'settings.mcpMethodToml': 'TOML yapılandırması',
  'settings.mcpInstructionCodex': 'Bu tabloyu {path} dosyasına ekleyin. Aynı yapılandırma Codex CLI ile Codex IDE uzantısı arasında paylaşılır.',
  'settings.mcpMethodOneClick': 'Tek tıkla kurulum',
  'settings.mcpInstructionCursor': 'Onay iletişim kutusuyla kurmak için "Cursor\'a Kur"a tıklayın veya bu JSON\'u {path} dosyasıyla birleştirin.',
  'settings.mcpDeeplinkInstallCursor': 'Cursor\'a Kur',
  'settings.mcpMethodJson': 'JSON yapılandırması',
  'settings.mcpInstructionCopilot': 'Komut Paletini ({shortcut}) açın, "MCP: Open User Configuration" komutunu çalıştırın ve bu JSON\'u birleştirin. Araçların görünmesi için Copilot Chat\'in Agent modunda olması gerekir.',
  'settings.mcpInstructionAntigravity': 'Antigravity\'de: Agent paneli "..." menüsü → MCP Servers → Manage MCP Servers → View raw config. Bu JSON\'u birleştirin.',
  'settings.mcpInstructionZed': 'Zed Ayarlarını ({shortcut}) açın ve bunu en üst düzey nesneyle birleştirin. Zed, "mcpServers" değil "context_servers" kullanır.',
  'settings.mcpInstructionWindsurf': '{path} dosyasını açın (veya Cascade → Configure içindeki MCPs simgesini kullanın) ve birleştirin:',
  'settings.mcpCopyAria': 'MCP yapılandırma parçacığını kopyala',
  'settings.mcpResolvingFailed': '# yollar çözümlenemedi, yukarıdaki hataya bakın',
  'settings.mcpLoadingPaths': '# yerel daemon\'dan kurulum yolları yükleniyor…',
  'settings.mcpCopied': 'Kopyalandı',
  'settings.mcpCopy': 'Kopyala',
  'settings.mcpCursorApproval': 'Cursor, yapılandırmayı yazmadan önce bir onay iletişim kutusu açar.',
  'settings.mcpCodexOneClickInstall': 'Codex\'e Kur',
  'settings.mcpCodexOneClickUninstall': 'Codex\'ten Kaldır',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI PATH üzerinde bulunamadı — Codex\'i kurun veya parçacığı manuel olarak yapıştırın.',
  'settings.mcpCodexInstallSuccess': 'Kuruldu. Yeni sunucuyu yüklemek için Codex\'i yeniden başlatın.',
  'settings.mcpCodexUninstallSuccess': 'Codex\'ten kaldırıldı.',
  'settings.mcpCodexBusy': 'Çalışıyor…',
  'settings.mcpCodexInstallError': 'İşlem başarısız oldu: {error}',
  'settings.mcpRestartNote': 'Yeni sunucuyu almak için istemcinizi yeniden başlatın.',
  'settings.mcpRestartDetail': 'Çoğu düzenleyici MCP sunucularını yalnızca başlangıçta yükler. Cursor / VS Code / Antigravity / Windsurf\'te tam bir yeniden başlatma yerine komut paletinden `Developer: Reload Window` komutunu çalıştırabilirsiniz. Zed ve Claude Code için kapatıp yeniden açmak gerekir.',
  'settings.mcpCapabilitiesTitle': 'Agent\'ınızın yapabilecekleri',
  'settings.mcpCapabilityRead': 'Bir projedeki herhangi bir dosyayı okuyun veya arayın (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Tek bir çağrıyla bir tasarım paketi çekin: giriş dosyası ile birlikte referans verdiği her CSS değişkeni, bileşen ve yazı tipi.',
  'settings.mcpCapabilityDefault': 'DANIA Studio\'da açık olan projeyi ve dosyayı varsayılan olarak kullanın; böylece hangi tasarım olduğunu yeniden belirtmeden "bunu uygulamamda oluştur" diyebilirsiniz.',
  'settings.mcpRunningNote': 'MCP araç çağrılarının başarılı olması için DANIA Studio\'ın çalışıyor olması gerekir. Kodlama agent\'ınızı DANIA Studio\'ı açmadan önce başlattıysanız, canlı daemon\'a ulaşabilmesi için agent\'ı yeniden başlatın.',
  'entry.tabDesigns': 'Tasarımlar',
  'entry.tabTemplates': 'Şablonlar',
  'entry.tabDesignSystems': 'Tasarım sistemleri',
  'entry.tabConnectors': 'Bağlayıcılar',
  'entry.openSettingsTitle': 'Ayarlar',
  'entry.openSettingsAria': 'Ayarları aç',
  'entry.discordLabel': 'Discord\'a Katıl',
  'entry.discordAria': 'DANIA Studio Discord\'una katılın',
  'entry.discordAriaWithOnline': 'DANIA Studio Discord\'una katılın - {online}',
  'entry.discordOnlineLabel': '{count} çevrimiçi',
  'entry.followXLabel': 'X\'te DANIA hesabını takip et',
  'entry.followThreadsLabel': 'Follow DANIA Studio on Threads',
  'entry.youtubeLabel': 'DANIA Studio on YouTube',
  'entry.followInstagramLabel': 'Instagram\'da @opendesign.ai hesabını takip et',
  'entry.followLinkedinLabel': 'LinkedIn\'de DANIA Studio hesabını takip et',
  'entry.followXiaohongshuLabel': 'Xiaohongshu\'da DANIA Studio hesabını takip et',
  'entry.resizeAria': 'Yan çubuğu yeniden boyutlandır',
  'entry.loadingWorkspace': 'Çalışma alanı yükleniyor…',
  'entry.useEverywhereTitle': 'Her yerde kullan',
  'entry.useEverywhereAria': '“Her yerde kullan” kılavuzunu aç (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'entry.workspaceTeamsTitle': 'Ekipler için Workspace — ekibinizin neye ihtiyacı olduğunu bize söyleyin',
  'entry.workspaceTeamsAria': 'Ekipler için Workspace sayfasını aç',
  'entry.navExpand': 'Kenar çubuğunu genişlet',
  'entry.navCollapse': 'Kenar çubuğunu daralt',
  'entry.navNewProject': 'Yeni proje',
  'entry.navHome': 'Ana sayfa',
  'entry.navProjects': 'Projeler',
  'entry.navTasks': 'Otomasyonlar',
  'entry.navPlugins': 'Plugin\'ler',
  'entry.navDesignSystems': 'Tasarım sistemleri',
  'entry.navBrands': 'Marka Kiti',
  'entry.navIntegrations': 'Entegrasyonlar',
  'workspaceTabs.project': 'Proje',
  'workspaceTabs.pluginDetails': 'Plugin ayrıntıları',
  'workspaceTabs.marketplace': 'Pazar Yeri',
  'homeHero.title': 'Bugün ne tasarlayacaksın?',
  'homeHero.startWithTemplate': 'Bir şablonla başla…',
  'homeHero.startBlankProject': '…ya da boş bir proje başlat',
  'homeHero.templatePicker.label': 'Şablon',
  'homeHero.templatePicker.searchPlaceholder': 'Şablon ara',
  'homeHero.templatePicker.projectTypes': 'Proje türleri',
  'homeHero.templatesScrollHint': 'Daha fazla şablon görmek için yukarı kaydırın',
  'homeHero.templatesCollapse': 'Şablonları daralt',
  'homeHero.subtitlePrefix': 'Yapay zekâ destekli tasarım stüdyonuz.',
  'homeHero.placeholder': 'Ne oluşturmak istediğinizi açıklayın…',
  'homeHero.placeholderActive': 'Örnek sorguyu düzenleyin veya kendinizinkini yazın…',
  'homeHero.carousel.hint': 'Dosya ekle, tasarım sistemini bağla ya da ne yapmak istediğini anlat',
  'homeHero.carousel.onePageBrief': 'Tek sayfalık proje özeti yaz',
  'homeHero.carousel.notesToDeck': 'Notlarımı bir sunuma dönüştür',
  'homeHero.carousel.signupFlow': 'Bir kayıt akışı taslağı oluştur',
  'homeHero.carousel.improveBrief': 'Mevcut bir proje özetini geliştir',
  'homeHero.carousel.loadingAnimation': 'Bir yükleme animasyonu oluştur',
  'homeHero.carousel.teamUpdateSlides': 'Ekip güncellemesi için slaytlar tasarla',
  'homeHero.carousel.ordersDashboard': 'Sipariş takibi için bir gösterge paneli prototipi yap',
  'homeHero.carousel.productDetail': 'Bir ürün detay sayfası düzenle',
  'homeHero.carousel.caseStudy': 'Bir vaka çalışması taslağı çıkar',
  'homeHero.carousel.landingIntro': 'Bir açılış sayfası için kısa bir giriş tasarla',
  'homeHero.carousel.pitchDeck': 'Yeni bir ürün için sunum destesi oluştur',
  'homeHero.carousel.appIdea': 'Bir uygulama fikrini anlat',
  'homeHero.carousel.landingLayout': 'Bir açılış sayfası düzeni çiz',
  'homeHero.skills': 'Skill\'ler',
  'homeHero.addMenu': 'Bağlam ekle',
  'homeHero.addPlugin': 'Eklenti ekle',
  'homeHero.addConnectors': 'Bağlayıcı ekle',
  'homeHero.addMcp': 'MCP sunucusu ekle',
  'homeHero.noPlugins': 'Yüklü eklenti yok',
  'homeHero.noMcp': 'MCP sunucusu yok',
  'homeHero.noConnectors': 'Bağlı bağlayıcı yok',
  'homeHero.applying': 'Uygulanıyor…',
  'homeHero.pluginTitle': 'Plugin: {title}',
  'homeHero.pluginPrefix': 'Plugin: {title}',
  'homeHero.skillPrefix': 'Skill: {title}',
  'homeHero.removePlugin': 'Plugin\'i kaldır',
  'homeHero.removePluginAria': '{title} plugin\'ini kaldır',
  'homeHero.clearActivePlugin': 'Etkin plugin\'i temizle',
  'homeHero.clearActiveSkill': 'Etkin skill\'i temizle',
  'homeHero.contextItemsResolved': '{n} bağlam öğesi çözümlendi',
  'homeHero.removeFile': 'Dosyayı kaldır',
  'homeHero.contextSearchResults': 'Bağlam arama sonuçları',
  'homeHero.contextSurfaces': 'Bağlam yüzeyleri',
  'homeHero.loadingContext': 'Bağlam yükleniyor…',
  'homeHero.noResults': '"{query}" için sonuç bulunamadı.',
  'homeHero.searchPrompt': 'Dosyalarda, plugin\'lerde, skill\'lerde, MCP sunucularında ve bağlayıcılarda arama yapın.',
  'homeHero.parameters': '{n} parametre',
  'homeHero.details': 'Ayrıntılar',
  'homeHero.toRun': 'çalıştırmak için',
  'homeHero.forNewLine': 'yeni satır için',
  'homeHero.run': 'Çalıştır',
  'homeHero.typeSomethingToRun': 'Çalıştırmak için bir şeyler yazın',
  'homeHero.promptExamples': 'Örnekler',
  'homeHero.footer.designSystem': 'Stil',
  'homeHero.footer.autoDesignSystem': 'Otomatik',
  'homeHero.footer.autoDesignSystemSummary': 'Geçerli istem için en uygun tasarım sistemini ve görsel stili otomatik eşler.',
  'homeHero.footer.ratio': 'Oran',
  'homeHero.footer.duration': 'Süre',
  'homeHero.footer.resolution': 'Çözünürlük',
  'homeHero.footer.speakerNotes': 'Notlar',
  'homeHero.footer.noSpeakerNotes': 'Not yok',
  'homeHero.footer.availableCount': '{n} mevcut',
  'homeHero.footer.noMatches': 'Eşleşme yok',
  'homeHero.moreShortcuts': 'Daha fazla',
  'homeHero.railAria': 'Bir proje kategorisi veya başlangıç kısayolu seçin',
  'homeHero.subTypeAria': 'Bir alt tür seçin',
  'homeHero.confirmReplaceTitle': 'Geçerli istem değiştirilsin mi?',
  'homeHero.confirmReplaceBody': '{title} kullanmak, girişte şu anda bulunan metni değiştirecek.',
  'homeHero.confirmReplace': 'Değiştir',
  'homeHero.chip.prototype': 'Prototip',
  'homeHero.chip.liveArtifact': 'Canlı çıktı',
  'homeHero.chip.deck': 'Sunum destesi',
  'homeHero.chip.image': 'Görsel',
  'homeHero.chip.video': 'Video',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.audio': 'Ses',
  'homeHero.chip.createBrandKit': 'Marka Kiti oluştur',
  'homeHero.chip.createPlugin': 'Plugin oluştur',
  'homeHero.chip.figma': 'Figma\'dan',
  'homeHero.chip.folder': 'Klasörden',
  'homeHero.chip.template': 'Şablondan',
  'homeHero.chip.liveArtifactHint': 'Canlı önizleyebileceğiniz etkileşimli bir HTML/CSS/JS çıktısı oluşturun.',
  'homeHero.chip.hyperframesHint': 'HTML tabanlı hareket oluşturun: altyazılar, sese tepki veren görseller, sahne geçişleri.',
  'homeHero.chip.createBrandKitHint': 'Bir web sitesinden marka kiti çıkarın, ardından herhangi bir sohbette uygulayın.',
  'homeHero.chip.createPluginHint': 'Yeniden kullanılabilir bir DANIA Studio plugin\'i oluşturun ve Plugin\'lerim\'e ekleyin.',
  'homeHero.chip.figmaHint': 'Bir Figma frame\'ini etkin tasarım sistemine taşıyın.',
  'homeHero.chip.folderHint': 'Mevcut bir yerel klasörü içe aktarın ve düzenlemeye devam edin.',
  'homeHero.chip.templateHint': 'Paketlenmiş bir şablonla başlayın.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'Mobile app',
  'homeHero.chip.document': 'Document',
  'homeHero.chip.prototypeDesc': 'Interactive app mockups',
  'homeHero.chip.wireframeDesc': 'Lo-fi screens & flows',
  'homeHero.chip.mobileDesc': 'iOS & Android screens',
  'homeHero.chip.deckDesc': 'Presentations & pitch decks',
  'homeHero.chip.documentDesc': 'Resumes, reports & PDFs',
  'homeHero.chip.imageDesc': 'Posters, graphics & art',
  'homeHero.chip.videoDesc': 'Clips, reels & promos',
  'homeHero.chip.audioDesc': 'Voiceovers, music & SFX',
  'homeHero.chip.hyperframesDesc': 'Motion graphics & loops',
  'homeHero.chip.liveArtifactDesc': 'Data-backed live dashboards',
  'homeHero.chip.createBrandKitDesc': 'Extract a brand design system',
  'homeHero.chip.prototypeNext': 'Open a chat that builds a high-fidelity, clickable web prototype you refine turn by turn.',
  'homeHero.chip.wireframeNext': 'Open a chat that sketches lo-fi screens and flows to validate structure first.',
  'homeHero.chip.mobileNext': 'Open a chat that lays out mobile screens for iOS and Android.',
  'homeHero.chip.deckNext': 'Open a chat that builds a slide deck you can present and export.',
  'homeHero.chip.documentNext': 'Open a chat that drafts a polished document — resume, report, or PDF.',
  'homeHero.chip.imageNext': 'Open a chat that generates on-brand images you can iterate on.',
  'homeHero.chip.videoNext': 'Open a chat that produces a short video you can refine.',
  'homeHero.chip.audioNext': 'Open a chat that creates voiceover, music, or sound effects.',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'Klasör',
  'workingDirPicker.homeTitle': 'Yerel depolamaya kaydedilir — klasör seçmek için tıklayın',
  'workingDirPicker.processing': 'İşleniyor…',
  'workingDirPicker.select': 'Yerel depolama',
  'workingDirPicker.clearAria': 'Çalışma dizinini temizle',
  'workingDirPicker.replaceFailed': 'Çalışma dizini değiştirilemedi',
  'workingDirPicker.unavailable': 'Klasör seçici bu derlemede kullanılamıyor. Klasör seçmek için masaüstü uygulamasını çalıştırın.',
  'workingDirPicker.openUnavailable': 'Klasörü göstermek için bu projeyi masaüstü uygulamasında açın.',
  'workingDirPicker.openFailed': 'Bu klasör gösterilemedi',
  'workingDirPicker.showInFileManager': 'Dosya yöneticisinde göster',
  'workingDirPicker.replace': 'Klasör seç…',
  'workingDirPicker.recent': 'Son dizinler',
  'workingDirPicker.defaultLabel': 'Yerel depolama',
  'handoff.toTarget': '{target} öğesine devret',
  'handoff.openInTarget': '{target} içinde aç',
  'handoff.openAction': 'Aç',
  'handoff.menuTitle': 'Hangi düzenleyicide açılsın?',
  'handoff.action': 'Devret',
  'handoff.fallbackTitle': '$PATH üzerinde düzenleyici bulunamadı - {target} içinde açılır',
  'handoff.chooseTargetAria': 'Devretme hedefini seçin',
  'handoff.optionsAria': 'Devretme seçenekleri',
  'handoff.editorSection': 'Düzenleyiciyle aç',
  'handoff.cliSection': 'CLI için kopyala',
  'handoff.clickOpen': 'Açmak için tıklayın',
  'handoff.framework': 'Kod çerçevesi',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'saf JavaScript, HTML ve CSS',
  'handoff.amrWebsite': 'DANIA Studio web sitesini aç',
  'handoff.copyPrompt': 'İstemi kopyala',
  'handoff.copyPromptForTarget': '{target} için istemi kopyala',
  'handoff.copied': 'Kopyalandı',
  'handoff.projectPathUnavailable': 'Proje yolu hâlâ yükleniyor. Birazdan tekrar deneyin.',
  'handoff.copyFailed': 'Pano yazma işlemi engellendi. Birazdan tekrar deneyin.',
  'handoff.promptIntro': 'Bu yerel DANIA Studio proje klasöründen devam edin:',
  'handoff.promptTarget': 'Hedef',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': '{cli} içinde devralıyorsunuz. Lütfen:',
  'handoff.promptReadFiles': 'Önce bu dizine girin veya okuyun. Varsa DESIGN.md, README, mevcut HTML/CSS/JS, varlıklar ve package.json dosyalarına öncelik verin.',
  'handoff.promptKeepDesign': 'Mevcut görsel tasarımı, düzeni, etkileşimleri ve varlıkları koruyun. Bir planla yetinmeyin.',
  'handoff.promptProduceCode': 'Gerçek, çalıştırılabilir {framework} kodu oluşturun veya değiştirin. Projede zaten daha net bir teknoloji yığını varsa, çakışmayı belirtin ve sonucu çalıştırılabilir tutun.',
  'handoff.promptVerify': 'Çalıştırma, önizleme ve doğrulama komutlarını bana bildirerek tamamlayın.',
  'handoff.promptCommandHint': 'Proje dizininden başlamak için şunu kullanın:',
  'handoff.promptProject': 'Proje',
  'handoff.promptProjectId': 'Proje kimliği',
  'handoff.notInstalled': 'Yüklü değil',
  'handoff.notDetectedTitle': '{target} - $PATH üzerinde algılanmadı',
  'designSystemPicker.select': 'Tasarım sistemi seçin',
  'designSystemPicker.loading': 'Tasarım sistemleri yükleniyor…',
  'designSystemPicker.searchPlaceholder': 'Tasarım sistemlerinde ara (başlık / kategori / özet)',
  'designSystemPicker.searchCompactPlaceholder': 'Tasarım sistemlerinde ara',
  'designSystemPicker.noneTitle': 'Tasarım sistemi yok',
  'designSystemPicker.noneSummary': 'Modelin serbestçe seçmesine izin ver',
  'designSystemPicker.empty': 'Eşleşen tasarım sistemi yok',
  'designSystemPicker.openPreview': 'Önizlemeyi aç',
  'designSystemPicker.loadingPreview': 'Önizleme yükleniyor…',
  'designSystemPicker.noPreview': 'Önizleme sayfası yok. Tam önizlemeyi görüntülemek için Tasarım Sistemleri\'ni açın.',
  'designSystemPicker.previewHint': 'Önizlemek için bir tasarım sisteminin üzerine gelin',
  'designSystemPicker.fullscreenAria': '{title} tam ekran önizleme',
  'designSystemPicker.closeFullscreen': 'Tam ekran önizlemeyi kapat',
  'designSystemPicker.closeEsc': 'Kapat (Esc)',
  'designSystemPicker.previewFrameTitle': '{title} önizleme',
  'designSystemPicker.fullscreenFrameTitle': '{title} tam ekran önizleme',
  'recentProjects.title': 'Son projeler',
  'recentProjects.viewAll': 'Tümünü gör',
  'recentProjects.empty': 'Henüz proje yok — başlatmak için bir komut yazın.',
  'pluginsHome.title': 'Topluluk',
  'pluginsHome.subtitle': 'Bu çalışma zamanıyla birlikte gelen, kullanıma hazır DANIA Studio iş akışları. Başlangıç istemi yüklemek için birini seçin veya daha fazlası için kayıt defterine göz atın.',
  'pluginsHome.browseRegistry': 'Kayıt defterine göz at',
  'pluginsHome.count': '{total} öğeden {filtered} tanesi',
  'pluginsHome.loadingCatalog': 'Katalog yükleniyor…',
  'pluginsHome.emptyCatalog': 'Katalog boş. Paketlenmiş eklentiler DANIA Studio ile birlikte gelir ve buraya otomatik olarak görünmelidir — bu durum devam ederse daemon\'u yeniden başlatmayı deneyin.',
  'pluginsHome.emptyFiltered': 'Geçerli filtrelerle eşleşen eklenti yok.',
  'pluginsHome.clearFilters': 'Filtreleri temizle',
  'pluginsHome.modeAria': 'Eklenti modu',
  'pluginsHome.featured': 'Kaydedildi',
  'pluginsHome.totalInCatalog': 'Katalogda {n}',
  'pluginsHome.categoryFilterAria': 'Kategori filtresi',
  'pluginsHome.subcategoryFilterAria': '{label} alt kategori filtresi',
  'pluginsHome.allCategory': 'Tüm {label}',
  'pluginsHome.searchPlaceholder': 'Eklenti ara…',
  'pluginsHome.searchAria': 'Eklenti ara',
  'pluginsHome.clearSearch': 'Aramayı temizle',
  'pluginsHome.sortAria': 'Sıralama düzeni',
  'pluginsHome.sortHot': 'Popüler',
  'pluginsHome.sortNewest': 'En yeni',
  'pluginsHome.facet.import': 'İçe aktar',
  'pluginsHome.facet.create': 'Oluştur',
  'pluginsHome.facet.export': 'Dışa aktar',
  'pluginsHome.facet.share': 'Paylaş',
  'pluginsHome.facet.deploy': 'Dağıt',
  'pluginsHome.facet.refine': 'İyileştir',
  'pluginsHome.facet.extend': 'Genişlet',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Kod / klasör',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Ekran görüntüsü',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Slaytlar',
  'pluginsHome.facet.publicLink': 'Herkese açık bağlantı',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'Panolar',
  'pluginsHome.subfacet.app-prototypes': 'Uygulamalar',
  'pluginsHome.subfacet.landing-marketing': 'Landing / pazarlama',
  'pluginsHome.subfacet.developer-tools': 'Geliştirici araçları',
  'pluginsHome.subfacet.docs-reports': 'Doküman / raporlar',
  'pluginsHome.subfacet.brand-design': 'Marka / tasarım',
  'pluginsHome.subfacet.pitch-business': 'Sunum / iş',
  'pluginsHome.subfacet.course-training': 'Kurs / eğitim',
  'pluginsHome.subfacet.reports-briefings': 'Raporlar / brifingler',
  'pluginsHome.subfacet.product-sales': 'Ürün / satış',
  'pluginsHome.subfacet.engineering-talks': 'Teknik konuşmalar',
  'pluginsHome.subfacet.creative-decks': 'Yaratıcı sunumlar',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / ürün maketleri',
  'pluginsHome.subfacet.brand-visuals': 'Marka / logo',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboardlar',
  'pluginsHome.subfacet.social-content': 'Sosyal / içerik',
  'pluginsHome.subfacet.avatar-portrait': 'Avatar / portre',
  'pluginsHome.subfacet.illustration-style': 'İllüstrasyon / stil',
  'pluginsHome.subfacet.motion-effects': 'Hareket / efektler',
  'pluginsHome.subfacet.social-short-form': 'Sosyal / kısa video',
  'pluginsHome.subfacet.marketing-product': 'Pazarlama / ürün',
  'pluginsHome.subfacet.data-explainers': 'Veri / açıklamalar',
  'pluginsHome.subfacet.cinematic-story': 'Sinematik / hikâye',
  'pluginsView.lede': 'Yüklü iş akışlarına göz atın, kayıt defteri girdilerini keşfedin, kaynakları yönetin ve eklentileri ekip dağıtımı için hazırlayın.',
  'pluginsView.importPlugin': 'Eklenti içe aktar',
  'pluginsView.agentContext': 'Agent bağlamı',
  'pluginsView.summaryAria': 'Eklenti özeti',
  'pluginsView.areasAria': 'Eklenti alanları',
  'pluginsView.loading': 'Eklentiler yükleniyor…',
  'pluginsView.tab.installed': 'Yüklü',
  'pluginsView.tab.available': 'Mevcut',
  'pluginsView.tab.sources': 'Kaynaklar',
  'pluginsView.tab.team': 'Ekip',
  'pluginsView.tabHint.installed': 'Eklentileriniz',
  'pluginsView.tabHint.available': 'Kaynaklardan',
  'pluginsView.tabHint.sources': 'Kataloglar',
  'pluginsView.tabHint.team': 'Kurumsal',
  'pluginsView.installedTitle': 'Yüklü eklentiler',
  'pluginsView.installedSubtitle': 'Pazar yeri kaynaklarından içe aktardığınız veya yüklediğiniz eklentiler.',
  'pluginsView.installedEmpty': 'Henüz yüklü kullanıcı eklentisi yok. Oluştur / İçe aktar seçeneğini kullanın ya da Mevcut bir girdiyi yükleyin.',
  'pluginsView.availableTitle': 'Kaynaklardan mevcut',
  'pluginsView.availableSubtitle': 'Yapılandırılmış pazar yerlerinden keşfedilen katalog girdileri.',
  'pluginsView.availableFiltersAria': 'Mevcut eklenti filtreleri',
  'pluginsView.searchAvailableAria': 'Mevcut eklentilerde ara',
  'pluginsView.searchAvailablePlaceholder': 'Mevcut eklentilerde ara',
  'pluginsView.clearAvailableSearch': 'Mevcut eklenti aramasını temizle',
  'pluginsView.source': 'Kaynak',
  'pluginsView.availableEmptyInstalled': 'Henüz kullanılabilir giriş yok. Yüklü katalog girişleri Kullanılabilir listesinden kaldırılır; birini kaldırarak tekrar kullanılabilir hale getirin.',
  'pluginsView.availableEmptyFiltered': 'Filtrelerinizle eşleşen kullanılabilir giriş yok.',
  'pluginsView.availableEmptyNoSources': 'Henüz kullanılabilir giriş yok. Kaynaklar sekmesinden bir kaynak ekleyin.',
  'pluginsView.installing': 'Yükleniyor…',
  'pluginsView.install': 'Yükle',
  'pluginsView.sourcesTitle': 'Registry kaynakları',
  'pluginsView.sourcesSubtitle': 'Kullanılabilir plugin girişlerini besleyen marketplace katalogları.',
  'pluginsView.sourceUrl': 'Kaynak URL',
  'pluginsView.defaultTrust': 'Varsayılan güven',
  'pluginsView.trust.restricted': 'Kısıtlı',
  'pluginsView.trust.trusted': 'Güvenilir',
  'pluginsView.trust.official': 'Resmi',
  'pluginsView.adding': 'Ekleniyor…',
  'pluginsView.addSource': 'Kaynak ekle',
  'pluginsView.sourcesEmpty': 'Henüz yapılandırılmış registry kaynağı yok.',
  'pluginsView.pluginsCount': '{n} plugin',
  'pluginsView.catalogVersion': 'katalog v{version}',
  'pluginsView.trustFor': '{name} için güven',
  'pluginsView.refreshing': 'Yenileniyor…',
  'pluginsView.removing': 'Kaldırılıyor…',
  'pluginsView.teamTitle': 'Özel ekip marketplace\'leri',
  'pluginsView.teamBody': 'Bu alan kurumsal ve ekip katalogları, özel güven politikaları ve paylaşılan plugin yaşam döngüsü kontrolleri için ayrılmıştır.',
  'pluginCard.details': 'Ayrıntılar',
  'pluginCard.use': 'Kullan',
  'pluginCard.useWithQuery': 'Sorgu ile kullan',
  'pluginCard.applying': 'Uygulanıyor…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'Remix yapiliyor…',
  'pluginCard.duplicateFailed': 'Bu sablon remixlenemedi.',
  'pluginCard.saved': 'Kaydedildi',
  'pluginCard.publish': 'Yayımla',
  'pluginCard.contribute': 'Katkıda bulun',
  'pluginCard.starting': 'Başlatılıyor…',
  'pluginCard.detailsAria': '{title} için ayrıntıları görüntüle',
  'pluginCard.chooseUseAria': '{title} öğesini nasıl kullanacağınızı seçin',
  'pluginCard.useOptionsAria': '{title} için kullanım seçenekleri',
  'pluginCard.duplicateAria': '{title} ogesini yeni proje olarak remixle',
  'pluginCard.saveAria': '{title} öğesini kaydet',
  'pluginCard.savedAria': '{title} kaydedildi',
  'pluginCard.shareAria': '{title} öğesini paylaş',
  'pluginCard.publishAria': '{title} öğesini GitHub deposu olarak yayımla',
  'pluginCard.publishTitle': 'Plugin\'i GitHub deposu olarak yayımla',
  'pluginCard.contributeAria': '{title} öğesini DANIA Studio\'a katkı olarak ekle',
  'pluginCard.contributeTitle': 'Plugin\'i pull request ile DANIA Studio\'a katkı olarak ekle',
  'skillPluginCandidate.createForMe': 'Eklenti/şablon oluştur',
  'skillPluginCandidate.contributeToMain': 'open-design\'e katkıda bulun',
  'skillPluginCandidate.repoDescription': 'Bu depo plugin olarak çalışabilecek gibi görünüyor.',
  'integrations.kicker': 'Entegrasyon',
  'integrations.lede': 'Harici sistemleri bağlayın, MCP araçlarını agent döngünüze dahil edin ve DANIA Studio\'ı diğer IDE\'ler, betikler ve otomasyonlardan kullanın.',
  'integrations.agentReady': 'Agent\'a hazır',
  'integrations.areasAria': 'Entegrasyon alanları',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Beceriler',
  'integrations.tabHint.mcp': 'Harici araçlar',
  'integrations.tabHint.connectors': 'Hesaplar ve API\'ler',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Skills entegrasyonları',
  'integrations.skillsBody': 'Skill düzeyinde entegrasyon yönetimi başka bir daldan taşınıyor. Bu sekme, MCP, Connectors ve gelecekteki Skills kurulumunun aynı Entegrasyon rotasında yer alması için ayrılmıştır.',
  'mcpClient.title': 'Harici MCP sunucuları',
  'mcpClient.subtitle': 'Kodlama agent\'ınız için üçüncü taraf araçlar.',
  'mcpClient.addServer': 'Sunucu ekle',
  'mcpClient.emptyTitle': 'Yapılandırılmış MCP sunucusu yok.',
  'mcpClient.emptyBody': 'Başlamak için "Sunucu ekle"ye tıklayın — bir şablon seçin (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) ya da özel bir stdio / HTTP sunucusu kurun.',
  'mcpClient.saveChanges': 'Değişiklikleri kaydet',
  'mcpClient.storedAt': 'Şurada saklanıyor:',
  'mcpClient.daemonError': 'Yerel daemon\'a ulaşılamadı. DANIA Studio\'ın çalıştığından emin olun, ardından bu paneli yeniden açın.',
  'mcpClient.saveFailed': 'Kaydetme başarısız oldu. Daemon\'ın çalıştığını kontrol edip tekrar deneyin.',
  'useEverywhere.modalAria': 'DANIA Studio\'ı her yerde kullanın',
  'useEverywhere.modalTitle': 'DANIA Studio\'ı her yerde kullanın',
  'useEverywhere.modalSubtitle': 'DANIA Studio\'ı herhangi bir IDE\'ye, Agent\'a veya betiğe bırakın — CLI, HTTP, MCP ve Beceriler. Her şeyi kurmak için "Bir agent için kılavuzu kopyala"yı kullanın ve Claude Code, Codex, Cursor, openclaw veya hermes\'e yapıştırın.',
  'useEverywhere.closeAria': 'Her yerde kullan\'ı kapat',
  'useEverywhere.closeTitle': 'Kapat (Esc)',
  'useEverywhere.tabsAria': 'Entegrasyon yüzeyleri',
  'useEverywhere.footStrong': 'Tek tıkla devir.',
  'useEverywhere.footBody': 'Agent\'ınızın hemen üzerinde işlem yapabileceği yapılandırılmış bir markdown kılavuzu kopyalar — yükleyin, doğrulayın ve kullanın.',
  'useEverywhere.configureMcp': 'MCP sunucusunu yapılandır',
  'useEverywhere.copyGuide': 'Bir agent için kılavuzu kopyala',
  'useEverywhere.copy': 'Kopyala',
  'useEverywhere.copied': 'Kopyalandı',
  'useEverywhere.copyFailed': 'Kopyalama başarısız',
  'useEverywhere.copySnippetAria': 'Parçacığı kopyala: {label}',
  'useEverywhere.section.overview.tab': 'Genel bakış',
  'useEverywhere.section.overview.heading': 'DANIA Studio, agent\'ınızın çalıştığı her yerde çalışır',
  'useEverywhere.section.overview.intro': 'DANIA Studio bir pencereden fazlasıdır — yerel ayrıcalıklı bir daemon (`od`) ile birlikte bir Beceriler + Tasarım Sistemleri + Atoms kayıt defteridir. Makinenizde çalışmaya başladığında, herhangi bir kod agent\'ı (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, kendi betiğiniz) dört değiştirilebilir yüzey aracılığıyla üretimleri yönetebilir, projeleri inceleyebilir ve tasarım çıktıları üretebilir.',
  'useEverywhere.section.overview.bullet1': 'CLI — başsız betikler, CI ve kabuk otomasyonu için `od <command>`.',
  'useEverywhere.section.overview.bullet2': 'MCP sunucusu — DANIA Studio\'ı bir Model Context Protocol sunucusu olarak bağlar, böylece MCP destekli herhangi bir agent becerileri listeleyebilir, senaryoları çalıştırabilir ve çıktıları okuyabilir.',
  'useEverywhere.section.overview.bullet3': 'HTTP API — `http://127.0.0.1:7456/api/*` REST + SSE uç noktaları; web arayüzünün kullandığı aynı yüzey.',
  'useEverywhere.section.overview.bullet4': 'Beceriler — PATH\'inizde zaten bulunan herhangi bir agent\'ın DANIA Studio olmadan çağırabileceği eklenebilir `SKILL.md` paketleri (Claude uyumlu).',
  'useEverywhere.section.overview.bullet5': 'Standart çıktılar — daemon başlamadan önce Beceriler\'den, paketlenmiş varsayılan eklentilerden ve topluluk eklenti örneklerinden gerçek HTML projeleri oluşturun.',
  'useEverywhere.section.overview.snippet1': 'Daemon\'ı (ve web arayüzünü) yerel olarak başlatın',
  'useEverywhere.section.overview.snippet2': 'Erişilebilir olduğunu doğrulayın',
  'useEverywhere.section.overview.snippet3': 'Önyüklemeden önce standart yapıtları içe aktarın',
  'useEverywhere.section.overview.footer': 'Daemon varsayılan olarak `./.od/` dizinine (proje-yerel) yazar. Verileri projeler arasında paylaşmak için `OD_DATA_DIR=~/.open-design` ayarlayın.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'DANIA Studio\'ı herhangi bir kabuktan yönetin',
  'useEverywhere.section.cli.intro': '`od` ikili dosyası daemon ile birlikte gelir ve Claude Code / Codex bir üretim çalıştırdığında kullandığı ile aynı ikili dosyadır. Çoğu alt komut, yerel daemon\'a POST gönderen ince istemcilerdir; bu nedenle ister `pnpm tools-dev` ile ister paketlenmiş bir uygulama olarak başlatın aynı şekilde çalışırlar.',
  'useEverywhere.section.cli.bullet1': '`od` (bağımsız değişken yok) — daemon\'u başlatır ve web arayüzünü açar.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — birleşik medya protokolü aracılığıyla görüntü / video / ses baytları üretir.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — bir komut + beceriden proje çalıştırması başlatır.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — topluluk eklentilerini yükler ve uygular.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — yerel olarak nelerin mevcut olduğunu inceler.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — daemon sağlığını doğrular ve PATH\'inizdeki agent CLI\'larını algılar.',
  'useEverywhere.section.cli.snippet1': 'Bir görsel oluştur (yapılandırılmış medya sağlayıcısına devreder)',
  'useEverywhere.section.cli.snippet2': 'Bir senaryo eklentisini başsız çalıştır ve olayları JSON satırları olarak akıt',
  'useEverywhere.section.cli.snippet3': 'Yerel olarak mevcut skill\'leri ve tasarım sistemlerini listele',
  'useEverywhere.section.cli.snippet4': 'Tohumlanmış yapıtları CLI üzerinden kontrol et',
  'useEverywhere.section.cli.snippet5': 'Ortamı + algılanan agent\'ları doğrula (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Tüm alt komutlar, belirli bir çalışan daemon\'u hedeflemek için `--daemon-url http://127.0.0.1:<port>` kabul eder — testler için yalıtılmış ikinci bir örnek çalıştırırken kullanışlıdır.',
  'useEverywhere.section.mcp.tab': 'MCP sunucusu',
  'useEverywhere.section.mcp.heading': 'DANIA Studio\'ı herhangi bir kodlama agent\'ına MCP sunucusu olarak sun',
  'useEverywhere.section.mcp.intro': 'DANIA Studio, MCP destekli herhangi bir istemcinin — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — DANIA Studio araçlarını (becerileri listele, önizlemeleri oluştur, medya üret, eklentileri çalıştır) manuel olarak kabuk açmadan keşfetmesini sağlayan bir Model Context Protocol sunucusu (`od mcp`) ile gelir. Daemon, her büyük istemci için `GET /api/mcp/install-info` aracılığıyla yapıştırmaya hazır bir kurulum parçacığı yayınlar.',
  'useEverywhere.section.mcp.bullet1': 'Stdio aktarımı — ek port yok, istemci `od mcp`\'yi doğrudan başlatır.',
  'useEverywhere.section.mcp.bullet2': 'Bir yan bileşen (sidecar) olarak başlatıldığında, yerel IPC durum soketi aracılığıyla canlı daemon URL\'sini otomatik olarak keşfeder.',
  'useEverywhere.section.mcp.bullet3': 'Düz kurulumlar için `--daemon-url http://127.0.0.1:<port>` adresine geri döner, böylece MCP süreci her zaman çalışan bir daemon bulur.',
  'useEverywhere.section.mcp.bullet4': '`OD_DATA_DIR` değerini sabitler, böylece oluşturulan MCP süreci daemon\'ın zaten kullandığı yere yazar (paketlenmiş macOS uygulama paketlerinde EPERM\'i önler).',
  'useEverywhere.section.mcp.snippet1': 'Genel MCP istemci yapılandırması (Cursor, Claude Code, Codex, … içinde çalışır)',
  'useEverywhere.section.mcp.snippet2': 'Veya: kurulumunuza uyarlanmış parçacığı daemon\'dan isteyin',
  'useEverywhere.section.mcp.snippet3': 'Canlı yapıt MCP varyantı (panoları okuyun ve yenileyin)',
  'useEverywhere.section.mcp.footer': 'DANIA Studio uygulamasında, JSON\'u elle düzenlemek yerine istemciye özel bir kurulum komutu (Cursor, Claude Code, Antigravity, VS Code) kopyalamak için Ayarlar → Entegrasyonlar\'ı açın.',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': 'Web arayüzünün kullandığı ile aynı REST + SSE yüzeyi',
  'useEverywhere.section.http.intro': 'Yerel daemon, `http://127.0.0.1:7456` adresinde bir HTTP API sunar (port yapılandırılabilir). Web arayüzünün çağırdığı her uç nokta betikleriniz için de kullanılabilir. Akış uç noktaları (sohbet turları, proje çalıştırmaları) `@open-design/contracts` içindeki sözleşme türleriyle Server-Sent Events yayar.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — daemon canlılığı.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` ve `GET /api/design-systems` — mevcut kayıt defterleri.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` ve `POST /api/projects` — projeleri listeler ve oluşturur (POST, proje + ilk konuşmayı döndürür).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — bir konuşma için agent olaylarının SSE akışı.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — yüklü bir eklentiyi bağlar ve oluşturulan örnek sorgusunu + girdilerini alır.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — PATH\'inizde algılanan kod agent\'ı CLI\'ları.',
  'useEverywhere.section.http.snippet1': 'Yüklü skill\'leri listele (agent bunları şablon olarak kullanacak)',
  'useEverywhere.section.http.snippet2': 'Bir komut isteminden proje oluştur (tam sunucu tarafı akış)',
  'useEverywhere.section.http.snippet3': 'Bir sohbet turunu akışla aktar (SSE — her satır JSON-Lines uyumludur)',
  'useEverywhere.section.http.footer': 'Her istek/yanıt için saf TypeScript türleri `@open-design/contracts` içinde bulunur — bir oluşturucu bağlamadan tam otomatik tamamlama için bunları betiğinize aktarın.',
  'useEverywhere.section.skills.tab': 'Skill\'ler ve başsız',
  'useEverywhere.section.skills.heading': 'Herhangi bir agent için eklenebilir Beceriler — DANIA Studio çalışmıyor olsa bile',
  'useEverywhere.section.skills.intro': 'Bir Beceri, Claude uyumlu bir `SKILL.md` (YAML ön bilgisi + gövde) içeren bir dizindir. DANIA Studio, formatı `od:` ad alanıyla (`mode`, `preview`, `design_system`, `inputs`, …) genişletir, böylece aynı çıktı hem DANIA Studio içinde hem de Claude Code, Codex, openclaw veya hermes gibi sade bir agent tarafından kullanılabilir. Keşif, projelerin kendi becerilerini geçersiz kılabilmesi için bir öncelik zincirini izler.',
  'useEverywhere.section.skills.bullet1': 'Keşif: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (proje kazanır).',
  'useEverywhere.section.skills.bullet2': 'Bir skill\'i kopyalamadan paylaşmak için onu birden çok projeye sembolik bağlantı (symlink) ile bağlayın.',
  'useEverywhere.section.skills.bullet3': 'Her skill; konektörler, atomlar, tasarım sistemi gereksinimleri ve galeri için bir `preview` örnek çıktısı bildirebilir.',
  'useEverywhere.section.skills.bullet4': 'Başsız: PATH\'inde `od` bulunan bir agent `od skills list` çağırıp herhangi bir skill\'i çalıştırabilir; salt okunur akışlar için daemon isteğe bağlıdır.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects`, aynı yapıt şeklini varsayılan eklenti örnekleri ve topluluk eklenti örnekleriyle çalıştırır, ardından ortaya çıkan `index.html` projelerini yeniden kullanılabilir test verisi olarak saklar.',
  'useEverywhere.section.skills.snippet1': 'Minimal SKILL.md (Claude uyumlu ön bilgi + DANIA Studio ekstraları)',
  'useEverywhere.section.skills.snippet2': 'Paylaşılan bir skill\'i bir projeye sembolik bağlantı ile bağla (cc-switch tarzı)',
  'useEverywhere.section.skills.snippet3': 'Başsız: daemon\'ın şu anda gördüğü skill\'leri listele',
  'useEverywhere.section.skills.snippet4': 'Başsız yapıt fikstür paketi',
  'useEverywhere.section.skills.footer': 'Spesifikasyon: `docs/skills-protocol.md` ve `docs/agent-adapters.md`, tüm adaptör yüzeyini (Claude Code, Codex, Cursor, MCP destekli agent\'lar, BYOK API yedeği) ve adaptör başına skill enjeksiyon stratejilerini kapsar.',
  'tasks.kicker': 'Otomasyon çalışma alanı',
  'tasks.comingSoon': 'Yakında',
  'tasks.lede': 'Otomasyonlar, komut istemlerini kalıcı işe dönüştürür: Orbit onları çalıştırır, rutinler onları saklar, zamanlamalar ne zaman tetikleneceklerine karar verir ve canlı yapıtlar neyin değiştiğini gösterir.',
  'tasks.newAutomation': 'Yeni otomasyon',
  'tasks.previewNote': 'Yalnızca önizleme yüzeyi. Orbit ayarları bugün kullanılabilir; rutinler, zamanlamalar ve canlı yapıt bağlantıları arka uç dalları birleştikçe gelecek.',
  'tasks.primitivesAria': 'Otomasyon ilkelleri',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Uzun süre çalışan veya yinelenen agent işleri için kalıcı bir çalışma zamanı.',
  'tasks.primitive.orbit.enabled': 'Günlük özet etkin',
  'tasks.primitive.orbit.manualOnly': 'Yalnızca manuel',
  'tasks.primitive.routines.title': 'Rutinler',
  'tasks.primitive.routines.body': 'Tek bir sohbet sona erdikten sonra da varlığını sürdüren kalıcı görev tanımları.',
  'tasks.primitive.routines.meta': 'Ürün kabuğu hazır',
  'tasks.primitive.schedules.title': 'Zamanlamalar',
  'tasks.primitive.schedules.body': 'Bir rutinin ne zaman çalışması gerektiğine karar veren zaman veya olay tetikleyicileri.',
  'tasks.primitive.schedules.meta': 'Dal beklemede',
  'tasks.primitive.liveArtifacts.title': 'Canlı yapıtlar',
  'tasks.primitive.liveArtifacts.body': 'Bir agent çalışırken güncellenmeye devam eden raporlar ve notlar.',
  'tasks.primitive.liveArtifacts.meta': 'Önizleme modeli',
  'tasks.listAria': 'Otomasyon listesi',
  'tasks.routinesAndRuns': '{n} rutin ve çalıştırma',
  'tasks.filtersAria': 'Otomasyon filtreleri',
  'tasks.filter.scheduled': 'Zamanlanmış',
  'tasks.filter.running': 'Çalışıyor',
  'tasks.filter.done': 'Tamamlandı',
  'tasks.configurationAria': 'Otomasyon yapılandırması',
  'tasks.slot.trigger': 'Tetikleyici',
  'tasks.slot.pattern': 'Desen',
  'tasks.slot.runtime': 'Çalışma zamanı',
  'tasks.slot.output': 'Çıktı',
  'tasks.liveArtifact': 'Canlı yapıt',
  'tasks.viewProgress': 'İlerlemeyi görüntüle',
  'tasks.pause': 'Duraklat',
  'tasks.runNow': 'Şimdi çalıştır',
  'tasks.openArtifact': 'Yapıtı aç',
  'tasks.status.dailyAt': 'Günlük · {time}',
  'tasks.status.pausedManual': 'Duraklatıldı · yalnızca manuel',
  'tasks.sample.orbit.title': 'Orbit Daily connector özeti',
  'tasks.sample.orbit.metaEnabled': 'Connector özeti zamanlandı',
  'tasks.sample.orbit.metaDisabled': 'Etkinleştirmek için Orbit ayarlarını aç',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · canlı çıktı',
  'tasks.sample.orbit.previewDisabled': 'Zamanlanmış çalıştırma yok',
  'tasks.sample.orbit.triggerEnabled': 'Zamanlama · her gün {time}',
  'tasks.sample.orbit.triggerDisabled': 'Manuel · talep üzerine çalıştır',
  'tasks.sample.orbit.pattern': 'Rutin · bağlayıcı özeti',
  'tasks.sample.orbit.runtime': 'Orbit · daemon tarafından zamanlanmış',
  'tasks.sample.orbit.output': 'Canlı çıktı · yenilenebilir rapor',
  'tasks.sample.orbit.artifactMetaEnabled': 'Her çalıştırmadan sonra yenilenir',
  'tasks.sample.orbit.artifactMetaDisabled': 'Zamanlama bekleniyor',
  'tasks.sample.orbit.body1': '# Orbit Daily etkinlik özeti',
  'tasks.sample.orbit.body2': 'Bağlayıcılar kontrol edildi · başarılar, atlamalar ve hatalar',
  'tasks.sample.orbit.body3': 'Öne çıkanlar, yenilenebilir bir canlı yapıta dönüşür.',
  'tasks.sample.mcp.title': 'MCP alternatifleri araştırması',
  'tasks.sample.mcp.status': 'Orbit\'te çalışıyor · 2sa 14dk',
  'tasks.sample.mcp.meta': '14 / 30 kaynak işlendi',
  'tasks.sample.mcp.preview': 'research_notes.md · canlı',
  'tasks.sample.mcp.trigger': 'Manuel · tek seferlik',
  'tasks.sample.mcp.pattern': 'Derin araştırma istemi',
  'tasks.sample.mcp.runtime': 'Uzak · kalıcı',
  'tasks.sample.mcp.output': 'Canlı rapor · otomatik güncellenen',
  'tasks.sample.mcp.artifactMeta': '12sn önce güncellendi',
  'tasks.sample.mcp.body1': '# MCP alternatifleri - ara bulgular',
  'tasks.sample.mcp.body2': '14 kaynak incelendi · 3 aday seçildi',
  'tasks.sample.mcp.body3': '## Kısa liste',
  'tasks.sample.mcp.body4': '- JSON-RPC üzerinden araç çağrısı şemaları...',
  'tasks.sample.mcp.body5': '- gRPC tabanlı agent protokolleri...',
  'tasks.sample.weekly.title': 'Haftalık ekip özeti',
  'tasks.sample.weekly.status': 'Sonraki: Pzt 09:00',
  'tasks.sample.weekly.meta': 'Ekip haftalık belgesini günceller',
  'tasks.sample.weekly.preview': 'team_weekly.md · sonraki çıktı',
  'tasks.sample.weekly.trigger': 'Zamanlama · haftalık',
  'tasks.sample.weekly.pattern': 'Rutin · ekip özeti',
  'tasks.sample.weekly.runtime': 'Uzak · yinelenen',
  'tasks.sample.weekly.output': 'Canlı çıktı · markdown',
  'tasks.sample.weekly.artifactMeta': 'Son güncelleme 4g önce',
  'tasks.sample.weekly.body1': '# Ekip haftalık',
  'tasks.sample.weekly.body2': '## Devam edenler',
  'tasks.sample.weekly.body3': '- Tasarım sistemi entegrasyon turu',
  'tasks.sample.weekly.body4': '- Connector kalite taraması',
  'tasks.sample.weekly.body5': '## Riskler',
  'tasks.sample.pr.title': 'PR inceleme hatırlatıcısı',
  'tasks.sample.pr.status': 'Yeni PR\'da · 23 dk önce tetiklendi',
  'tasks.sample.pr.meta': 'Slack DM gönderir',
  'tasks.sample.pr.preview': 'Son teslimat başarılı oldu',
  'tasks.sample.pr.trigger': 'Olay · yeni PR',
  'tasks.sample.pr.pattern': 'Rutin · bildirim',
  'tasks.sample.pr.runtime': 'Yerel · hızlı çalıştırma',
  'tasks.sample.pr.output': 'Mesaj · Slack DM',
  'tasks.sample.pr.artifactMeta': 'Son tetiklenme 23dk önce',
  'tasks.sample.pr.body1': 'İnceleme için PR #184 açıldı',
  'tasks.sample.pr.body2': 'Eşleşen incelemeciler: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Teslimat: Slack DM gönderildi',
  'tasks.sample.meeting.title': 'Toplantı öncesi hazırlık',
  'tasks.sample.meeting.status': 'Yarın · 10:00',
  'tasks.sample.meeting.meta': 'Tek seferlik · özet gönderir',
  'tasks.sample.meeting.preview': 'meeting_brief.md · sıraya alındı',
  'tasks.sample.meeting.trigger': 'Zamanlama · tek seferlik',
  'tasks.sample.meeting.pattern': 'Brifing istemi',
  'tasks.sample.meeting.runtime': 'Uzak · sınırlı',
  'tasks.sample.meeting.output': 'Yapıt + mesaj',
  'tasks.sample.meeting.artifactMeta': 'Oluşturma için sıraya alındı',
  'tasks.sample.meeting.body1': '# Toplantı brifingi',
  'tasks.sample.meeting.body2': 'Gündem kaynağı: takvim etkinliği + bağlı belgeler',
  'tasks.sample.meeting.body3': 'Çıktı; kararları, engelleri ve soruları içerecektir.',
  'tasks.sample.candidate.title': 'Aday takibi',
  'tasks.sample.candidate.status': 'Başarısız · ilgilenilmesi gerekiyor',
  'tasks.sample.candidate.meta': 'Kimlik doğrulama süresi doldu',
  'tasks.sample.candidate.preview': 'Devam etmek için Greenhouse\'u yeniden bağla',
  'tasks.sample.candidate.trigger': 'Zamanlama · günlük',
  'tasks.sample.candidate.pattern': 'Rutin · aday senkronizasyonu',
  'tasks.sample.candidate.runtime': 'Uzak · yinelenen',
  'tasks.sample.candidate.output': 'Canlı çıktı · tablo',
  'tasks.sample.candidate.artifactMeta': 'Kimlik doğrulama geri yüklenene kadar duraklatıldı',
  'tasks.sample.candidate.body1': '# Aday akışı',
  'tasks.sample.candidate.body2': 'Son başarılı senkronizasyon: 2 gün önce',
  'tasks.sample.candidate.body3': 'İşlem gerekli: kaynak hesabı yeniden bağlayın.',
  'routines.title': 'Otomasyonlar',
  'routines.subtitle': 'Gözetimsiz çalışan zamanlanmış otomasyonlar.',
  'routines.newAutomation': 'Yeni otomasyon',
  'routines.loading': 'Yükleniyor…',
  'routines.empty': 'Henüz otomasyon yok.',
  'routines.emptyHint': 'Gözetimsiz bir Agent çalıştırması zamanlamak için Yeni otomasyon\'a tıklayın.',
  'routines.runHistoryLoading': 'Çalıştırmalar yükleniyor…',
  'routines.runHistoryEmpty': 'Henüz çalıştırma yok.',
  'routines.fieldName': 'Ad',
  'routines.fieldNamePlaceholder': 'Sabah brifingi',
  'routines.fieldPrompt': 'Komut',
  'routines.fieldPromptPlaceholder': 'Dünün GitHub + Linear etkinliğini çek ve nelerin değiştiğini özetle.',
  'routines.fieldSchedule': 'Zamanlama',
  'routines.fieldMinute': 'Her saatin dakikası',
  'routines.fieldTime': 'Saat',
  'routines.fieldTimezone': 'Saat dilimi',
  'routines.fieldsetProject': 'Proje',
  'routines.kind.hourly': 'Saatlik',
  'routines.kind.daily': 'Günlük',
  'routines.kind.weekdays': 'Hafta içi',
  'routines.kind.weekly': 'Haftalık',
  'routines.weekday.short.0': 'Paz',
  'routines.weekday.short.1': 'Pzt',
  'routines.weekday.short.2': 'Sal',
  'routines.weekday.short.3': 'Çar',
  'routines.weekday.short.4': 'Per',
  'routines.weekday.short.5': 'Cum',
  'routines.weekday.short.6': 'Cmt',
  'routines.weekday.long.0': 'Pazar',
  'routines.weekday.long.1': 'Pazartesi',
  'routines.weekday.long.2': 'Salı',
  'routines.weekday.long.3': 'Çarşamba',
  'routines.weekday.long.4': 'Perşembe',
  'routines.weekday.long.5': 'Cuma',
  'routines.weekday.long.6': 'Cumartesi',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Her saat :{minute} dakikasında çalışır',
  'routines.describe.daily': 'Her gün {time} {tz} saatinde çalışır',
  'routines.describe.weekdays': 'Pzt–Cum {time} {tz} saatinde çalışır',
  'routines.describe.weekly': 'Her {day} günü {time} {tz} saatinde çalışır',
  'routines.modeCreate': 'Her çalıştırmada yeni bir proje oluştur',
  'routines.modeCreateHint': 'Her tetiklemede yeni, yalıtılmış bir çalışma alanı.',
  'routines.modeReuse': 'Mevcut bir projeyi yeniden kullan',
  'routines.modeReuseHint': 'Her çalıştırma, proje içinde yeni bir konuşma olarak yer alır.',
  'routines.pickProject': '— Bir proje seçin —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ her çalıştırmada yeni proje',
  'routines.tagPaused': 'duraklatıldı',
  'routines.metaNext': 'sonraki: {when}',
  'routines.metaLast': 'son:',
  'routines.triggerManual': 'manuel',
  'routines.triggerScheduled': 'zamanlanmış',
  'routines.openProject': 'Projeyi aç',
  'routines.openProjectTitle': 'Bu çalıştırmanın yazdığı projeyi aç',
  'routines.runNow': 'Şimdi çalıştır',
  'routines.edit': 'Düzenle',
  'routines.pause': 'Duraklat',
  'routines.resume': 'Devam ettir',
  'routines.history': 'Geçmiş',
  'routines.hideHistory': 'Geçmişi gizle',
  'routines.delete': 'Sil',
  'routines.deleteTitle': 'Bu otomasyonu sil',
  'routines.cancel': 'İptal',
  'routines.save': 'Kaydet',
  'routines.saving': 'Kaydediliyor…',
  'routines.create': 'Oluştur',
  'routines.creating': 'Oluşturuluyor…',
  'routines.status.queued': 'sırada',
  'routines.status.running': 'çalışıyor',
  'routines.status.succeeded': 'başarılı',
  'routines.status.failed': 'başarısız',
  'routines.status.canceled': 'iptal edildi',
  'routines.confirmDelete': 'Bu otomasyon silinsin mi? Geçmiş çalıştırmalar ve projeleri korunur.',
  'routines.errorPickProject': 'Yeniden kullanmak için bir proje seçin veya “Her çalıştırmada yeni oluştur” seçeneğine geçin',
  'routines.errorAgentEmptyOutput': 'Agent herhangi bir çıktı üretmeden tamamlandı. Model veya sağlayıcı boş bir yanıt döndürmüş olabilir — üst kaynaklı hatalar için agent günlüklerini kontrol edin.',
  'entry.helpAria': 'Yardım',
  'entry.helpMenuAria': 'Yardım menüsü',
  'entry.helpGetHelp': 'GitHub üzerinden yardım alın',
  'entry.helpSubmitFeature': 'Özellik öner',
  'entry.helpWhatsNew': 'Yenilikler',
  'entry.helpDownloadDesktop': 'Masaüstü uygulamasını indir',
  'entry.githubStarLabel': 'Yıldız',
  'entry.githubStarTitle': 'GitHub üzerinde bize yıldız verin',
  'entry.githubStarAria': 'DANIA Studio’a GitHub üzerinde yıldız ver',
  'entry.tabImageTemplates': 'Görsel istemleri',
  'entry.tabVideoTemplates': 'Video istemleri',
  'promptTemplates.searchPlaceholder': 'Şablon ara…',
  'promptTemplates.countLabel': '{n} sonuç',
  'promptTemplates.emptyImage': 'Henüz görsel istemi şablonu yüklenmedi.',
  'promptTemplates.emptyVideo': 'Henüz video istemi şablonu yüklenmedi.',
  'promptTemplates.emptyNoMatch': 'Aramanıza uygun şablon bulunamadı.',
  'promptTemplates.attributionFooter': 'Herkese açık istem kütüphanesinden adape edildi. Her kart orijinal yazara bağlantılıdır.',
  'promptTemplates.openPreviewTitle': 'istemi aç ve önizle',
  'promptTemplates.sourcePrefix': 'Kaynak:',
  'promptTemplates.fetchError': 'Bu şablon gövdesi yüklenemedi.',
  'promptTemplates.promptLabel': 'İstem gövdesi',
  'promptTemplates.copyPrompt': 'İstemi kopyala',
  'promptTemplates.copyDone': 'Kopyalandı!',
  'promptTemplates.modelHint': 'Tavsiye edilen model: {model}',
  'promptTemplates.openSource': 'Orijinali görüntüle',
  'promptTemplates.openFullscreen': 'Tam ekran ön izlemeyi aç',
  'promptTemplates.closeFullscreen': 'Tam ekran ön izlemeyi kapat',
  'promptTemplates.allSources': 'Tüm kaynaklar',
  'promptTemplates.sourceFilterAria': 'Kaynağa göre filtrele',
  'promptTemplates.retry': 'Yeniden dene',
  'connectors.title': 'Bağlayıcılar',
  'connectors.subtitle': 'Canlı artefaktları besleyebilecek yerel ve gelecekteki veri kaynakları.',
  'connectors.account': 'Hesap',
  'connectors.noAccount': 'Bağlı değil',
  'connectors.tools': 'Araçlar',
  'connectors.connect': 'Bağlan',
  'connectors.disconnect': 'Bağlantıyı kes',
  'connectors.authorizationPending': 'Yetkilendirme bekleniyor...',
  'connectors.authorizationPendingHint': 'Yetkilendirmeyi açılan pencerede tamamlayın.',
  'connectors.cancelAuthorization': 'İptal',
  'connectors.configure': 'Yapılandır',
  'connectors.unavailable': 'Kullanılamıyor',
  'connectors.phaseStubTitle': 'Bağlayıcı API\'leri 3. aşamada gelecek; burası yalnızca önizleme yüzeyi.',
  'connectors.statusAvailable': 'Kullanılabilir',
  'connectors.statusConnected': 'Bağlı',
  'connectors.statusError': 'Hata',
  'connectors.statusDisabled': 'Devre dışı',
  'connectors.gateTitle': 'Devam etmek için Composio API anahtarınızı ekleyin',
  'connectors.gateBody': 'Kullanılabilir entegrasyonları yüklemek için anahtarınızı yukarıya yapıştırın ve Anahtarı kaydet’e tıklayın.',
  'connectors.aboutLabel': 'Hakkında',
  'connectors.detailsLabel': 'Ayrıntılar',
  'connectors.statusLabel': 'Durum',
  'connectors.category.aiAgents': 'AI ajanları',
  'connectors.category.aiInfrastructure': 'AI altyapısı',
  'connectors.category.accounting': 'Muhasebe',
  'connectors.category.admin': 'Yönetim',
  'connectors.category.advertising': 'Reklam',
  'connectors.category.analytics': 'Analitik',
  'connectors.category.automation': 'Otomasyon',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Takvim',
  'connectors.category.commerce': 'Ticaret',
  'connectors.category.communication': 'İletişim',
  'connectors.category.contacts': 'Kişiler',
  'connectors.category.dataPlatform': 'Veri platformu',
  'connectors.category.database': 'Veritabanı',
  'connectors.category.design': 'Tasarım',
  'connectors.category.developer': 'Geliştirici araçları',
  'connectors.category.documentation': 'Dokümantasyon',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Eğitim',
  'connectors.category.email': 'E-posta',
  'connectors.category.events': 'Etkinlikler',
  'connectors.category.fieldService': 'Saha servisi',
  'connectors.category.finance': 'Finans',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Formlar',
  'connectors.category.gaming': 'Oyun',
  'connectors.category.hr': 'İK',
  'connectors.category.hospitality': 'Konaklama',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Entegrasyon',
  'connectors.category.localization': 'Yerelleştirme',
  'connectors.category.logistics': 'Lojistik',
  'connectors.category.maps': 'Haritalar',
  'connectors.category.marketing': 'Pazarlama',
  'connectors.category.media': 'Medya',
  'connectors.category.meetings': 'Toplantılar',
  'connectors.category.nonprofit': 'Kâr amacı gütmeyen',
  'connectors.category.observability': 'Gözlemlenebilirlik',
  'connectors.category.payments': 'Ödemeler',
  'connectors.category.personal': 'Kişisel',
  'connectors.category.presentations': 'Sunumlar',
  'connectors.category.procurement': 'Satın alma',
  'connectors.category.product': 'Ürün',
  'connectors.category.productivity': 'Verimlilik',
  'connectors.category.projectManagement': 'Proje yönetimi',
  'connectors.category.recruiting': 'İşe alım',
  'connectors.category.research': 'Araştırma',
  'connectors.category.salesIntelligence': 'Satış zekâsı',
  'connectors.category.scheduling': 'Zamanlama',
  'connectors.category.search': 'Arama',
  'connectors.category.security': 'Güvenlik',
  'connectors.category.signing': 'İmzalama',
  'connectors.category.social': 'Sosyal',
  'connectors.category.spreadsheets': 'E-tablolar',
  'connectors.category.storage': 'Depolama',
  'connectors.category.support': 'Destek',
  'connectors.category.surveys': 'Anketler',
  'connectors.category.tasks': 'Görevler',
  'connectors.category.timeTracking': 'Zaman takibi',
  'connectors.category.video': 'Video',
  'connectors.category.whiteboard': 'Beyaz tahta',
  'connectors.categoryLabel': 'Kategori',
  'connectors.providerLabel': 'Sağlayıcı',
  'connectors.toolsSection': 'Araçlar',
  'connectors.toolsLoading': 'Araçlar yükleniyor…',
  'connectors.noToolsAvailable': 'Henüz kullanılabilir araç yok. Bağlandıktan sonra bu entegrasyonun yetenekleri görünür.',
  'connectors.toolDetailsUnavailable': 'Araç ayrıntıları kullanılamıyor, ancak bu connector {n} araç bildiriyor.',
  'connectors.loadMoreTools': 'Daha fazla araç yükle',
  'connectors.openDetailsAria': '{name} ayrıntılarını aç',
  'connectors.toolsBadgeNone': 'Araç yok',
  'connectors.toolsBadgeOne': '{n} araç',
  'connectors.toolsBadgeMany': '{n} araç',
  'connectors.searchPlaceholder': 'Bağlayıcı ara…',
  'connectors.searchAriaLabel': 'Bağlayıcıları ada, sağlayıcıya veya araca göre ara',
  'connectors.searchClear': 'Aramayı temizle',
  'connectors.emptyNoMatchTitle': '“{query}” ile eşleşen bağlayıcı yok',
  'connectors.emptyNoMatchBody': 'Başka bir anahtar kelime deneyin veya tüm kataloğu görmek için aramayı temizleyin.',
  'connectors.emptyNoMatchAction': 'Aramayı temizle',
  'newproj.tabPrototype': 'Prototip',
  'newproj.tabLiveArtifact': 'Canlı artifact',
  'newproj.tabDeck': 'Slayt gösterisi',
  'newproj.tabTemplate': 'Şablondan',
  'newproj.tabMedia': 'Medya',
  'newproj.tabOther': 'Diğer',
  'newproj.titlePrototype': 'Yeni prototip',
  'newproj.titleLiveArtifact': 'Yeni canlı artifact',
  'newproj.titleDeck': 'Yeni slayt gösterisi',
  'newproj.titleTemplate': 'Bir şablondan başla',
  'newproj.titleImage': 'Yeni görsel',
  'newproj.titleVideo': 'Yeni video',
  'newproj.titleAudio': 'Yeni ses',
  'newproj.titleMedia': 'Yeni medya',
  'newproj.titleOther': 'Yeni proje',
  'newproj.namePlaceholder': 'Proje ismi',
  'newproj.fidelityLabel': 'Sadakat',
  'newproj.fidelityWireframe': 'İskelet',
  'newproj.fidelityHigh': 'Yüksek sadakat',
  'newproj.toggleSpeakerNotes': 'Konuşmacı notlarını kullan',
  'newproj.toggleSpeakerNotesHint': 'Slaytlarda daha az metin — konuşma noktalarını notlarda tut.',
  'newproj.toggleAnimations': 'Animasyonları dahil et',
  'newproj.toggleAnimationsHint': 'Şablonunuzun üstüne hareket (giriş, yüzme, geçişler) ekleyin.',
  'newproj.targetPlatformsLabel': 'Hedef platformlar',
  'newproj.targetPlatformsHint': 'Bir veya daha fazlasını seçin. Duyarlı web yalnızca tarayıcı kırılma noktalarını kapsar; yerel çapraz platform varyantları için iOS, Android, tablet uygulaması veya masaüstü uygulaması ekleyin.',
  'newproj.platform.responsive.label': 'Duyarlı web',
  'newproj.platform.responsive.hint': 'Masaüstü, tablet ve mobil tarayıcılar için uyarlanmış tek bir web deneyimi',
  'newproj.platform.webDesktop.label': 'Masaüstü web',
  'newproj.platform.webDesktop.hint': 'Tarayıcı öncelikli ürün veya açılış sayfası',
  'newproj.platform.mobileIos.label': 'iOS uygulaması',
  'newproj.platform.mobileIos.hint': 'iPhone çerçeveleri ve iOS etkileşim kuralları',
  'newproj.platform.mobileAndroid.label': 'Android uygulaması',
  'newproj.platform.mobileAndroid.hint': 'Pixel çerçeveleri ve Material etkileşim kuralları',
  'newproj.platform.tablet.label': 'Tablet uygulaması',
  'newproj.platform.tablet.hint': 'Bölünmüş görünümlerle yerel tarzda tablet deneyimi',
  'newproj.platform.desktopApp.label': 'Masaüstü uygulaması',
  'newproj.platform.desktopApp.hint': 'macOS/Windows uygulama arayüzü',
  'newproj.surfaceOptionsLabel': 'Tamamlayıcı yüzeyler',
  'newproj.includeLandingPage': 'Açılış sayfası ekle',
  'newproj.includeLandingPageHint': 'Reklamlar, bekleme listeleri, lansman kampanyaları, uygulama indirmeleri veya ürün açıklaması için duyarlı bir pazarlama sayfası ekleyin.',
  'newproj.includeOsWidgets': 'İşletim sistemi widget\'ları ekle',
  'newproj.includeOsWidgetsHint': 'Mobil/tablet uygulamaları için platforma özgü ana ekran, kilit ekranı veya hızlı erişim widget\'ları ekleyin.',
  'newproj.includeOsWidgetsDisabledHint': 'Hedef platform olarak iOS, Android veya tablet uygulaması seçildiğinde kullanılabilir.',
  'newproj.templateLabel': 'Şablon',
  'newproj.noTemplatesTitle': 'Henüz şablon yok',
  'newproj.noTemplatesBody': 'Herhangi bir projeyi açın, ardından dosya görüntüleyicideki Paylaş menüsü ile bir şablona dönüştürün. Şablonlar burada görünür.',
  'newproj.savedTemplate': 'Şablon kaydedildi',
  'newproj.fileSingular': 'dosya',
  'newproj.filePlural': 'dosyalar',
  'newproj.create': 'Oluştur',
  'newproj.locationLabel': 'Şuraya kaydet',
  'newproj.locationDefault': 'DANIA Studio projeleri',
  'newproj.locationExternalBase': 'Harici taban',
  'newproj.createLiveArtifact': 'Canlı artifact oluştur',
  'newproj.createFromTemplate': 'Şablondan oluştur',
  'newproj.createDisabledTitle': 'Önce bir projeyi şablon olarak kaydedin (herhangi bir projenin içinde Paylaş menüsünden).',
  'newproj.importClaudeZip': 'Claude ZIP’i içe aktar',
  'newproj.importClaudeZipTitle': 'Bir Claude .zip’ini içe aktarın',
  'newproj.importingClaudeZip': 'İçe aktarılıyor…',
  'newproj.privacyFooter': 'Projeyi varsayılan olarak yalnızca siz görebilirsiniz.',
  'newproj.designSystem': 'Tasarım sistemi',
  'newproj.dsNoneFreeform': 'Hiçbiri — serbest stil',
  'newproj.dsNoneSubtitleEmpty': 'Sistem tokeni yok, kendi paletinizi seçin',
  'newproj.dsNoneSubtitleSelected': 'Sistem tokenlerini atla. Ajan kendi paletini seçer.',
  'newproj.dsCategoryFallback': 'Tasarım sistemi',
  'newproj.dsSearch': 'Tasarım sistemleri ara…',
  'newproj.dsModeAria': 'Seçim modu',
  'newproj.dsModeSingle': 'Tekli',
  'newproj.dsModeMulti': 'Çoklu',
  'newproj.dsNoneTitle': 'Hiçbiri — serbest stil',
  'newproj.dsNoneSub': 'Sistem tokenlerini atla. Ajan kendi paletini seçer.',
  'newproj.dsEmpty': 'Hiçbir tasarım sistemi “{query}” aramasıyla örtüşmedi.',
  'newproj.dsFootSingular': 'yalnızca ilhamdır.',
  'newproj.dsFootPlural': 'yalnızca ilhamdır.',
  'newproj.dsFootClear': 'Temizle',
  'newproj.dsBadgeDefault': 'VARSAYILAN',
  'newproj.dsPrimaryFallback': 'Birincil',
  'newproj.surfaceImage': 'Görsel',
  'newproj.surfaceVideo': 'Video',
  'newproj.surfaceAudio': 'Ses',
  'newproj.modelLabel': 'Model',
  'newproj.modelSearch': 'Modelleri ara…',
  'newproj.modelEmpty': 'Eşleşen model yok.',
  'newproj.modelRecommended': 'Önerilen',
  'newproj.modelMissingTitle': 'Model seç',
  'newproj.modelMissingSub': 'Bu yüzey için bir model seç.',
  'newproj.aspectLabel': 'Oran',
  'newproj.videoLengthLabel': 'Uzunluk',
  'newproj.videoLengthSeconds': '{n}s',
  'newproj.audioKindLabel': 'Ses tipi',
  'newproj.audioKindMusic': 'Müzik',
  'newproj.audioKindSpeech': 'Konuşma / TTS',
  'newproj.audioKindSfx': 'Ses efekti',
  'newproj.audioDurationLabel': 'Süre',
  'newproj.audioDurationSeconds': '{n}s',
  'newproj.voiceLabel': 'Ses',
  'newproj.voicePlaceholder': 'Sağlayıcı ses kimliği, opsiyonel',
  'newproj.connectorsLabel': 'Bağlayıcılar',
  'newproj.connectorsHint': 'Bu artefaktın veri çekebileceği kaynaklar.',
  'newproj.connectorsEmptyTitle': 'Yapılandırılmış bağlayıcı yok',
  'newproj.connectorsEmptyBody': 'Canlı artefaktın yer tutucular yerine gerçek verileri kullanması için bir veri kaynağı bağlayın.',
  'newproj.connectorsEmptyCta': 'Bağlayıcıları ayarla →',
  'newproj.connectorsLoading': 'Bağlayıcılar yükleniyor…',
  'newproj.connectorsCountOne': '{n} bağlı',
  'newproj.connectorsCountMany': '{n} bağlı',
  'newproj.connectorsManage': 'Yönet',
  'newproj.promptTemplateLabel': 'Referans şablon',
  'newproj.promptTemplateNoneTitle': 'Hiçbiri — kendin yaz',
  'newproj.promptTemplateNoneSub': 'Galeriyi atla, kendi brief’ini açıkla',
  'newproj.promptTemplateRefSub': 'Referans şablon',
  'newproj.promptTemplateSearch': 'Şablon ara…',
  'newproj.promptTemplateEmpty': 'Bu yüzey için henüz şablon yüklenmedi.',
  'newproj.promptTemplateBodyLabel': 'İstem (istediğin gibi düzenleyebilirsin)',
  'newproj.promptTemplateOptimizeHint': 'İstediğin her şeyi düzenle — değişikliklerin ajan brief’ine taşınır.',
  'newproj.promptTemplateBodyEmpty': 'Gövde boş — ajana şablon referansı gitmeyecek.',
  'newproj.deleteTemplateTitle': 'Şablonu sil',
  'newproj.deleteTemplateConfirm': '"{name}" silinsin mi? Bu işlem geri alınamaz.',
  'newproj.deleteTemplateConfirmCta': 'Şablonu sil',
  'newproj.deleteTemplateError': 'Bu şablon silinemedi. Lütfen tekrar deneyin.',
  'designs.subRecent': 'Yakında',
  'designs.subYours': 'Tasarımların',
  'designs.filterAria': 'Projeleri filtrele',
  'designs.searchPlaceholder': 'Ara…',
  'designs.emptyNoProjects': 'Henüz proje yok.',
  'designs.emptyNoMatch': 'Hiçbir proje aramanızla örtüşmedi.',
  'designs.deleteTitle': 'Projeyi sil',
  'designs.deleteConfirm': '"{name}"’i sil?',
  'designs.cardFreeform': 'serbest stil',
  'designs.badgeLive': 'Canlı',
  'designs.liveArtifactBadgesAria': 'Canlı artifact rozetleri',
  'designs.liveCount': '{n} canlı',
  'designs.statusLive': 'Canlı artifact',
  'designs.statusArchived': 'Arşivlendi',
  'designs.statusError': 'Hata',
  'designs.statusRefreshing': 'Yenileniyor…',
  'designs.statusRefreshFailed': 'Yenileme başarısız',
  'designs.statusRefreshed': 'Yenilendi',
  'designs.status.notStarted': 'başlamadı',
  'designs.status.queued': 'Sırada',
  'designs.status.running': 'Çalışıyor',
  'designs.status.awaitingInput': 'Girdi gerekli',
  'designs.status.succeeded': 'Tamamlandı',
  'designs.status.published': 'Yayımlandı',
  'designs.status.failed': 'Başarısız',
  'designs.status.canceled': 'İptal edildi',
  'designs.viewToggleAria': 'Görüntüleme modu',
  'designs.viewGrid': 'Izgara görünümü',
  'designs.viewKanban': 'Tahta görünümü',
  'designs.kanbanEmptyColumn': 'Tasarım yok',
  'designs.deleteAria': '{name} projesini sil',
  'designs.menuMore': 'Diğer eylemler',
  'designs.menuRename': 'Yeniden adlandır',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': 'Sil',
  'designs.renamePrompt': '"{name}" için yeni ad',
  'designs.selectMode': 'Seç',
  'designs.cancelSelect': 'İptal',
  'designs.deleteSelected': 'Seçilenleri sil',
  'designs.selectedCount': '{n} seçildi',
  'designs.deleteSelectedConfirm': '{n} proje silinsin mi?',
  'designs.deleteSelectedSuccess': '{n} proje başarıyla silindi.',
  'designs.deleteSelectedPartial': '{deleted} proje silindi; {failed} başarısız oldu.',
  'designs.tagPrototype': 'Prototip',
  'designs.tagLiveArtifact': 'Canlı Yapıt',
  'designs.tagSlide': 'Slayt',
  'designs.tagMedia': 'Medya',
  'designs.renameTitle': 'Projeyi yeniden adlandır',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'İptal',
  'examples.typeLabel': 'Tip',
  'examples.surfaceLabel': 'Yüzey',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Görsel',
  'examples.surfaceVideo': 'Video',
  'examples.surfaceAudio': 'Ses',
  'examples.scenarioLabel': 'Senaryo',
  'examples.modeAll': 'Tümü',
  'examples.modePrototypeDesktop': 'Prototipler · Masaüstü',
  'examples.modePrototypeMobile': 'Prototipler · Mobil',
  'examples.modeDeck': 'Slaytlar',
  'examples.modeDocument': 'Doküman & şablonlar',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Canlı',
  'examples.scenarioGeneral': 'Genel',
  'examples.scenarioEngineering': 'Mühendislik',
  'examples.scenarioProduct': 'Ürün',
  'examples.scenarioDesign': 'Tasarım',
  'examples.scenarioMarketing': 'Pazarlama',
  'examples.scenarioSales': 'Satış',
  'examples.scenarioFinance': 'Finans',
  'examples.scenarioHr': 'İnsan Kaynakları',
  'examples.scenarioOperations': 'Operasyonlar',
  'examples.scenarioSupport': 'Destek',
  'examples.scenarioLegal': 'Yasal',
  'examples.scenarioEducation': 'Eğitim',
  'examples.scenarioPersonal': 'Şahsi',
  'examples.searchPlaceholder': 'Örnek ara…',
  'examples.searchAria': 'Örnekleri ada göre ara',
  'examples.emptyNoSkills': 'Yetenekler mevcut değil. Arka plan servisi çalışıyor mu?',
  'examples.emptyNoMatch': 'Hiçbir örnek bu filtrelere uymuyor.',
  'examples.openPreview': '⤢ Önizlemeyi aç',
  'examples.loadingPreview': 'Önizleme yükleniyor…',
  'examples.hoverPreview': 'Önizlemek için fareyi üzerine getirin',
  'examples.usePrompt': 'Bu istemi kullan',
  'examples.previewModalTitle': 'Tam önizlemeyi aç (modal)',
  'examples.shareTitle': 'Bu örneği paylaş',
  'examples.shareLoadFirst': 'önizlemek için önce fareyi üzerine getirin',
  'examples.unavailablePlaceholder': 'Birlikte gelen {kind} önizlemesi yok — ayrıntılar için aç',
  'examples.shareUnavailable': 'Paylaşılacak {kind} önizlemesi gelmiyor',
  'examples.shareMenu': 'Paylaş ▾',
  'examples.exportPdfAllSlides': 'PDF olarak dışa aktar (tüm slaytlar)',
  'examples.exportPptxLocked': 'PPTX olarak dışa aktar… (Önce şablon açın)',
  'examples.tagSlideDeck': 'Slayt gösterisi',
  'examples.tagTemplate': 'Şablon',
  'examples.tagDesignSystem': 'Tasarım sistemi',
  'examples.tagMobilePrototype': 'Mobil prototip',
  'examples.tagDesktopPrototype': 'Masaüstü prototip',
  'examples.tagImage': 'Görsel',
  'examples.tagVideo': 'Video',
  'examples.tagAudio': 'Ses',
  'examples.previewLabel': 'Önizleme',
  'ds.surfaceLabel': 'Yüzey',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Görsel',
  'ds.surfaceVideo': 'Video',
  'ds.surfaceAudio': 'Ses',
  'ds.searchPlaceholder': 'Tasarım sistemleri ara…',
  'ds.emptyNoMatch': 'Hiçbir tasarım sistemi aramanızla örtüşmedi.',
  'ds.badgeDefault': 'VARSAYILAN',
  'ds.preview': 'Önizleme',
  'ds.previewTitle': 'Tasarım sistemini önizle',
  'ds.categoryAll': 'Tümü',
  'ds.categoryUncategorized': 'Kategorilendirilmemiş',
  'ds.showcase': 'Tanıtım',
  'ds.tokens': 'Tokenler',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'DESIGN.md yükleniyor…',
  'avatar.title': 'Hesap & ayarlar',
  'avatar.localCli': 'Yerel CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Yerel CLI’ı kullan',
  'avatar.useApi': 'API · BYOK kullan',
  'avatar.codeAgent': 'Kod ajanı',
  'avatar.rescan': 'PATH’ı yeniden tara',
  'avatar.amrConsole': 'DANIA Studio hesabı',
  'avatar.amrConsoleMeta': 'Bakiye ve yükleme',
  'avatar.settings': 'Ayarlar',
  'avatar.backToProjects': 'Projelere dön',
  'avatar.metaActive': 'aktif',
  'avatar.metaOffline': 'çevrim dışı',
  'avatar.metaSelected': 'seçildi',
  'avatar.noAgentSelected': 'ajan seçilmedi',
  'avatar.modelSection': 'Model',
  'avatar.modelLabel': 'Model',
  'avatar.reasoningLabel': 'Akıl yürütme',
  'avatar.customSuffix': '(özel)',
  'socialShare.openDesignSection': 'DANIA Studio\'ı paylaş',
  'socialShare.openDesignTitle': 'GitHub\'da DANIA Studio',
  'socialShare.openDesignText': 'DANIA Studio; tasarım yapıtları oluşturmak, düzenlemek, dağıtmak ve devretmek için açık kaynaklı bir çalışma alanıdır.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'SOSYAL PAYLAŞIM',
  'socialShare.publishPageTitle': 'Paylaşım sayfasını yayınla',
  'socialShare.publishPageSubtitle': 'Bu önizlemeyi sosyal platformlarda paylaşılabilir hale getirmek için yayınlayın.',
  'socialShare.projectTitle': '{title} · DANIA Studio',
  'socialShare.projectText': 'DANIA Studio ile oluşturuldu: {title}. Dağıtılan yapıtı görüntüleyin ve depoya yıldız verin: {repo}',
  'socialShare.projectCopyText': 'DANIA Studio ile oluşturuldu: {title}\n{url}\nDANIA Studio deposu: {repo}',
  'socialShare.deployFirst': 'Dağıt ve paylaş…',
  'socialShare.copied': 'Kopyalandı',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'CLI / modeli değiştir',
  'inlineSwitcher.chipCli': 'Yerel CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'varsayılan',
  'inlineSwitcher.noAgent': 'ajan yok',
  'inlineSwitcher.modeLabel': 'Mod',
  'inlineSwitcher.agentLabel': 'Ajan',
  'inlineSwitcher.providerLabel': 'Sağlayıcı',
  'inlineSwitcher.modelLabel': 'Model',
  'inlineSwitcher.useCli': 'Yerel CLI kullan',
  'inlineSwitcher.useByok': 'Kendi API anahtarını kullan',
  'inlineSwitcher.daemonOffline': 'Daemon çevrimdışı — ayarları aç',
  'inlineSwitcher.noAgentsDetected': 'PATH\'te CLI bulunamadı',
  'inlineSwitcher.openSettingsForModel': 'Sağlayıcıyı Ayarlardan yapılandırın',
  'inlineSwitcher.missingApiKey': 'API anahtarı yok — Ayarlardan ekleyin.',
  'inlineSwitcher.openFullSettings': 'Yürütme ayarlarını aç',
  'inlineSwitcher.customSuffix': '(özel)',
  'project.backToProjects': 'Projelere dön',
  'project.brandReadyTitle': '{name} tasarım sistemi hazır',
  'project.brandReadyTitleGeneric': 'Tasarım sisteminiz hazır',
  'project.brandReadyCta': 'Tasarım sistemlerinde önizle',
  'project.brandReadyDismiss': 'Kapat',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'Tasarım sistemi önizlemesi açıldı.',
  'project.metaFreeform': 'serbest stil',
  'project.typePrototype': 'Prototip',
  'project.typeDeck': 'Slaytlar',
  'project.typeTemplate': 'Şablon',
  'project.typeImage': 'Görsel',
  'project.typeVideo': 'Video',
  'project.typeAudio': 'Ses',
  'project.customInstructions': 'Proje talimatları',
  'project.customInstructionsPlaceholder': 'Bu proje için talimatlar (her mesajda eklenir)…',
  'project.resizeChatPanel': 'Sohbet panelini yeniden boyutlandır',
  'project.instructionsActive': 'Etkin — her mesaja eklenir',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'Sohbet',
  'chat.tabComments': 'Yorumlar',
  'chat.commentsSoon': 'Yorumlar — yakında',
  'chat.comments.attached': 'Sohbete eklendi',
  'chat.comments.emptyAttached': 'Eklenmiş yorum yok.',
  'chat.comments.saved': 'Kaydedilen yorumlar',
  'chat.comments.emptySaved': 'Kaydedilmiş yorum yok.',
  'chat.comments.add': 'Ekle',
  'chat.comments.addAll': 'Tümünü ekle',
  'chat.comments.remove': 'Kaldır',
  'chat.comments.placeholder': 'Bu öğeye yorum yapın…',
  'chat.comments.addSend': 'Ekle ve gönder',
  'chat.comments.updateSend': 'Güncelle ve gönder',
  'chat.comments.removeAttachment': 'Yorum ekini kaldır',
  'chat.comments.removeAttachmentAria': '{name} için yorum ekini kaldır',
  'chat.comments.comment': 'Yorum',
  'chat.comments.sendToChat': 'Sohbete gönder',
  'chat.comments.sending': 'Gönderiliyor…',
  'chat.comments.edit': 'Düzenle',
  'chat.comments.select': 'Seç',
  'chat.comments.selectAll': 'Tümünü seç',
  'chat.comments.deselect': 'Seçimi kaldır',
  'chat.comments.nSelected': '{n} seçildi',
  'chat.comments.pin': 'Sabitle',
  'chat.comments.addNote': 'Not ekle',
  'chat.comments.savedToast': 'Yorum kaydedildi',
  'chat.comments.pinSavedToast': 'Sabitleme kaydedildi',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} yakalanan öğe',
  'chat.comments.clear': 'Temizle',
  'chat.comments.targetImage': 'Görsel',
  'chat.comments.targetControl': 'Denetim',
  'chat.comments.targetLink': 'Bağlantı',
  'chat.comments.targetText': 'Metin',
  'chat.comments.targetSection': 'Bölüm',
  'chat.comments.targetPage': 'Sayfa',
  'chat.comments.targetArea': 'Alan',
  'chat.annotationNotePlaceholder': 'Bu işaret için bir not ekleyin',
  'chat.annotationAttachImage': 'Görsel ekle',
  'chat.annotationAttachedImages': 'Eklenen görseller',
  'chat.annotationAttachedRemove': 'Son görseli kaldır',
  'chat.annotationAddToInput': 'Girdiye ekle',
  'chat.annotationAddingToInput': 'Ekleniyor...',
  'chat.annotationQueue': 'Kuyruğa al',
  'chat.annotationQueueing': 'Kuyruğa alınıyor...',
  'chat.annotationSubmitOptions': 'Gönderme seçenekleri',
  'chat.annotationSending': 'Gönderiliyor...',
  'chat.annotationSendDisabledReason': 'Şu anda bir görev çalışıyor',
  'chat.annotationPreviewMissing': 'Önizleme yakalanamadı. Lütfen tekrar deneyin.',
  'chat.annotationPreviewMissingInk': 'Önizleme yakalanamadı. Yalnızca çizim göndermemek için tekrar deneyin.',
  'chat.annotationSentWithoutScreenshot': 'Önizleme yakalanamadı. Açıklama ekran görüntüsü olmadan gönderildi.',
  'chat.annotationTimeout': 'Açıklama gönderimi zaman aşımına uğradı. Lütfen tekrar deneyin.',
  'chat.annotationFailed': 'Açıklama gönderimi başarısız oldu. Lütfen tekrar deneyin.',
  'chat.annotationProjectCreateFailed': 'Bir proje oluşturulamadığından açıklama gönderilmedi.',
  'chat.annotationUploadFailed': 'Ek yükleme başarısız oldu. Lütfen tekrar deneyin.',
  'chat.conversationsTitle': 'Konuşmalar',
  'chat.conversationsAria': 'Konuşma geçmişi',
  'chat.newConversation': 'Yeni konuşma',
  'chat.newConversationsTitle': 'Yeni Konuşma',
  'chat.conversationsHeading': 'Konuşmalar',
  'chat.new': 'Yeni',
  'chat.emptyConversations': 'Henüz konuşma yok.',
  'chat.deleteConversation': 'Konuşmayı sil',
  'chat.renameConversationLabel': '"{title}" adını değiştir',
  'chat.deleteConversationConfirm': '"{title}"’ı sil? Bu mesajları silecektir.',
  'chat.untitledConversation': 'Başlıksız konuşma',
  'chat.forkedConversationTitle': '{title} çatallaması',
  'chat.forkConversationFailed': 'Bu konuşma fork edilemedi.',
  'chat.startTitle': 'Bir konuşma başlat',
  'chat.startHint': 'Oluşturmak istediğiniz şeyi açıklayın veya bu örneklerden biriyle başlayın:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so DANIA Studio can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.brandBrowserAssistMessage': 'DANIA Studio needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "AI Optimizasyonu",
  'brandEnrichment.body': "DANIA Studio arka planda daha derin bir çıkarım çalıştırır, doğru design system skills paketini otomatik uygular ve bu sistemi yerinde günceller. Bu işlem 10-20 dakika sürebilir; çalışmaya devam edebilirsiniz.",
  'brandEnrichment.cta': "AI Optimize Et",
  'brandEnrichment.busy': "AI optimizasyonu başlatılıyor...",
  'brandExtractionTranscript.sourceDesignMd': 'yapıştırılan DESIGN.md',
  'brandExtractionTranscript.user': '{source} kaynağından bir tasarım sistemi çıkar.',
  'brandExtractionTranscript.doneTitle': '{name} için programatik çıkarım tamamlandı.',
  'brandExtractionTranscript.doneBody': '{source} kaynağından {designSystemId} tasarım sistemini oluşturdum ve kaydettim. Artık önizlenebilir ve yeni tasarımlarda kullanılabilir.',
  'brandExtractionTranscript.next': 'Sonra daha derin bir çıkarım için AI Optimize çalıştırabilir veya bu sistemle yeni bir tasarım oluşturabilirsin.',
  'chat.fillInputTitle': 'İstemi doldurmak için tıklayın',
  'chat.jumpToLatest': 'En son mesaja atla',
  'chat.scrollToLatest': 'En son mesaja kaydır',
  'chat.you': 'Sen',
  'chat.openFile': '{name}’ı aç',
  'chat.copyPrompt': 'Promptu kopyala',
  'chat.copyErrorDiagnostic': 'Hata tanısını kopyala',
  'chat.copyDone': 'Kopyalandı!',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.composerPlaceholder': 'Oluşturmak istediğiniz şeyi açıklayın…',
  'chat.activeFileEditingLabel': 'Düzenleniyor',
  'chat.activeFilePlaceholder': 'DANIA Studio\'dan {file} dosyasını değiştirmesini isteyin...',
  'chat.designArtifactsShowMore': '{count} tasarım dosyası daha göster',
  'chat.mode.chat.label': 'Sor',
  'chat.mode.chat.title': 'Sorma modu',
  'chat.mode.chat.summary': 'Tasarım çıktısı oluşturulacağını varsaymadan hızlı yanıtlar, düzenlemeler, planlama ve tartışma için.',
  'chat.mode.chat.solves': 'Fikirleri netleştirmek, promptları iyileştirmek, seçenekleri karşılaştırmak veya mevcut işle ilgili soru sormak için kullanın.',
  'chat.mode.chat.query1': 'Bu taslağı özetle ve eksikleri göster.',
  'chat.mode.chat.query2': 'Bu landing page için en iyi yapıya karar vermeme yardım et.',
  'chat.mode.chat.query3': 'Bu tasarımı incele ve somut iyileştirmeler öner.',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': 'Tasarım',
  'chat.mode.design.title': 'Design modu',
  'chat.mode.design.summary': 'Sayfa, prototip, canlı artifact, slayt, görsel, video, HyperFrames, ses, dashboard ve proje dosyaları gibi somut çıktılar oluşturmak veya değiştirmek için.',
  'chat.mode.design.solves': 'DANIA Studio’ın dosya üretmesini, workspace’i güncellemesini veya brief’i çok modlu deliverable’lara dönüştürmesini istediğinizde kullanın.',
  'chat.mode.design.query1': 'Bu brief’ten bir ürün lansmanı landing page’i ve HyperFrames prototipi oluştur.',
  'chat.mode.design.query2': 'Konuşmacı notlarıyla 10 slaytlık yatırımcı deck’i hazırla.',
  'chat.mode.design.query3': 'Bu kampanya için görsel, video ve ses konseptleri üret.',
  'chat.mode.cardBestFor': 'En uygun',
  'chat.mode.cardTry': 'Örnek istekler',
  'chat.mode.cardCost': 'Tipik kullanım',
  'chat.mode.chat.cost': 'Düşük',
  'chat.mode.chat.costNote': 'Yalnızca sohbet — hiçbir şey üretilmez, bu yüzden en az kaynağı kullanır.',
  'chat.mode.plan.cost': 'Standart',
  'chat.mode.plan.costNote': 'Üretime geçmeden önce düzenlenebilir bir plan belgesi oluşturur.',
  'chat.mode.design.cost': 'Yüksek',
  'chat.mode.design.costNote': 'Dosyalar ve çok biçimli içerik üretir; bu nedenle tek çalıştırma en fazla kaynağı kullanabilir.',
  'chat.composerHint': 'Göndermek için ⌘/Ctrl + Enter · hedef, içerik, stil ve formatı belirtin',
  'chat.cliSettingsTitle': 'CLI & model ayarları',
  'chat.cliSettingsAria': 'CLI ve model ayarlarını aç',
  'chat.attachTitle': 'Dosyaları iliştirin (veya yapıştırın / sürükleyin)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Dosyaları iliştirin',
  'chat.importTitle': 'Kaynakları içe aktar (yakında)',
  'chat.importLabel': 'İçe aktar',
  'chat.importComingSoon': 'Yakında',
  'chat.importSoon': 'Yakında',
  'chat.importFig': 'Bir .fig dosyası yükleyin',
  'chat.importGitHub': 'GitHub bağla',
  'chat.importWeb': 'Bir web elementi',
  'chat.importFolder': 'Kod klasörünü bağlantıla',
  'chat.importSkills': 'Yetenekler ve tasarım sistemleri',
  'chat.importProject': 'Başka bir projeye referans ver',
  'chat.importDesignSystemHeader': 'Bir tasarım sistemi seçin',
  'chat.importDesignSystemBack': 'Geri',
  'chat.importDesignSystemSearch': 'Tasarım sistemlerini ara…',
  'chat.importDesignSystemEmpty': '"{query}" ile eşleşen tasarım sistemi yok',
  'chat.importDesignSystemNone': 'Yok — serbest',
  'chat.importDesignSystemNoneSub': 'Bu turda bir sisteme bağlı kalma',
  'chat.importDesignSystemActive': 'Etkin',
  'chat.importDesignSystemSwitched': 'Tasarım sistemi {title} olarak değiştirildi',
  'chat.importDesignSystemFailed': 'Tasarım sistemi değiştirilemedi. Lütfen tekrar deneyin.',
  'chat.importDesignSystemLoadFailed': 'Tasarım sistemleri yüklenemedi.',
  'browserUse.title': 'İlham',
  'browserUse.summary': '{count} web eylemi; varlık çıkarımı, tasarım dili, hareket, görsel kontroller ve bileşen yapısına öncelik verir.',
  'browserUse.searchAria': 'İlham ara',
  'browserUse.searchPlaceholder': 'Ekran görüntülerini, yazı tiplerini, renkleri, a11y\'yi ara...',
  'browserUse.empty': 'Eşleşen ilham yok',
  'browserUse.unavailable': 'İlham burada kullanılamıyor',
  'browserUse.added': 'Düzenleyiciye eklendi',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': 'Yüklemeyi durdur',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'DANIA Studio browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': 'Varlık çıkarımı',
  'browserUse.category.tokens': 'Tasarım dili',
  'browserUse.category.motion': 'Hareket',
  'browserUse.category.visual': 'Görsel kontroller',
  'browserUse.category.structure': 'Bileşenler',
  'browserUse.category.project': 'Proje çalıştırması',
  'browserUse.category.general': 'Genel',
  'browserUse.input.none': 'Girdi yok',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'İsteğe bağlı seçici',
  'browserUse.input.requirementSelector': 'Gereksinim, isteğe bağlı seçici',
  'browserUse.input.selectorOptional': 'İsteğe bağlı seçici',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Seçici, scale=2',
  'browserUse.input.gridOverlay': '12 sütun, maks 1200, boşluk 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, alan adı veya arama terimleri',
  'browserUse.input.selector': 'Seçici',
  'browserUse.input.selectorText': 'Seçici ve metin',
  'browserUse.input.scroll': 'Piksel, üst, alt veya sayfa',
  'browserUse.input.terminalRun': 'Komut, zaman aşımı 120sn',
  'browserUse.input.command': 'Komut',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Üstbilgi, gezinme, sınıf adları, konum, OG görseli ve favicon yedeğinden en iyi logo adayları.',
  'browserUse.action.list_images.output': 'Boyutları ve alternatif metni olan tüm img, srcset, source ve CSS arka plan görselleri.',
  'browserUse.action.download_assets.output': 'İndirilen varlık klasörü ile referer ve çerez desteği içeren _manifest.json.',
  'browserUse.action.extract_svgs.output': 'Satır içi SVG\'ler ve bağlı .svg dosyaları ayrı SVG dosyaları olarak kaydedildi.',
  'browserUse.action.optimize_svgs.output': 'Optimize edilmiş SVG dosyaları ve sıkıştırma oranı.',
  'browserUse.action.extract_colors.output': 'Ağırlıklı palet ve :root CSS renk değişkenleri palette.json ve palette.html olarak.',
  'browserUse.action.extract_fonts.output': 'En çok kullanılan font aileleri, boyutları, ağırlıkları ve @font-face kuralları typography.json olarak.',
  'browserUse.action.extract_design_tokens.output': 'Yarıçap, gölge, boşluk ve CSS değişkenleri tokens.json olarak.',
  'browserUse.action.extract_type_scale.output': 'Boyut, ağırlık, satır yüksekliği ve oranlarla başlık, gövde ve buton tipografi ölçeği.',
  'browserUse.action.extract_buttons.output': 'Yinelenenlerden arındırılmış buton stili kütüphanesi buttons.html ve buttons.json olarak.',
  'browserUse.action.extract_grid_system.output': 'Grid ve flex kapsayıcıları, yön, boşluklar, sütunlar ve maksimum genişlikler layout.json olarak.',
  'browserUse.action.extract_breakpoints.output': 'Duyarlı medya sorgusu kesme noktaları breakpoints.json olarak.',
  'browserUse.action.extract_gradients.output': 'CSS gradyanları gradients.css, gradients.json ve önizleme HTML olarak.',
  'browserUse.action.extract_shadows.output': 'Kutu gölgeleri, metin gölgeleri ve düşen gölgeler shadows.json ve önizleme olarak.',
  'browserUse.action.extract_easings.output': 'Geçiş ve animasyon yumuşatma fonksiyonları easings.json olarak.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js ve style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, geçiş ve dönüşüm kuralları, algılanan hareket kütüphaneleri, motion.css ve motion.json.',
  'browserUse.action.validate_view.output': 'Ekran görüntüsü yolları ve yapılandırılmış görsel ve düzen sorunları.',
  'browserUse.action.audit_layout.output': 'Taşma, sınırlar, çakışma ve kırpılmış metin dahil düzen kusurları audit.json olarak.',
  'browserUse.action.audit_accessibility.output': 'Seçicilerle, etiketlerle, rollerle, odakla, kontrastla erişilebilirlik sorunları ve faydalı olduğunda ekran görüntüleri.',
  'browserUse.action.responsive_screenshots.output': 'Mobil 390, tablet 834 ve masaüstü 1440 ekran görüntüleri.',
  'browserUse.action.screenshot_full.output': 'Görünüm alanının ötesindeki tam sayfa ekran görüntüsü.',
  'browserUse.action.screenshot_element.output': 'Varsayılan olarak 2x ölçekte tek öğe ekran görüntüsü.',
  'browserUse.action.screenshot_with_grid.output': 'Düzen gridi bindirmeli ekran görüntüsü.',
  'browserUse.action.screenshot_dark_mode.output': 'prefers-color-scheme: dark ile ekran görüntüsü.',
  'browserUse.action.generate_styleguide.output': 'Renkler, tipografi ölçeği, yarıçap ve gölgelerle tek sayfalık stil kılavuzu.',
  'browserUse.action.extract_html.output': 'script, noscript veya satır içi olay öznitelikleri olmayan temiz, kendi kendine yeten HTML.',
  'browserUse.action.extract_component_inventory.output': 'Tekrarlanan bileşen kalıpları, seçiciler, sayılar ve ekran görüntüleri.',
  'browserUse.action.extract_copy.output': 'Başlıklar, CTA\'lar, gövde metni ve açıklamalar copy.md ve copy.json olarak.',
  'browserUse.action.extract_nav.output': 'Birincil gezinme ve alt bilgi bağlantıları sitemap.md ve nav.json olarak.',
  'browserUse.action.extract_forms.output': 'Form alanları, etiketler, doğrulama ipuçları ve gönderme eylemleri forms.json olarak.',
  'browserUse.action.run_project.output': 'Browser sekmesinde açılan algılanan dev sunucusu URL\'si.',
  'browserUse.action.detect_project.output': 'Framework, paket yöneticisi, kurulum komutu, dev komutu ve port.',
  'browserUse.action.page_info.output': 'URL, başlık, açıklama, OG görseli, tema rengi, favicon ve viewport.',
  'browserUse.action.snapshot.output': 'Etiket, etiket adı, href ve koordinatlarla 120\'ye kadar görünür etkileşimli ve metin öğesi.',
  'browserUse.action.navigate.output': 'Sayfayı aç ve page_info döndür.',
  'browserUse.action.click.output': 'İlk eşleşen öğeyi görünüme kaydırdıktan sonra tıkla.',
  'browserUse.action.type_text.output': 'Bir girişi doldur ve input ile change olaylarını gönder.',
  'browserUse.action.scroll.output': 'Mevcut ve maksimum kaydırma konumu.',
  'browserUse.action.extract_og_metadata.output': 'Meta başlık, açıklama, kanonik URL, OG/Twitter kartları, sosyal görsel ve tema rengi.',
  'browserUse.action.terminal_run.output': 'stdout, stderr ve çıkış kodu.',
  'browserUse.action.terminal_run_background.output': 'Arka plan görevi kimliği ve son çıktı.',
  'browserUse.action.terminal_read.output': 'Son paylaşılan terminal çıktısı.',
  'chat.designToolbox.title': 'Tasarım araç kutusu',
  'chat.designToolbox.tooltip': 'Tasarım araç kutusu',
  'chat.designToolbox.aria': 'Tasarım araç kutusunu aç',
  'chat.designToolbox.searchPlaceholder': 'Skill / MCP / eklenti / connector / tasarım dosyası ara...',
  'chat.designToolbox.searchAria': 'Tasarım araç kutusu kaynaklarını ara',
  'chat.designToolbox.followupSection': 'Takip',
  'chat.designToolbox.resourcesSection': 'Global kaynaklar',
  'chat.designToolbox.selected': 'Seçili',
  'chat.designToolbox.noResources': '"{query}" için kaynak bulunamadı.',
  'chat.designToolbox.badge.video': 'Video',
  'chat.designToolbox.badge.image': 'Görsel',
  'chat.designToolbox.badge.motion': 'Hareket',
  'chat.designToolbox.badge.polish': 'Cila',
  'chat.designToolbox.action.auto-match.title': 'Sonraki adımı eşleştir',
  'chat.designToolbox.action.auto-match.badge': 'Eşleştir',
  'chat.designToolbox.action.auto-match.description': 'Önce beğeni çıtasını tanımlayın, ardından skill\'leri, MCP\'yi, eklentileri, connector\'ları ve dosyaları eşleştirin.',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': 'Animasyon / hareket ekle',
  'chat.designToolbox.action.motion.badge': 'Hareket',
  'chat.designToolbox.action.motion.description': 'Mevcut HTML veya sayfa öğesine giriş, kaydırma, durum geçişi ve mikro etkileşim hareketi ekleyin.',
  'chat.designToolbox.action.motion-polish.title': 'Hareketi cilala',
  'chat.designToolbox.action.motion-polish.badge': 'Zamanlama',
  'chat.designToolbox.action.motion-polish.description': 'Mevcut hareketin zamanlamasını, yumuşatmasını, performansını ve azaltılmış hareket geri dönüşlerini incele.',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Yapay zeka hissini kaldır',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Zevk',
  'chat.designToolbox.action.anti-ai-polish.description': 'Şablon hissini, yapay zeka gradyanlarını, ucuz kart yığınlarını ve belirsiz metni kaldır.',
  'chat.designToolbox.action.visual-polish.title': 'Tasarım cilası / yayına hazır',
  'chat.designToolbox.action.visual-polish.badge': 'Cila',
  'chat.designToolbox.action.visual-polish.description': 'Görsel hiyerarşiyi, tipografiyi, boşlukları, duyarlı davranışı, erişilebilirliği ve teslimat kalitesini denetle.',
  'chat.designToolbox.action.image-gen.title': 'Görsel / görsel referans oluştur',
  'chat.designToolbox.action.image-gen.badge': 'Görsel',
  'chat.designToolbox.action.image-gen.description': 'Mevcut sayfa için bölüm referansları, varlıklar, ikonlar, sosyal görseller veya bir ilham panosu oluştur.',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': 'Video / hareket senaryosu oluştur',
  'chat.designToolbox.action.video-gen.badge': 'Video',
  'chat.designToolbox.action.video-gen.description': 'Tasarımı kısa bir videoya, Remotion / Hyperframes storyboard\'una veya oluşturmaya hazır bir prompt\'a dönüştür.',
  'chat.designToolbox.kind.skill': 'Beceri',
  'chat.designToolbox.kind.plugin': 'Eklenti',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'MCP şablonu',
  'chat.designToolbox.kind.connector': 'Bağlayıcı',
  'chat.designToolbox.kind.designFile': 'Tasarım dosyası',
  'chat.designToolbox.context.browser': 'Tarayıcı',
  'chat.designToolbox.context.designFiles': 'Tasarım dosyaları',
  'chat.designToolbox.context.designSystem': 'Tasarım sistemi',
  'chat.designToolbox.context.folder': 'Klasör',
  'chat.designToolbox.context.terminal': 'Terminal',
  'chat.designToolbox.context.sideChat': 'Yan sohbet',
  'chat.designToolbox.context.liveArtifact': 'Canlı artifact',
  'chat.designToolbox.context.file': 'Dosya',
  'chat.designToolbox.prompt.contextGeneric': 'Geçerli hedef: şu anda açık olan HTML / tasarım dosyası / web öğesi.',
  'chat.designToolbox.prompt.contextSpecific': 'Geçerli hedef: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Düzenleyicide zaten var olan amacı koru: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Seçili skill: {skill}. Bu turda birincil iş akışı olarak kullan.',
  'chat.designToolbox.prompt.noSkill': 'Belirli bir skill eşleşmediyse, önce mevcut skill\'ler, MCP, plugin\'ler, connector\'lar ve tasarım dosyalarından en iyi kombinasyonu seç.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Creative Director orkestratörü olarak hareket et ve bir tasarım iş akışını tamamla:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Önce "iyi görünen tasarım"ın ne anlama geldiğini tanımlayın: hedef kitle, iş hedefi, marka hissi, stil referansları, bilgi yoğunluğu, renk/tipografi/hareket/varlık standartları ve kaçınılması gereken AI/şablon kalıpları.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Yukarıdaki tam kaynak dizinini ara ve eşleştir. Yalnızca tasarım araç kutusu önerilerini kullanma; faydalı olduğunda skill\'leri, MCP\'yi, plugin\'leri, connector\'ları ve tasarım dosyalarını birleştir.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Akışı şu sırayla tamamla: teşhis -> stil yönü -> kaynak seçimi -> somut düzenleme/oluşturma -> doğrulama. Her adımda, bu kaynakların neden seçildiğini ve sırada neyin onaylanması gerektiğini açıkla.',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': 'Mevcut hareketin zamanlamasını, yumuşatmasını, performansını ve erişilebilirliğini incele ve cilala. Ani, ucuz veya okunabilirliğe zarar veren animasyonu kaldır; gerektiğinde daha rafine bir zaman çizelgesi kullan.',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'Yapay zeka hissine karşı bir cilalama turu yap: şablonlaşmış düzenleri, ucuz gradyanları/parıltıları, anlamsız kart yığınlarını ve belirsiz metni kaldır. Bilgiyi koru ve gerçek bir tasarımcının teslim ettiği hissini ver.',
  'chat.designToolbox.prompt.visualPolish': 'Bu tasarımı yayına hazır olana kadar cilala: hiyerarşiyi, tipografiyi, boşlukları, duyarlı davranışı, buton durumlarını, boş/yükleniyor/hata durumlarını ve erişilebilirliği kontrol et; en önemli sorunları doğrudan düzelt.',
  'chat.designToolbox.prompt.imageGen': 'Bu tasarım için bir sonraki görsel varlık planını oluştur: bölüm referansları, hero varlıkları, illüstrasyonlar, ikonlar, sosyal görseller veya bir ilham panosu. Önce hangi tür görselin eksik olduğuna karar ver, ardından yürütülebilir oluşturma prompt\'ları / dosya planı sağla.',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': 'Bu tasarımı videoya yönlendir: kısa video storyboard\'u, Hyperframes / Remotion kare yapısı veya Sora/fal\'a hazır bir prompt oluştur. Mevcut HTML / sayfa içeriğinin doğal olarak çekimlere dönüşmesini tercih et.',
  'chat.designToolbox.prompt.useSkill': 'Geçerli tasarımda {skill} kullan.',
  'chat.designToolbox.prompt.skillInstruction': 'Önce en iyi takip hedefine karar ver, ardından somut bir tur tamamla. Harici varlıklara veya API\'lere bağlıysa, çalıştırılabilir bir geri dönüş sağla ya da neyi sağlamam gerektiğini belirt.',
  'chat.designToolbox.prompt.selectedResource': 'Seçili kaynak: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Kaynak açıklaması: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Bu plugin\'i geçerli tasarım akışı için ana bağlam olarak kullan. Girdiler veya GenUI açığa çıkarıyorsa, gerektiğinde seçim yapmam için bana rehberlik et; hedefe uymuyorsa, daha iyi bir global kaynak seç ve nedenini açıkla.',
  'chat.designToolbox.prompt.mcpResource': 'Sonraki tasarım adımı için bu MCP yeteneğini tercih et. Harici varlıklar, web yakalama, görsel/video oluşturma veya veri gerektiğinde, önce işi yapıp yapamayacağına karar ver, ardından yürütülebilir bir plan sun.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Bu MCP yapılandırılabilir bir şablondur. Bu tasarım adımı için en faydalı araçsa, önce kuruluma rehberlik et; yapılandırılmış bir alternatif varsa, o alternatifle devam et.',
  'chat.designToolbox.prompt.connectorResource': 'Gerçek veri, varlık, hesap içeriği veya harici iş akışı erişimi gerektiğinde bu connector\'ı kullan. Kullanmadan önce, neyin okunacağını veya yazılacağını açıkla ve uygun olduğunda onay iste.',
  'chat.designToolbox.prompt.fileResource': 'Bu tasarım dosyasını geçerli tasarım hedefi veya referans varlık olarak kullan ve sonraki adımı buradan tamamla. Diğer dosyaların karşılaştırılması gerekiyorsa, tüm tasarım dosyalarında aramaya devam et.',
  'chat.designToolbox.prompt.resourceIndex': 'Global kaynak dizini: skill\'ler({skills}), plugin\'ler({plugins}), MCP({mcpEnabled} etkin / {mcpTemplates} şablon), connector\'lar({connectors} bağlı), tasarım dosyaları({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Aranabilir skill\'ler',
  'chat.designToolbox.prompt.searchablePlugins': 'Aranabilir plugin\'ler',
  'chat.designToolbox.prompt.availableMcp': 'Kullanılabilir MCP',
  'chat.designToolbox.prompt.connectedConnectors': 'Bağlı connector\'lar',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Referans tasarım dosyaları',
  'chat.designToolbox.prompt.mcpTemplateName': '{name} şablonu',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} daha',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Bahsetme yüzeyleri',
  'chat.mentionTabAll': 'Tümü',
  'chat.mentionTabTabs': 'Sekmeler',
  'chat.mentionTabPlugins': 'Eklentiler',
  'chat.mentionTabSkills': 'Beceriler',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Bağlayıcılar',
  'chat.mentionTabFiles': 'Tasarım dosyaları',
  'chat.mentionNoResults': '"{query}" için sonuç yok.',
  'chat.mentionSearchPrompt': 'Tasarım dosyaları, sekmeler, eklentiler, beceriler, MCP sunucuları ve bağlayıcılar arasında arama yapın.',
  'chat.mentionSectionTabs': 'Sekmeler',
  'chat.mentionSectionPlugins': 'Eklentiler',
  'chat.mentionSectionSkills': 'Beceriler',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Bağlayıcılar',
  'chat.mentionSectionFiles': 'Tasarım dosyaları',
  'chat.mentionActiveSkill': 'Etkin',
  'chat.mentionUseMcpTitle': '{name} kullan',
  'chat.mentionUseConnectorTitle': '{name} kullan',
  'chat.mentionPluginOfficial': 'Resmi',
  'chat.mentionPluginMine': 'Eklentim',
  'chat.linkedFolderRemoveAria': 'Bağlantılı klasörü kaldır {path}',
  'chat.linkedFolderNotFound': 'Klasör mevcut değil',
  'chat.linkedFolderAlready': 'Bu klasör zaten bağlantılı',
  'chat.linkedFolderPickError': 'Klasör seçici açılamadı',
  'chat.queuedHeader': 'Sıraya alındı',
  'chat.queuedToSend': 'Gönderilecek',
  'chat.queuedEditQueuedTaskAria': 'Sıradaki görevi düzenle',
  'chat.queuedSave': 'Kaydet',
  'chat.queuedCancel': 'İptal',
  'chat.queuedReorder': 'Yeniden sıralamak için sürükleyin',
  'chat.queuedEdit': 'Düzenle',
  'chat.queuedMore': 'sırada daha fazla',
  'chat.queuedFollowUpFallback': 'Sıraya alınan takip',
  'chat.send': 'Gönder',
  'chat.stop': 'Durdur',
  'chat.removeAria': '{name}’ı sil',
  'chat.example1Title': 'Editörlük sunum dosyası',
  'chat.example1Tag': 'Magazin',
  'chat.example1Prompt': '10 slaytlık bir editoryal pitch deck: seed yatırım turu için fon arayan bir tasarım stüdyosu — İsviçre grid yerleşimi, büyük serif başlıklar ve kalın drop cap’ler, monospace bölüm numaraları, geniş negatif alan kullanımı ve metin yoğun slaytlarla dönüşümlü tam sayfa (full-bleed) fotoğraf slaytları. Kapak, vizyon, pazar, ürün, traction, ekip, talep, iletişim.',
  'chat.example2Title': 'SaaS analitik gösterge paneli',
  'chat.example2Tag': 'Veri',
  'chat.example2Prompt': 'Geliştirici araçlarına yönelik bir SaaS için yoğun bir analitik gösterge paneli: haftadan haftaya değişimleri gösteren KPI şeridi, üst üste yerleştirilmiş iki çizgi grafik (MRR ve aktif çalışma alanları), kullanımın dünya ısı haritası, cohort retention grid’i, en iyi müşteriler liderlik tablosu ve gerçek zamanlı olay akışı. Karanlık tema, tabular monospace rakamlar, sparkline vurguları.',
  'chat.example3Title': 'Yıllık rapor uzun kaydırma',
  'chat.example3Tag': 'Editoryal',
  'chat.example3Prompt': 'İklim odaklı bir sivil toplum kuruluşu için etkileşimli bir yıllık rapor: büyük alıntı blokları, veri görselleştirmeleri (yığılmış çubuk grafikler, animasyonlu sayaçlar, proje sahalarını gösteren choropleth harita), fotoğraf geçişleri, bağışçı duvarı ve finalde bir call-to-action içeren uzun kaydırmalı editoryal yerleşim. Modern serif gövde metni, grafik etiketlerinde sans-serif, toprak tonlarında kâğıt paleti.',
  'chat.example4Title': 'Ürün motion videosu',
  'chat.example4Tag': 'Motion',
  'chat.example4Prompt': 'Bir üretkenlik app lansmanı için 15 saniyelik motion video storyboardu oluştur: açılış hooku, UI yakın planları, kinetik tipografi, özellik geçişleri, kapanış logo ve CTA. Zamanlama, sahne açıklamaları, kamera hareketleri ve ekran yazılarını ekle.',
  'preview.usePlugin': 'Eklentiyi kullan',
  'preview.usePluginOnly': 'Prompt olmadan kullan',
  'preview.usePluginOnlyDesc': 'Ornek promptu yuklemeden eklenti yapisini kullan',
  'preview.replicateContent': 'Kullan',
  'preview.replicateContentDesc': 'Ornek promptu kullanarak onizlemeyi yeniden olustur',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'Bu ornegi duzenlenebilir yeni bir proje olarak remixle',
  'preview.shareMenu': 'Paylaş',
  'preview.exportMenu': 'Dışa aktar',
  'preview.shareTemplateBadge': 'Şablon',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Şablon bağlantısını kopyala',
  'preview.copyShareText': 'Paylaşım metnini kopyala',
  'preview.shareSocialGroup': 'Sosyal medyada paylaş',
  'preview.shareCopyGroup': 'Kopyala',
  'preview.shareExportGroup': 'Dosyaları dışa aktar',
  'preview.shareCopied': 'Kopyalandı',
  'preview.shareCopyFailed': 'Kopyalama başarısız',
  'preview.shareTextDefault': 'DANIA Studio şablonu: {title}',
  'preview.openInNewTab': 'Yeni sekmede aç',
  'preview.exit': '⤓ Çık',
  'preview.fullscreen': '⤢ Tam ekran',
  'preview.closeTitle': 'Kapat (Esc)',
  'preview.loading': '{label} yükleniyor…',
  'preview.errorTitle': 'Bu örnek yüklenemedi.',
  'preview.errorBody': 'Örnek HTML\'i alınamadı. DANIA Studio\'ın çalıştığından emin olup tekrar deneyin.',
  'preview.retry': 'Tekrar dene',
  'preview.unavailableTitle': '{noun} için birlikte gelen bir önizleme yok.',
  'preview.unavailableBody': 'Sohbette istemini çalıştırarak {kind} çıktısı üretin.',
  'preview.nounSkill': 'bu yetenek',
  'preview.nounPlugin': 'bu eklenti',
  'preview.nounTemplate': 'bu şablon',
  'preview.showSidebar': '{label} göster',
  'preview.hideSidebar': '{label} gizle',
  'misc.savedTemplate': 'Kaydedilmiş şablonlar',
  'misc.primary': 'Birincil',
  'misc.designSystem': 'Tasarım sistemi',
  'workspace.designFiles': 'Tasarım Dosyaları',
  'workspace.focusMode': 'Çalışma alanına odaklan',
  'workspace.showChat': 'Sohbeti göster',
  'workspace.closeTab': 'Sekmeyi kapat',
  'workspace.deleteFileConfirm': '"{name}"ı proje klasöründen sil?',
  'workspace.deleteSelectedFilesConfirm': 'Seçili {n} dosya proje klasöründen silinsin mi?',
  'workspace.deleteSelectedFilesPartial': '{n} dosya silinemedi.',
  'workspace.openFromDesignFiles': 'bir dosya aç',
  'workspace.designFilesLink': 'Tasarım Dosyaları',
  'workspace.loadingSketch': 'Taslak yükleniyor…',
  'workspace.newTab': 'Yeni sekme',
  'workspace.searchFilesPlaceholder': 'Search files…',
  'workspace.openTabs': 'Sekmeleri aç',
  'workspace.openFile': 'Open a file',
  'workspace.noFilesMatch': 'No files match',
  'workspace.allFiles': 'All',
  'workspace.createNew': 'Create new',
  'workspace.tabOpen': 'Open',
  'workspace.sideChatContextBanner': 'Integrated context from the current conversation',
  'workspace.sideChatDefaultTitle': 'Side chat',
  'workspace.newTerminal': 'New Terminal',
  'workspace.newTerminalDescription': 'Open a shell in the project directory in a new tab',
  'workspace.newBrowser': 'Yeni Tarayıcı',
  'workspace.newBrowserDescription': 'Referans siteleri ve tarayıcı görevleri için yerleşik bir tarayıcı sekmesi açın',
  'workspace.newSketchDescription': 'Ajana tasarım bağlamı vermek için kaba düzenler ve notlar çizin',
  'workspace.terminalStarting': 'Terminal başlatılıyor…',
  'workspace.terminalStartingDescription': 'Proje kabuğu hazırlanıyor. Genellikle birkaç saniye sürer.',
  'workspace.terminalSessionEnded': 'Oturum sona erdi',
  'workspace.terminalReconnecting': 'Yeniden bağlanılıyor…',
  'workspace.terminalStartFailed': 'Terminal oturumu başlatılamadı',
  'workspace.terminalRestart': 'Yeniden başlat',
  'designFiles.title': 'Tasarım Dosyaları',
  'designFiles.upload': 'Dosyaları yükle',
  'designFiles.pasteText': 'Metin dosyası olarak yapıştır',
  'designFiles.newSketch': 'Yeni taslak',
  'designFiles.empty': 'Eserler burada görünecek',
  'designFiles.refresh': 'Yenile',
  'designFiles.delete': 'Sil',
  'designFiles.searchPlaceholder': 'Dosyaları ara…',
  'designFiles.up': 'Yukarı',
  'designFiles.back': 'Geri',
  'designFiles.crumbs': 'proje',
  'designFiles.rowMenu': 'Sıra menüsü',
  'designFiles.openInTab': 'Sekmede aç',
  'designFiles.download': 'İndir',
  'designFiles.downloadSelected': '{n} dosyayı ZIP olarak indir',
  'designFiles.deleteSelected': '{n} sil',
  'designFiles.clearSelection': 'Seçimi temizle',
  'designFiles.selectPage': 'Sayfadaki tümünü seç',
  'designFiles.selectAll': 'Tümünü seç',
  'designFiles.dropTitle': '⤓ Dosyaları buraya sürükleyin',
  'designFiles.dropDesc': 'Görseller, dokümanlar, referanslar, veya klasörler — ajan onları bağlam olarak kullanacak.',
  'designFiles.dropLabel': 'Dosyaları buraya bırakın',
  'designFiles.upload.title': 'Dosyaları yükleyin',
  'designFiles.paste.title': "Create document",
  'designFiles.upload.label': 'Yükle',
  'designFiles.paste.label': "Create document",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what DANIA Studio should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The DANIA Studio agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask DANIA Studio to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': 'Aç',
  'designFiles.previewClose': 'Önizlemeyi kapat',
  'designFiles.modified': 'Düzenlendi: {time} · {size}',
  'designFiles.weeksAgo': '{n} hafta önce',
  'designFiles.groupBy': 'Grupla',
  'designFiles.groupByKind': 'Tür',
  'designFiles.groupByModified': 'Değiştirilme',
  'designFiles.filterBy': 'Türe göre filtrele',
  'designFiles.filterClear': 'Temizle',
  'designFiles.filterCount': '{n} tür',
  'designFiles.expandGroup': 'Genişlet',
  'designFiles.collapseGroup': 'Daralt',
  'designFiles.sectionPages': 'Sayfalar',
  'designFiles.sectionScripts': 'Betikler',
  'designFiles.sectionImages': 'Görseller',
  'designFiles.sectionSketches': 'Taslaklar',
  'designFiles.sectionLiveArtifacts': 'Canlı yapılar',
  'designFiles.sectionOther': 'Diğer',
  'designFiles.modifiedToday': 'Bugün',
  'designFiles.modifiedYesterday': 'Dün',
  'designFiles.modifiedPrevious7Days': 'Son 7 gün',
  'designFiles.modifiedPrevious30Days': 'Son 30 gün',
  'designFiles.modifiedOlder': 'Daha eski',
  'designFiles.showMore': '+{n} tane daha göster',
  'designFiles.kindHtml': 'HTML sayfası',
  'designFiles.kindImage': 'Görsel',
  'designFiles.kindSketch': 'Taslak',
  'designFiles.kindText': 'Metin',
  'designFiles.kindCode': 'Betil',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Doküman',
  'designFiles.kindPresentation': 'Sunum',
  'designFiles.kindSpreadsheet': 'Elektronik tablo',
  'designFiles.kindLiveArtifact': 'Canlı yapı',
  'designFiles.kindBinary': 'İkili',
  'designFiles.kindFolder': 'Klasör',
  'designFiles.folderCount': '{n} dosya',
  'designFiles.newFolderTitle': 'Yeni klasör',
  'designFiles.newFolderLabel': 'Klasör adı',
  'designFiles.moveTitle': 'Klasöre taşı',
  'designFiles.moveLabel': 'Hedef klasör',
  'designFiles.moveRoot': 'Proje kökü',
  'designFiles.moveNewFolder': 'Yeni klasör…',
  'designFiles.move': 'Taşı',
  'designFiles.copyPath': 'Yolu kopyala',
  'designFiles.copiedPath': 'Yol kopyalandı',
  'designFiles.copyLocalPath': 'Yerel dosya yolunu kopyala',
  'designFiles.copiedLocalPath': 'Yerel dosya yolu kopyalandı',
  'designFiles.deleteFolderConfirm': '"{name}" klasörü ve tüm içeriği silinsin mi?',
  'designFiles.folderCreated': '"{name}" klasörü oluşturuldu',
  'designFiles.folderDeleted': '"{name}" klasörü silindi',
  'designFiles.filesMoved': '{n} öğe {dest} klasörüne taşındı',
  'designFiles.colName': 'Ad',
  'designFiles.colKind': 'Tür',
  'designFiles.colModified': 'Değiştirilme',
  'designFiles.perPage': 'Göster',
  'designFiles.all': 'Tümü',
  'designFiles.prev': 'Önceki',
  'designFiles.next': 'Sonraki',
  'designFiles.jumpToPage': 'Sayfaya git',
  'designFiles.pageInfo': '{start}–{end} / {total}',
  'designFiles.sectionFolders': 'Klasörler',
  'designFiles.sectionStylesheets': 'Stil sayfaları',
  'designFiles.sectionDocuments': 'Belgeler',
  'designFiles.kindStylesheet': 'Stil sayfası',
  'designFiles.modifiedExt': 'Değiştirilme {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Faydalı bilgiler',
  'designFiles.usefulInfoTip': 'Herhangi bir dosyayı tam sekmede açmak için çift tıklayın.',
  'designFiles.usefulInfoTip2': 'Bir dosyayı bağlam olarak eklemek için sohbete @ yazın.',
  'designFiles.usefulInfoTip4': 'Bir tasarım sistemi seçin; sonuçlar markanıza uygun olsun.',
  'designFiles.usefulInfoTip5': 'Fikriniz mi yok? Ana sayfadaki Topluluk bölümünden bir eklenti şablonu deneyin.',
  'designFiles.usefulInfoTip6': 'Soru veya öneriniz mi var? Discord sunucumuza katılın.',
  'designFiles.usefulInfoTip7': 'Beğendiyseniz GitHub üzerinde bize yıldız verin.',
  'designFiles.usefulInfoTip8': 'Yenilikler için X üzerinde DANIA hesabını takip edin.',
  'designFiles.usefulInfoTip9': 'Görselleri, dokümanları veya klasörleri bu panele sürükleyin; ajan onları bağlam olarak kullanır.',
  'designFiles.usefulInfoTip10': 'Yeni eskiz ile kaba bir düzen çizin, ajan onu tasarıma dönüştürsün.',
  'designFiles.usefulInfoTip11': 'Önizlemede herhangi bir ögeyi seçip yorum bırakın; ajan hedefli düzenleme yapar.',
  'designFiles.usefulInfoTip12': 'Sonucu beğenmediniz mi? Ögeyi işaretlemek yeniden anlatmaktan hızlıdır.',
  'designFiles.usefulInfoTip13': 'Tasarımları tek tıkla PDF, görsel veya bağımsız HTML olarak dışa aktarın.',
  'designFiles.usefulInfoTip14': 'Projeden memnun musunuz? Paylaş menüsünden şablon olarak kaydedin.',
  'designFiles.usefulInfoTip15': 'Dağıtımdan sonra sosyal medya paylaşım kartlarını hemen oluşturun.',
  'designFiles.usefulInfoTip16': 'Perde arkası gelişmeler için Threads\'te @opendesign.ai hesabını takip edin.',
  'designFiles.usefulInfoTip17': 'Tasarım ilhamı için Instagram\'da @opendesign.ai hesabını takip edin.',
  'designFiles.usefulInfoTip18': 'Eğitimler ve demolar için YouTube\'da DANIA Studio\'a abone olun.',
  'designFiles.usefulInfoTip19': 'Ürün haberleri için LinkedIn\'de DANIA Studio\'ı takip edin.',
  'designFiles.usefulInfoTip20': 'İpuçları ve ilham için Xiaohongshu\'da DANIA Studio\'ı takip edin.',
  'quickSwitcher.placeholder': 'Dosya aç…',
  'quickSwitcher.empty': 'Bu projede dosya yok',
  'quickSwitcher.noMatches': 'Eşleşme yok',
  'quickSwitcher.navigate': 'gezin',
  'quickSwitcher.open': 'aç',
  'quickSwitcher.close': 'kapat',
  'pasteDialog.title': 'Metin yapıştır',
  'pasteDialog.hint': 'Proje klasörüne kaydedilir. Herhangi bir isim seçin.',
  'pasteDialog.fileNameLabel': 'Dosya adı',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': 'İçerik',
  'pasteDialog.contentPlaceholder': 'Herhangi bir şey yapıştırın…',
  'pasteDialog.save': 'Kaydet',
  'pasteDialog.cancel': 'İptal et',
  'sketch.save': 'Taslağı kaydet',
  'sketch.cancel': 'İptal et',
  'sketch.saving': 'Kaydediliyor…',
  'sketch.saved': 'Kaydedildi',
  'sketch.tooltipMainMenu': 'Ana menü: kaydetme, dışa aktarma, yardım ve tuval ayarları',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': 'Kaydedilmemiş değişiklikler',
  'sketch.tooltipClean': 'Kaydedildi',
  'fileViewer.empty': 'Görüntülemek için bir dosya seçin.',
  'fileViewer.loading': 'Yükleniyor…',
  'fileViewer.exportPptx': 'PPTX olarak dışa aktar',
  'fileViewer.openInNewTab': 'Yeni sekmede aç',
  'fileViewer.copyPath': 'Yolu kopyala',
  'fileViewer.copied': 'Kopyalandı!',
  'fileViewer.share': 'Paylaş',
  'fileViewer.binaryMeta': 'İkili · {size}',
  'fileViewer.binaryNote': 'Binary dosyası ({size} bytes). İncelemek için indirin veya diskten seçin.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Doküman',
  'fileViewer.presentationMeta': 'Sunum',
  'fileViewer.spreadsheetMeta': 'Elektronik tablo',
  'fileViewer.previewUnavailable': 'Önizleme mevcut değil. İncelemek için indirin veya diskten seçin.',
  'fileViewer.download': 'İndir',
  'fileViewer.open': 'Aç',
  'fileViewer.imageMeta': 'Görsel · {size}',
  'fileViewer.reactMeta': 'React bileşeni · {size}',
  'fileViewer.sketchMeta': 'Taslak · {size}',
  'fileViewer.markdownStreamingMeta': 'Önizleme yayınlanıyor…',
  'fileViewer.markdownErrorMeta': 'Önizleme eksik olabilir (oluşturma hatası).',
  'fileViewer.markdownStreamingStatus': 'Yayınlanıyor… kısmi markdown gösteriliyor.',
  'fileViewer.markdownErrorStatus': 'Oluşturma hatası. Son mevcut içerik gösteriliyor.',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': 'Video · {size}',
  'fileViewer.audioMeta': 'Ses · {size}',
  'fileViewer.reload': 'Yeniden yükle',
  'fileViewer.reloadDisk': 'Diskten yeniden yükle',
  'fileViewer.copy': 'Kopyala',
  'fileViewer.copyTitle': 'Dosya içeriklerini kopyala',
  'fileViewer.saveDisabled': 'Kaydet (salt-okunur görüntüleyici)',
  'fileViewer.save': 'Kaydet',
  'fileViewer.preview': 'Önizle',
  'fileViewer.source': 'Kaynak',
  'fileViewer.tweaks': 'Düzenlemeler',
  'fileViewer.tweaksUnavailable': 'Bu artefaktta düzenleme paneli yok',
  'fileViewer.jsxModuleTitle': 'Bağımsız önizleme yok',
  'fileViewer.jsxModuleBody': 'Bu dosya başka bir sayfa tarafından yüklenen bir bileşen modülüdür.',
  'fileViewer.jsxModuleCta': 'Onu işleyen sayfayı açın:',
  'fileViewer.comment': 'Yorum',
  'fileViewer.edit': 'Düzenle',
  'fileViewer.draw': 'Çiz',
  'fileViewer.mark': 'İşaretle',
  'fileViewer.markTool': 'İşaretleme aracı',
  'fileViewer.boxSelect': 'Kutu seçimi',
  'fileViewer.screenshot': 'Ekran görüntüsü',
  'fileViewer.versions.entry': 'Sürümler',
  'fileViewer.versions.title': 'Sürümler',
  'fileViewer.versions.countOne': '1 sürüm',
  'fileViewer.versions.countMany': '{count} sürüm',
  'fileViewer.versions.current': 'Geçerli',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'Sürüm {version}',
  'fileViewer.versions.listAria': 'Dosya sürümleri',
  'fileViewer.versions.loading': 'Sürümler yükleniyor...',
  'fileViewer.versions.empty': 'Henüz sürüm yok.',
  'fileViewer.versions.loadFailed': 'Sürümler yüklenemedi.',
  'fileViewer.versions.previewFailed': 'Bu sürüm önizlemesi yüklenemedi.',
  'fileViewer.versions.previewLoading': 'Sürüm önizlemesi yükleniyor...',
  'fileViewer.versions.noPrompt': 'Kaydedilmiş prompt yok',
  'fileViewer.versions.noPromptBody': 'Bu sürüm için prompt kaydedilmedi.',
  'fileViewer.versions.promptTitle': 'Prompt',
  'fileViewer.versions.copyPrompt': 'Promptu kopyala',
  'fileViewer.versions.fullscreen': 'Tam ekran önizleme',
  'fileViewer.versions.open': 'Önizlemeyi aç',
  'fileViewer.versions.currentHelp': 'Bu zaten geçerli sürüm.',
  'fileViewer.versions.restoreHelp': 'Geçiş, bu HTML’i yeni geçerli sürüm olarak geri yükler.',
  'fileViewer.versions.restore': 'Bu sürüme geç',
  'fileViewer.versions.restoreConfirmTitle': 'Bu sürüme geçilsin mi?',
  'fileViewer.versions.restoreConfirmCta': 'Geç',
  'fileViewer.versions.restoring': 'Geçiliyor...',
  'fileViewer.versions.restoreFailed': 'Bu sürüme geçilemedi.',
  'fileViewer.versions.restoreSuccess': 'Bu sürüme geçildi.',
  'manualEdit.layers': 'Katmanlar',
  'manualEdit.editableCount': '{count} düzenlenebilir',
  'manualEdit.hiddenBadge': 'Gizli',
  'manualEdit.title': 'Manuel düzenleyici',
  'manualEdit.fallbackTitle': 'Düzenle',
  'manualEdit.movePanel': 'Düzenleme panelini taşı',
  'manualEdit.editParams': 'Parametreleri düzenle',
  'manualEdit.closePanel': 'Düzenleme panelini kapat',
  'manualEdit.selectLayer': 'Bir katman seç',
  'manualEdit.empty': 'Önizlemede bir öğeye tıklayın veya bir katman seçin.',
  'manualEdit.noEditableLayers': 'Düzenlenebilir katman bulunamadı.',
  'manualEdit.noClass': 'sınıf yok',
  'manualEdit.tabsAria': 'Manuel düzenleme sekmeleri',
  'manualEdit.tabContent': 'İçerik',
  'manualEdit.tabStyle': 'Stil',
  'manualEdit.tabAttributes': 'Öznitelikler',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'Kaynak',
  'manualEdit.attributesJson': 'Öznitelikler JSON',
  'manualEdit.selectedHtml': 'Seçili öğenin HTML\'si',
  'manualEdit.fullSource': 'Tam yapı kaynağı',
  'manualEdit.applyContent': 'İçeriği Uygula',
  'manualEdit.applyStyle': 'Stili Uygula',
  'manualEdit.applyAttributes': 'Öznitelikleri Uygula',
  'manualEdit.applyHtml': 'HTML Uygula',
  'manualEdit.applySource': 'Kaynağı Uygula',
  'manualEdit.invalidAttributes': 'Geçersiz öznitelikler JSON\'u.',
  'manualEdit.changes': 'Değişiklikler',
  'manualEdit.undo': 'Geri al',
  'manualEdit.redo': 'Yinele',
  'manualEdit.noChanges': 'Henüz manuel düzenleme yok.',
  'manualEdit.imageUrl': 'Görsel URL\'si',
  'manualEdit.altText': 'Alternatif metin',
  'manualEdit.label': 'Etiket',
  'manualEdit.text': 'Metin',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Metin rengi',
  'manualEdit.background': 'Arka plan',
  'manualEdit.fontSize': 'Yazı tipi boyutu',
  'manualEdit.weight': 'Kalınlık',
  'manualEdit.align': 'Hizala',
  'manualEdit.padding': 'İç boşluk',
  'manualEdit.margin': 'Dış boşluk',
  'manualEdit.radius': 'Yarıçap',
  'manualEdit.border': 'Kenarlık',
  'manualEdit.width': 'Genişlik',
  'manualEdit.minHeight': 'Min. yükseklik',
  'manualEdit.deleteElement': 'Öğeyi sil',
  'manualEdit.deleteElementConfirm': 'Seçili öğe silinsin mi? Bu işlem Geri Al ile geri alınabilir.',
  'manualEdit.uploadImage': 'Görsel yükle',
  'manualEdit.uploadingImage': 'Görsel yükleniyor…',
  'manualEdit.uploadImageFailed': 'Görsel yüklenemedi.',
  'manualEdit.focusSlides': 'Slaytlara odaklan',
  'manualEdit.showPanels': 'Panelleri göster',
  'fileViewer.zoomOut': 'Yakınlaş',
  'fileViewer.zoomIn': 'Uzaklaş',
  'fileViewer.resetZoom': 'Uzaklığı sıfırla',
  'fileViewer.viewportAria': 'Görüntü alanını önizle',
  'fileViewer.viewportDesktop': 'Masaüstü',
  'fileViewer.viewportDesktopTitle': 'Tam genişlikte masaüstü önizlemesi',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': '820 × 1180 boyutunda tablet önizlemesi (modern dikey taban çizgisi)',
  'fileViewer.viewportMobile': 'Mobil',
  'fileViewer.viewportMobileTitle': '390 × 844 boyutunda mobil önizleme',
  'fileViewer.reloadAria': 'Yeniden yükle',
  'fileViewer.previousSlide': 'Önceki slayt',
  'fileViewer.nextSlide': 'Sonraki slayt',
  'fileViewer.slideNavAria': 'Slayt hareketi',
  'fileViewer.present': 'Sun',
  'fileViewer.presentInTab': 'Bu pencerede sun',
  'fileViewer.presentFullscreen': 'Tam ekran',
  'fileViewer.presentNewTab': 'Yeni sekme',
  'fileViewer.exitPresentation': 'Sunumdan ayrıl',
  'fileViewer.shareLabel': 'Paylaş',
  'fileViewer.shareMenuShareLink': 'PAYLAŞ',
  'fileViewer.shareMenuPublishOnline': 'ÇEVRİMİÇİ YAYINLA',
  'fileViewer.shareMenuDownload': 'İNDİR',
  'fileViewer.shareMenuPresentation': 'Sunum',
  'fileViewer.shareMenuSourceFiles': 'Kaynak dosyalar',
  'fileViewer.shareMenuSave': 'KAYDET',
  'fileViewer.copyShareLink': 'Paylaşım bağlantısını kopyala',
  'fileViewer.openSharePage': 'Paylaşım sayfasını aç',
  'fileViewer.shareLinkRequiresDeploy': 'Bağlantı almak için önce çevrimiçi yayınla',
  'fileViewer.shareLinkPublishGuide': 'Paylaşımı etkinleştirmek için yukarıda çevrimiçi yayınla ↑',
  'fileViewer.shareAfterGenerationComplete': 'Oluşturma tamamlandıktan sonra paylaşılabilir',
  'fileViewer.deployDania': 'Kendi DANIA Studio’ma dağıt',
  'fileViewer.deployDaniaBusy': 'Dania VPS\'inize dağıtılıyor…',
  'fileViewer.deployDaniaSuccess': 'Dağıtıldı: {url}',
  'fileViewer.deployDaniaSuccessNoUrl': 'Dania VPS\'inize dağıtıldı',
  'fileViewer.deployDaniaOficial': 'DANIA Official’a dağıt',
  'fileViewer.deployDaniaOficialBusy': 'DANIA Official’a dağıtılıyor…',
  'fileViewer.copyProviderLink': '{provider} bağlantısını kopyala',
  'fileViewer.copyCloudflareLink': 'Cloudflare bağlantısını kopyala',
  'fileViewer.screenshotCopying': 'Ekran görüntüsü kopyalanıyor...',
  'fileViewer.screenshotCopied': 'Ekran görüntüsü panoya kopyalandı',
  'fileViewer.screenshotClipboardDenied': 'Tarayıcı pano erişimini engelledi',
  'fileViewer.screenshotPreviewLoading': 'Önizleme hâlâ yükleniyor. Birazdan tekrar deneyin.',
  'fileViewer.screenshotCaptureFailed': 'Önizleme yakalanamadı. Lütfen tekrar deneyin.',
  'fileViewer.exportPdf': 'PDF olarak dışa aktar',
  'fileViewer.exportPdfAllSlides': 'PDF olarak dışa aktar (tüm slaytlar)',
  'fileViewer.exportPptxBusy': 'Güncel sıranın bitmesini bekleyin.',
  'fileViewer.exportPptxHint': 'Bu tasarımı PPTX’e dönüştürmesi için ajana bir istek yollayın.',
  'fileViewer.exportPptxNa': 'PPTX dışa aktarma burada mevcut değil.',
  'fileViewer.exportZip': 'ZIP olarak indir',
  'fileViewer.exportHtml': 'Tekil HTML olarak dışa aktar',
  'fileViewer.exportMd': 'Markdown olarak dışa aktar',
  'fileViewer.exportImage': 'Görsel olarak dışa aktar',
  'fileViewer.exportPptxImages': 'PPTX olarak dışa aktar (görseller)',
  'fileViewer.exportPptxEditable': 'PPTX olarak dışa aktar (düzenlenebilir)',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': 'Dışa aktarılıyor…',
  'fileViewer.exportSlideProgress': '{current}/{total} slayt dışa aktarılıyor…',
  'fileViewer.exportingElapsed': 'Dışa aktarılıyor… {seconds}sn',
  'fileViewer.exportSlideEta': '{current}/{total} slayt · ~{seconds}sn kaldı',
  'fileViewer.exportFailed': 'Dışa aktarma başarısız. Lütfen tekrar deneyin.',
  'fileViewer.exportDone': 'Dışa aktarma tamamlandı',
  'fileViewer.exportImageFailed': 'Görsel yakalama başarısız oldu. Lütfen tekrar deneyin veya tarayıcınızın ekran görüntüsü aracını kullanın.',
  'fileViewer.exportImageModalSubtitle': 'Bir biçim seçin, ardından geçerli önizlemeyi resim olarak indirin.',
  'fileViewer.exportImageFormatLabel': 'Biçim',
  'fileViewer.exportImageSaving': 'Görsel kaydediliyor…',
  'fileViewer.exportImageSaved': 'Görsel kaydedildi',
  'fileViewer.exportImageDownloadStarted': 'İndirme başladı',
  'fileViewer.exportImageDownloadDetails': 'Farklı Kaydet penceresi görünmediyse {filename} tarayıcı indirmelerinde.',
  'fileViewer.exportJsx': 'JSX olarak dışa aktar',
  'fileViewer.exportReactHtml': 'Önizlemeyi HTML olarak dışa aktar',
  'fileViewer.exportStarted': 'Dışa aktarma başlatıldı',
  'fileViewer.saveAsTemplate': 'Şablon olarak kaydet…',
  'fileViewer.savingTemplate': 'Şablon kaydediliyor…',
  'fileViewer.savedTemplate': '"{name}" olarak kaydedildi',
  'fileViewer.savedTemplateFail': 'Şablon olarak kaydedilemedi — yeniden deneyin.',
  'fileViewer.templateNamePrompt': 'Şablon ismi',
  'fileViewer.templateNameDefault': 'Başlıksız şablon',
  'fileViewer.templateDescPrompt': 'Kısa açıklama (opsiyonel — bu şablonu kullanışlı yapan ne?)',
  'liveArtifact.refresh.button': 'Yenile',
  'liveArtifact.refresh.buttonTitle': 'Bu canlı yapıtı yenile',
  'liveArtifact.refresh.loadingTitle': 'Canlı yapı öğesi yükleniyor…',
  'liveArtifact.refresh.noSourceTitle': 'Henüz kullanılabilir bir yenileme kaynağı yok.',
  'liveArtifact.refresh.running': 'Yenileniyor…',
  'liveArtifact.refresh.runningMessage': 'Veriler ve önizleme yenileniyor. Bu biraz zaman alabilir.',
  'liveArtifact.refresh.runningAction': 'Yenileme başarılı olana kadar önceki önizleme görünür kalır.',
  'liveArtifact.refresh.successOne': 'Yenileme tamamlandı. Veriler güncellendi.',
  'liveArtifact.refresh.successMany': 'Yenileme tamamlandı. Veriler güncellendi.',
  'liveArtifact.refresh.successAction': 'Önizleme, en son işlenen verilerle yeniden yüklendi.',
  'liveArtifact.refresh.previousFailure': 'Önceki yenileme başarısız oldu: {message}',
  'liveArtifact.refresh.failureAction': 'Yenileme geçmişini inceleyin, kaynak veya izin sorununu giderin, ardından tekrar deneyin.',
  'liveArtifact.refresh.networkFailure': 'Yenileme isteği başarısız oldu. Bağlantınızı kontrol edip tekrar deneyin.',
  'liveArtifact.refresh.genericFailure': 'Yenileme başarısız oldu.',
  'liveArtifact.refresh.statusNever': 'Yenilenemez',
  'liveArtifact.refresh.statusReady': 'Yenilemeye hazır',
  'liveArtifact.refresh.statusSucceeded': 'Güncel',
  'liveArtifact.refresh.statusFailed': 'Yenileme başarısız oldu',
  'liveArtifact.refresh.statusRunning': 'Yenileniyor',
  'liveArtifact.refresh.statusRunningDescription': 'Şu anda bir yenileme işlemi sürüyor.',
  'liveArtifact.refresh.statusSucceededDescription': 'Son yenileme başarıyla tamamlandı.',
  'liveArtifact.refresh.statusFailedDescription': 'Son yenileme denemesi başarıyla tamamlanmadı.',
  'liveArtifact.refresh.statusReadyDescription': 'Yenilenebilir kaynaklar yapılandırıldı ancak sürmekte olan bir işlem yok.',
  'liveArtifact.refresh.statusNeverDescription': 'Bu canlı yapıtın henüz bir yenileme kaynağı yok.',
  'liveArtifact.refresh.eventStarted': 'Başlatıldı',
  'liveArtifact.refresh.eventSucceeded': 'Başarılı oldu',
  'liveArtifact.refresh.eventFailed': 'Başarısız oldu',
  'liveArtifact.refresh.eventStartedDetail': 'Yenileme başlatıldı…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} kaynak güncellendi',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} kaynak güncellendi',
  'liveArtifact.refresh.timelineEmpty': 'Bu oturumda henüz yenileme etkinliği yok. Bir zaman çizelgesi kaydetmek için Yenile\'yi tetikleyin ya da otomatik işlemleri bekleyin.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Son yenileme',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Hiçbir zaman',
  'liveArtifact.refresh.justNow': 'az önce',
  'liveArtifact.refresh.factCreated': 'Oluşturuldu',
  'liveArtifact.refresh.factLastUpdated': 'Son güncelleme',
  'liveArtifact.refresh.factUnknown': 'Bilinmiyor',
  'liveArtifact.refresh.persistedTitle': 'Kalıcı yenileme geçmişi',
  'liveArtifact.refresh.persistedHint': 'refreshes.jsonl dosyasından yüklenen kayıtlar',
  'liveArtifact.refresh.persistedEmpty': 'Henüz kalıcı yenileme geçmişi yok.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'başarılı',
  'liveArtifact.refresh.persistedStatusRunning': 'çalışıyor',
  'liveArtifact.refresh.persistedStatusFailed': 'başarısız',
  'liveArtifact.refresh.persistedStatusCancelled': 'iptal edildi',
  'liveArtifact.refresh.persistedStatusSkipped': 'atlandı',
  'liveArtifact.refresh.sessionTitle': 'Oturum etkinliği',
  'liveArtifact.refresh.sessionHint': 'Bu sekme açıkken gözlemlenen olaylar',
  'liveArtifact.refresh.docSourceTitle': 'Belge kaynağı',
  'liveArtifact.refresh.docSourceHint': 'Kaynak yapılandırıldı',
  'liveArtifact.refresh.docSourceType': 'Tür',
  'liveArtifact.refresh.docSourceTool': 'Araç',
  'liveArtifact.refresh.docSourceConnector': 'Bağlayıcı',
  'liveArtifact.refresh.debugSummary': 'Gelişmiş hata ayıklama meta verileri',
  'liveArtifact.refresh.debugNote': 'Connector kimliklerini, dosya adlarını, kaynak meta verilerini ve dahili yapı yollarını içerebilir.',
  'liveArtifact.viewer.tabPreview': 'Önizleme',
  'liveArtifact.viewer.tabCode': 'Kod',
  'liveArtifact.viewer.tabData': 'Veri',
  'liveArtifact.viewer.tabRefreshHistory': 'Yenileme geçmişi',
  'liveArtifact.viewer.dataEmpty': 'Kullanılabilir data.json önbelleği yok.',
  'liveArtifact.viewer.code.templateHeading': 'Şablon HTML',
  'liveArtifact.viewer.code.renderedHeading': 'Oluşturulan HTML',
  'liveArtifact.viewer.code.templateHelp': 'Önizlemeyi oluşturmak için data.json ile kullanılan düzenlenebilir şablon.',
  'liveArtifact.viewer.code.renderedHelp': 'Önizleme tarafından şu anda yüklenen oluşturulmuş index.html.',
  'liveArtifact.viewer.code.variantAria': 'Kod varyantı',
  'liveArtifact.viewer.code.variantTemplate': 'Şablon',
  'liveArtifact.viewer.code.variantRendered': 'Oluşturuldu',
  'liveArtifact.viewer.code.loading': 'Kod yükleniyor…',
  'liveArtifact.viewer.code.unavailable': 'Kod henüz kullanılamıyor.',
  'liveArtifact.viewer.code.empty': 'Bu kod dosyası boş.',
  'fileViewer.deployToVercel': 'Vercel’e yayınla',
  'fileViewer.redeployToVercel': 'Yeniden yayınla',
  'fileViewer.deployingToVercel': 'Vercel’e yayınlanıyor…',
  'fileViewer.deployProviderLabel': 'Yayınlama sağlayıcısı',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': '{provider}’e yayınla',
  'fileViewer.redeployToProvider': '{provider}’e yeniden yayınla',
  'fileViewer.deployingToProvider': '{provider}’e yayınlanıyor…',
  'fileViewer.preparingPublicLink': 'Herkese açık bağlantı hazırlanıyor…',
  'fileViewer.copyDeployLink': 'Bağlantıyı kopyala',
  'fileViewer.deployModalTitle': 'Yayınla',
  'fileViewer.deployModalSubtitle': 'Bu HTML önizlemesini seçilen sağlayıcı hesabıyla yayınlayın.',
  'fileViewer.vercelToken': 'Vercel tokeni',
  'fileViewer.vercelTokenGetLink': 'Vercel tokenini al',
  'fileViewer.vercelTokenPlaceholder': 'Vercel tokeninizi yapıştırın',
  'fileViewer.vercelTokenReuseHint': 'Kaydedilmiş token kullanılacak. Değiştirmek için yeni bir token girin.',
  'fileViewer.vercelTokenRequired': 'Önce bir Vercel tokeni girin ve kaydedin.',
  'fileViewer.cloudflareApiToken': 'Cloudflare API tokeni',
  'fileViewer.cloudflareApiTokenGetLink': 'API tokenini al',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Cloudflare API tokeninizi yapıştırın',
  'fileViewer.cloudflareApiTokenReuseHint': 'Kaydedilmiş Cloudflare API tokeni kullanılacak. Değiştirmek için yeni bir token girin.',
  'fileViewer.cloudflareApiTokenRequired': 'Önce bir Cloudflare API tokeni girin ve kaydedin.',
  'fileViewer.cloudflareApiTokenScopeHint': 'API tokeni oluştururken Pages Edit’i seçin; özel alan adları için Zone Read / DNS Edit gerekir.',
  'fileViewer.vercelTeamId': 'Takım ID',
  'fileViewer.vercelTeamSlug': 'Takım slug’ı',
  'fileViewer.cloudflareAccountId': 'Hesap ID',
  'fileViewer.cloudflareAccountIdHint': 'Hesap ID’sini Cloudflare panosunda bulabilirsiniz.',
  'fileViewer.cloudflareAccountIdRequired': 'Önce Cloudflare Account ID girin ve kaydedin.',
  'fileViewer.cloudflareZoneLabel': 'Alan adı',
  'fileViewer.cloudflareZonePlaceholder': 'Alan adlarını yüklemek için Cloudflare ayarlarını kaydedin',
  'fileViewer.cloudflareZoneRequired': 'Önce bir Cloudflare alan adı seçin.',
  'fileViewer.cloudflareZonesLoading': 'Cloudflare alan adları yükleniyor…',
  'fileViewer.cloudflareZonesRefresh': 'Alan adlarını yenile',
  'fileViewer.cloudflareZonesLoadFailed': 'Cloudflare alan adları yüklenemedi.',
  'fileViewer.cloudflareZonesEmpty': 'Bu hesap için aktif tam Cloudflare alan adı bulunamadı.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Alt alan adı ön eki',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Yalnızca tek bir DNS etiketi kullanın: küçük harfler, rakamlar ve tireler.',
  'fileViewer.cloudflareHostnamePreview': 'Özel alan adı önizlemesi: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'İsteğe bağlı: özel alan adı bağlayın. Boş bırakırsanız yine de bir pages.dev bağlantısı oluşturulur.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Özel alan adı',
  'fileViewer.optional': 'Opsiyonel',
  'fileViewer.vercelPreviewOnly': 'Yayınlanmış içerikler şimdilik yalnızca önizlenebilir.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages yayınları Direct Upload kullanır.',
  'fileViewer.savingConfig': 'Kaydediliyor…',
  'fileViewer.deployConfigSaveFailed': 'Vercel ayarları kaydedilemedi.',
  'fileViewer.deployFailed': 'Yayınlama başarısız oldu. Vercel ayarlarınızı kontrol edin ve yeniden deneyin.',
  'fileViewer.deployProviderConfigSaveFailed': '{provider} ayarları kaydedilemedi.',
  'fileViewer.deployProviderFailed': '{provider} yayını başarısız oldu. Ayarları kontrol edip yeniden deneyin.',
  'fileViewer.deployResultLabel': 'Yayınlanmış URL',
  'fileViewer.deployLinkReady': 'Hazır',
  'fileViewer.deploySuccessToast': 'Yayın başarıyla yüklendi',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Herkese açık link bekleniyor',
  'fileViewer.deployLinkDelayed': 'Site yayınlandı. Sağlayıcı herkese açık bağlantıyı hâlâ hazırlıyor.',
  'fileViewer.deployLinkFailed': 'Özel alan adı başarısız',
  'fileViewer.deployLinkProtectedLabel': 'Yayın koruması etkin',
  'fileViewer.deployLinkProtected': 'Site yayınlandı, ancak bu önizleme bağlantısı kimlik doğrulaması istiyor. Deployment Protection’ı kapatın veya özel alan adı kullanın.',
  'fileViewer.retryLink': 'Şimdi yeniden dene',
  'questionForm.submit': 'Gönder',
  'questionForm.skip': 'Atla',
  'questionForm.locked': 'Cevaplandı',
  'conv.switch': 'Konuşmayı değiştir',
  'conv.label': 'Konuşma',
  'conv.heading': 'Konuşmalar',
  'conv.new': '+ Yeni',
  'conv.empty': 'Henüz konuşma yok.',
  'conv.untitled': 'Başlıksız konuşma',
  'conv.renameTooltip': 'Yeniden adlandırmak için çift tıklayın',
  'conv.delete': 'Konuşmayı sil',
  'conv.deleteConfirm': '"{title}"ı sil? Bu mesajları silecektir.',
  'agentPicker.label': 'Ajan',
  'agentPicker.modeChoose': 'Yürütme modunu seç',
  'agentPicker.localCli': 'Yerel CLI',
  'agentPicker.daemonOff': 'Arka plan servisi kapalı',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Tespit edilmiş bir kod ajanı CLI’ı seçin',
  'agentPicker.noAgents': 'PATH’te ajan yok',
  'agentPicker.notInstalled': 'kurulmadı',
  'agentPicker.rescan': 'Ajanlar için yerel PATH’ı yeniden tara',
  'tool.openInTab': '{name}’ı bir sekmede aç ',
  'tool.open': 'aç',
  'tool.todos': 'Yapılacaklar',
  'tool.todosExpand': 'Görevleri göster',
  'tool.todosCollapse': 'Görevleri gizle',
  'tool.todosDone': 'Tamam',
  'tool.todosDismiss': 'Görev listesini kapat',
  'tool.write': 'Yaz',
  'tool.edit': 'Düzenle',
  'tool.read': 'Oku',
  'tool.delete': 'Sil',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Getir',
  'tool.search': 'Ara',
  'tool.lines': '{n} satır',
  'tool.changeSingular': 'değişiklik',
  'tool.changePlural': 'değişiklikler',
  'tool.in': '{path} yolunda',
  'tool.hide': 'sakla',
  'tool.output': 'çıktı',
  'tool.running': 'çalışıyor…',
  'tool.error': 'hata',
  'tool.done': 'bitti',
  'assistant.role': 'Asistan',
  'assistant.workingLabel': 'Çalışıyor',
  'assistant.doneLabel': 'Bitti',
  'assistant.copyMarkdown': 'Yanıt Markdown\'unu kopyala',
  'assistant.forkConversation': 'Buradan fork et',
  'assistant.forkingConversation': 'Fork ediliyor…',
  'assistant.shareToOpenDesign': 'DANIA Studio\'a paylaş',
  'assistant.shareToOpenDesignBusy': 'Paket hazırlanıyor…',
  'assistant.feedbackPrompt': 'Geri bildirim',
  'assistant.feedbackPositive': 'Yararlı',
  'assistant.feedbackNegative': 'Yararlı değil',
  'assistant.feedbackReasonTitle': 'Nedenini bize bildirin',
  'assistant.feedbackReasonPositiveMatched': 'İsteğimi anladı',
  'assistant.feedbackReasonPositiveVisual': 'İyi görünüyor',
  'assistant.feedbackReasonPositiveUseful': 'Kullanışlı yapı',
  'assistant.feedbackReasonPositiveEasy': 'Düzenlemeye devam etmesi kolay',
  'assistant.feedbackReasonPositiveDesignSystem': 'Tasarım sistemine uydu',
  'assistant.feedbackReasonNegativeMissed': 'İsteğimi kaçırdı',
  'assistant.feedbackReasonNegativeVisual': 'Görsel kalitenin iyileştirilmesi gerekiyor',
  'assistant.feedbackReasonNegativeIncomplete': 'Eksik çıktı',
  'assistant.feedbackReasonNegativeHard': 'Kullanımı zor',
  'assistant.feedbackReasonNegativeDesignSystem': 'Tasarım sistemine uymadı',
  'assistant.feedbackReasonOther': 'Diğer',
  'assistant.feedbackReasonPlaceholder': 'Kısa bir not ekleyin...',
  'assistant.feedbackReasonSubmit': 'Gönder',
  'assistant.emptyResponseLabel': 'Çıktı yok',
  'assistant.emptyResponseMessage': 'Sağlayıcı, metin veya yapı döndürmeden isteği sonlandırdı. Başka bir model ya da sağlayıcı deneyin, kotanızı kontrol edin veya yeniden deneyin.',
  'assistant.unfinishedLabel': 'Bitmemiş işlerle durduruldu',
  'assistant.unfinishedSummary': '{n} görev kaldı',
  'assistant.unfinishedMore': '+{n} daha',
  'assistant.continueRemaining': 'Kalan görevleri sürdür',
  'chat.resumeRunCta': 'Çalıştırmayı sürdür',
  'assistant.outTokens': '{n} çıktı',
  'assistant.producedFiles': 'Bu çalışmadan dosyalar',
  'assistant.openFile': 'Aç',
  'assistant.downloadFile': 'İndir',
  'nextStep.title': 'Sonraki adım',
  'nextStep.more': 'Daha fazla',
  'nextStep.share': 'Paylaş',
  'nextStep.download': 'İndir',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': 'Katkıda bulun',
  'nextStep.planGenerateTitle': "Generate from document",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': 'Tasarım oluşturuluyor...',
  'assistant.thinking': 'Düşünüyor',
  'assistant.thought': 'Düşündü',
  'assistant.thoughtFor': '{s}sn düşündü',
  'assistant.systemReminder': 'Sistem hatırlatıcısı',
  'assistant.possiblePromptInjection': 'Olası istem enjeksiyonu',
  'assistant.waitingFirstOutput': 'İlk girdi için bekleniyor',
  'assistant.statusBootingAgent': 'Ajan başlatılıyor',
  'assistant.statusPreparing': 'Hazırlanıyor...',
  'assistant.statusStarting': 'Başlıyor',
  'assistant.statusRequesting': 'İstek gönderiliyor',
  'assistant.statusThinking': 'Düşünüyor',
  'assistant.statusStreaming': 'Yayınlıyor',
  'assistant.slowHint': 'Normalden uzun sürüyor. Form normalde 5–10 saniye içinde görünür — Durabilir ve cümleninizi yeniden gönderebilirsiniz.',
  'assistant.verbEditing': 'Düzenliyor',
  'assistant.verbWriting': 'Yazıyor',
  'assistant.verbReading': 'Okuyor',
  'assistant.verbSearching': 'Arıyor',
  'assistant.verbRunning': 'Çalıştırıyor',
  'assistant.verbTodos': 'Yapılacaklar',
  'assistant.verbFetching': 'Getiriyor',
  'assistant.verbCalling': 'Çağırıyor',
  'qf.answered': 'cevapladı',
  'qf.choose': 'Se.…',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.required': 'gerekli',
  'qf.lockedSubmitted': 'Cevaplar gönderildi — ajan bunları oturum sonuna kadar kullanıyor.',
  'qf.lockedPrev': 'Bu form önceki bir çalışmadan.',
  'qf.hint': 'Uyanı seçin. Önemsemediğiniz opsiyonel alanları atlayın — ajan mantıklı varsayılan değerler kullanacak.',
  'qf.submitDefault': 'Cevapları gönder',
  'qf.submitDisabledTitle': 'Önce gerekli alanları doldurun',
  'qf.submitTitle': 'Cevapları gönder',
  'qf.cardSelected': 'seçildi',
  'qf.cardRefs': 'Referanslar:',
  'qf.cardSampleText': 'Pijamalı hasta yağız şoföre çabucak güvendi · 0123',
  'questions.tabLabel': 'Sorular',
  'questions.banner': 'Birkaç kısa soru sormamın sakıncası var mı?',
  'questions.bannerAnswered': 'Sorular yanıtlandı',
  'questions.continue': 'Devam et',
  'questions.generating': 'Sorular oluşturuluyor…',
  'questions.skipAll': 'Tümünü atla',
  'questions.autoSkipHint': 'Zamanlayıcı bittiğinde otomatik olarak devam eder',
  'sketch.toolSelect': 'Seç (işlem yok)',
  'sketch.toolPen': 'Kalem',
  'sketch.toolText': 'Metin',
  'sketch.toolRect': 'Dörtgen',
  'sketch.toolArrow': 'Ok',
  'sketch.toolEraser': 'Silgi',
  'sketch.color': 'Renk',
  'sketch.strokeSize': 'Fırça boyutu',
  'sketch.undo': 'Geri al',
  'sketch.clear': 'Temizle',
  'sketch.close': 'Kapat',
  'sketch.closeConfirm': 'Eskizi kapatıp kaydedilmemiş değişiklikleri silelim mi?',
  'sketch.textPrompt': 'Metin:',
  'sketch.textModalTitle': 'Metin ekle',
  'critiqueTheater.userFacingName': 'Tasarım Jürisi',
  'critiqueTheater.roleDesigner': 'Tasarımcı',
  'critiqueTheater.roleCritic': 'Eleştirmen',
  'critiqueTheater.roleBrand': 'Marka',
  'critiqueTheater.roleA11y': 'Erişilebilirlik',
  'critiqueTheater.roleCopy': 'Metin',
  'critiqueTheater.roundLabel': 'Tur {n}/{m}',
  'critiqueTheater.mustFix': '{n} mutlaka düzeltilmeli',
  'critiqueTheater.composite': 'Bileşik',
  'critiqueTheater.threshold': 'Eşik',
  'critiqueTheater.consensus': 'Uzlaşı',
  'critiqueTheater.interrupt': 'Kesintiye uğrat',
  'critiqueTheater.interrupting': 'Kesintiye uğratılıyor…',
  'critiqueTheater.interrupted': 'Kesintiye uğradı',
  'critiqueTheater.degradedHeading': 'Panel bu çalıştırmada çevrimdışı',
  'critiqueTheater.degradedReasonMalformed': 'Hatalı biçimlendirilmiş panel çıktısı (ayrıştırıcı bloğu reddetti).',
  'critiqueTheater.degradedReasonOversize': 'Panel çıktısı güvenli bayt bütçesini aştı.',
  'critiqueTheater.degradedReasonAdapter': 'Adaptör {adapter} Critique protokolünü desteklemedi.',
  'critiqueTheater.degradedReasonProtocol': 'Adaptör {adapter} desteklenmeyen bir protokol sürümü gönderdi.',
  'critiqueTheater.degradedReasonMissingArtifact': 'Çalıştırma nihai bir çıktı oluşturmadan tamamlandı.',
  'critiqueTheater.replay': 'Yeniden oynat',
  'critiqueTheater.replaySpeed': 'Yeniden oynatma hızı',
  'critiqueTheater.readOnly': 'Salt okunur',
  'critiqueTheater.shippedSummary': '{round}. turda yayınlandı · bileşik {composite}',
  'critiqueTheater.interruptedSummary': '{round}. turda kesintiye uğradı · en iyi bileşik {composite}',
  'critiqueTheater.shippedBadge': 'Yayınlandı',
  'critiqueTheater.belowThresholdBadge': 'Eşiğin altında',
  'critiqueTheater.timedOutBadge': 'Zaman aşımına uğradı',
  'critiqueTheater.failedHeading': 'Çalıştırma başarısız oldu',
  'critiqueTheater.failedReasonCliExit': 'Agent CLI, panel tamamlanamadan sıfırdan farklı bir kodla sonlandı.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Bir tur, zaman bütçesini aştı.',
  'critiqueTheater.failedReasonTotalTimeout': 'Tüm çalıştırma, toplam zaman bütçesini aştı.',
  'critiqueTheater.failedReasonOrchestrator': 'Dahili orkestratör hatası.',
  'critiqueTheater.transcriptEmpty': 'Henüz yeniden oynatılacak bir kayıt yok. Birini kaydetmek için bir kritik çalıştırın.',
  'critiqueTheater.transcriptLoading': 'Döküm yükleniyor…',
  'critiqueTheater.transcriptError': 'Kayıt yüklenemedi: {error}',
  'critiqueTheater.replaySpeedPaused': 'Duraklatıldı',
  'critiqueTheater.replaySpeedInstant': 'Anlık',
  'critiqueTheater.replaySpeedLive': 'Canlı',
  'critiqueTheater.replaySpeedFast': 'Hızlı',
  'critiqueTheater.settingsNav': 'Tasarım Jürisi',
  'critiqueTheater.settingsNavHint': 'Çalıştırmalarınız için beş panelli tasarım incelemesi',
  'critiqueTheater.settingsEnabledLabel': 'Agent çalıştırmaları sırasında Tasarım Jürisi\'ni göster',
  'critiqueTheater.settingsEnabledDescription': 'Etkinleştirildiğinde, agent üretimlerinin yanında beş panelli bir inceleme görünür ve çıktıyı yayınlamadan önce puanlar. İstediğiniz zaman kesintiye uğratabilirsiniz.',
  'critiqueTheater.settingsEnabledProjectHint': 'Bu proje için kaydedildi. Bu projedeki yeni çalıştırmalar sunucu tarafında Tasarım Jürisi üzerinden yönlendirilecek.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Bunu sunucu tarafında kalıcı hale getirmek için bir proje açın. O zamana kadar bu yalnızca tarayıcı içi tercihi değiştirir.',
  'pet.title': 'Evcil Dostlar',
  'pet.subtitle': 'Çalışma alanının üstünde süzülen küçük bir dost edin.',
  'pet.navTitle': 'Evcil Dostlar',
  'pet.navHint': 'Sahiplen veya özelleştir',
  'pet.tabBuiltIn': 'Yerleşik',
  'pet.tabBuiltInHint': 'DANIA Studio ile gelen seçili dostlar — birini seç ve sahiplen.',
  'pet.builtInEmpty': 'Hazır petler şu an kullanılamıyor. Daemon tekrar çevrimiçi olduğunda Topluluk sekmesini yenile.',
  'pet.tabCustom': 'Özel',
  'pet.tabCustomHint': 'Ad, glif, renk veya sprite\'ını kendin belirle.',
  'pet.tabCommunity': 'Topluluk',
  'pet.tabCommunityHint': 'Codex\'te yumurtadan çıkan dostlar — sahiplen ya da yapay zekâ ile yeni bir tane üret.',
  'pet.tabsAria': 'Evcil dost kaynağı',
  'pet.adopt': 'Sahiplen',
  'pet.adoptedBadge': 'Sahiplenildi',
  'pet.adoptCallout': 'Bir evcil dost sahiplen',
  'pet.changePet': 'Dostu değiştir',
  'pet.wake': 'Uyandır',
  'pet.tuck': 'Sakla',
  'pet.wakeTitle': 'Dostu uyandır — kayan paneli göster.',
  'pet.tuckTitle': 'Dostu sakla — kayan paneli gizle.',
  'pet.settingsTitle': 'Evcil dost ayarlarını aç',
  'pet.useCustom': 'Kendi dostumu kullan',
  'pet.customTitle': 'Kendin oluştur',
  'pet.customHint': 'Bir ad, simge ve vurgu rengi seç — panel anında güncellenir.',
  'pet.customGreetingPlaceholder': 'Dostundan bir selam…',
  'pet.fieldName': 'Ad',
  'pet.fieldGlyph': 'Simge',
  'pet.fieldGlyphHint': 'Tek bir emoji en iyisidir (ör. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Selamlama',
  'pet.fieldAccent': 'Vurgu rengi',
  'pet.fieldAccentCustom': 'Özel renk',
  'pet.fieldAccentDefault': 'Varsayılan vurgu rengi',
  'pet.overlayAria': 'Evcil dost yoldaş',
  'pet.spriteAria': '{name} — taşımak için sürükle, sohbet için tıkla',
  'pet.spriteTitle': '{name} merhaba diyor! Sohbet için tıkla.',
  'pet.taskSummarySingle': '{count} agent görevi çalışıyor.',
  'pet.taskSummaryMultiple': '{projects} projede {count} agent görevi çalışıyor.',
  'pet.taskSummaryRecentSingle': '{count} agent görevi yakın zamanda tamamlandı.',
  'pet.taskSummaryRecentMultiple': '{count} agent görevi yakın zamanda tamamlandı.',
  'pet.taskListAria': 'Etkin agent görevleri',
  'pet.taskOpenProject': '{project} aç',
  'pet.taskGroup.running': 'Çalışıyor',
  'pet.taskGroup.queued': 'Bekliyor',
  'pet.taskGroup.recent': 'Yakın zamanda tamamlanan',
  'pet.idleQuote.leonardo.text': 'Öğrenmek zihni asla yormaz.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Mermerde meleği gördüm ve onu özgür bırakana dek yonttum.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'Heykeltıraşa yardımcı olabilecek iki araç vardır: ışık ve gölge.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'İnsan resim yaparken düşünmez.',
  'pet.idleQuote.raphael.author': 'Raphael',
  'pet.idleQuote.caravaggio.text': 'Hangi konuda ya da kim tarafından yapılmış olursa olsun, hayattan yapılıp resmedilmedikçe tüm eserler önemsiz şeylerden ve çocukça ıvır zıvırlardan başka bir şey değildir.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'Asıl önemli olan duygulanmak, sevmek, umut etmek, titremek, yaşamaktır.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Evcil Dostlar — uyandır, sakla veya seç',
  'pet.composerMenuTitle': 'Evcil Dostlar',
  'pet.composerMenuHint': 'ipucu: değiştirmek için /pet yaz',
  'pet.composerOpenSettings': 'Evcil Hayvanları Yönet',
  'pet.welcomeTeaserTitle': 'Bir evcil dost sahiplen',
  'pet.welcomeTeaserBody': 'Çalışma alanın üstünde süzülen küçük bir yoldaş.',
  'pet.welcomeTeaserCta': 'Birini seç',
  'pet.imageUpload': 'Sprite yükle',
  'pet.imageReplace': 'Sprite değiştir',
  'pet.imageRemove': 'Emoji kullan',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF veya SVG. Spritesheet? Yatay bir şerit yükle ve frame sayısını ayarla.',
  'pet.imageHintActive': 'Sprite gösteriliyor. Frame sayısını > 1 yaparak yatay spritesheeti hareket ettir.',
  'pet.fieldFrames': 'Frame',
  'pet.fieldFramesHint': '1 = statik. > 1 = yatay spritesheet.',
  'pet.fieldFps': 'Hız (fps)',
  'pet.fieldFpsHint': 'Frame değişim hızı.',
  'pet.atlasImport': 'Codex sprite\'ı içe aktar',
  'pet.atlasImportTitle': 'hatch-pet 8x9 / 192x208 atlasını (PNG veya WebP) içe aktarın.',
  'pet.atlasPickerTitle': 'Bir animasyon satırı seçin',
  'pet.atlasPickerHint': 'Codex evcilleri 9 animasyon satırı ile gelir. Varsayılan olarak tüm atlası saklarız; böylece evcil hayvan üzerine gelmede, sürükleme yönünde ve uzun boşta kalmada satır değiştirir. Tek bir döngüye de sabitleyebilirsiniz.',
  'pet.atlasCancel': 'Atlası bırak',
  'pet.atlasAdopt': 'Bu satıra sabitle',
  'pet.atlasAdoptFull': 'Tüm atlası kullan (animasyonlu)',
  'pet.atlasAdoptFullTitle': 'Tüm satırları koruyun; böylece evcil hayvan üzerine gelmeye, sürükleme yönüne ve uzun boşta kalmaya tepki verir.',
  'pet.atlasAdoptRowTitle': 'Yalnızca vurgulanan satırı tek döngülü bir şerite kesin.',
  'pet.atlasActiveHint': 'Animasyonlu atlas etkin — evcil hayvan etkileşiminize (üzerine gelme, sürükleme, boşta kalma) göre bir satır seçer.',
  'pet.atlasRow.idle': 'Boşta',
  'pet.atlasRow.running-right': 'Sağa koş',
  'pet.atlasRow.running-left': 'Sola koş',
  'pet.atlasRow.waving': 'El sallama',
  'pet.atlasRow.jumping': 'Zıplama',
  'pet.atlasRow.failed': 'Başarısız',
  'pet.atlasRow.waiting': 'Bekleme',
  'pet.atlasRow.running': 'Koşu',
  'pet.atlasRow.review': 'İnceleme',
  'pet.hatchTitle': 'AI ile yeni pet kuluçkala',
  'pet.hatchHint': 'Sohbette gömülü hatch-pet skill\'ini kullanarak Codex tarzı bir spritesheet üretin, ardından buraya içe aktarın.',
  'pet.hatchConcept': 'Pet konsepti (opsiyonel)',
  'pet.hatchConceptPlaceholder': 'örn. rahat bir kazak giyen küçük piksel-art shiba',
  'pet.hatchCopy': 'Prompt\'u kopyala',
  'pet.hatchCopied': 'Kopyalandı!',
  'pet.hatchFoot': 'Skill petinizi kaydettiğinde geri dönüp "Codex sprite\'ı içe aktar" düğmesine basın.',
  'pet.slashPopoverAria': 'Slash komutları',
  'pet.slashPopoverTitle': 'Komutlar',
  'pet.slashPopoverHint': '↑↓ gez · enter seç · esc kapat',
  'pet.slashPet': 'Peti aç/kapat, evlat edin veya ayarları aç.',
  'pet.slashPetWake': 'Yüzen peti uyandır.',
  'pet.slashPetTuck': 'Peti şimdilik sakla.',
  'pet.slashHatch': 'hatch-pet skill\'i ile bir Codex peti üret.',
  'pet.slashHatchArg': '<konsept>',
  'pet.slashSearch': 'OD research komutuyla web araması yap.',
  'pet.slashSearchArg': '<sorgu>',
  'pet.codexTitle': 'Yeni kuluçkalananlar',
  'pet.codexSubtitle': 'hatch-pet skill\'inin paketlediği petler tek tıkla evlat edinmek için burada görünür.',
  'pet.codexSubtitleWithDir': 'hatch-pet paketleri için {dir} taranıyor.',
  'pet.codexEmpty': 'Henüz kuluçkalanan pet yok. Sohbette /hatch yazarak bir tane üretin.',
  'pet.codexLoading': 'Kuluçkalanan petler aranıyor…',
  'pet.codexRefresh': 'Yenile',
  'pet.codexAdopt': 'Evlat edin',
  'pet.codexAdopting': 'Evlat ediniyor…',
  'pet.communitySync': 'Topluluk petlerini indir',
  'pet.communitySyncing': 'İndiriliyor…',
  'pet.communitySyncTitle': 'Codex Pet Share + j20 Hatchery üzerindeki en yeni petleri ~/.codex/pets/ altına eşitle.',
  'pet.communitySyncDone': '{wrote} yeni pet eşitlendi (toplam {total}).',
  'pet.communitySyncFailed': 'Eşitleme başarısız: {error}',
  'pet.codexBundled': 'Yerleşik',
  'pet.codexBundledTitle': 'DANIA Studio ile birlikte gelir — indirme gerekmez.',
  'settings.notifications': 'Bildirimler',
  'settings.notificationsHint': 'Görev tamamlandığında ses ve masaüstü bildirimi',
  'settings.notifyCompletionSound': 'Tamamlanma sesi',
  'settings.notifyCompletionSoundHint': 'Bir tur sona erdiğinde çalar. Varsayılan olarak kapalı.',
  'settings.notifySuccessSound': 'Başarı sesi',
  'settings.notifyFailureSound': 'Hata sesi',
  'settings.notifyDesktop': 'Masaüstü bildirimi',
  'settings.notifyDesktopHint': 'Pencere etkin değilken gönderilir.',
  'settings.notifyDesktopBlocked': 'Tarayıcı bildirimleri engelledi. Site ayarlarından izin verin.',
  'settings.notifyDesktopUnsupported': 'Bu ortamda masaüstü bildirimleri kullanılamıyor.',
  'settings.notifyTest': 'Test gönder',
  'settings.notifyTestSent': 'Test bildirimi gönderildi. Banner görünmezse tarayıcı ve sistem bildirim ayarlarını kontrol edin.',
  'settings.notifyTestFailed': 'Bildirim çağrısı başarısız oldu. Tarayıcı ve sistem bildirim ayarlarını kontrol edin.',
  'settings.notifySoundDing': 'Çın',
  'settings.notifySoundChime': 'Çıngırak',
  'settings.notifySoundTwoToneUp': 'Yükselen iki ton',
  'settings.notifySoundPluck': 'Tıngırtı',
  'settings.notifySoundBuzz': 'Vızıltı',
  'settings.notifySoundTwoToneDown': 'Alçalan iki ton',
  'settings.notifySoundThud': 'Boğuk vuruş',
  'settings.skills': 'Yetenekler',
  'settings.skillsHint': 'Aracının görev sırasında çağırabileceği işlevsel yetenekler',
  'settings.skillsNew': 'Yeni yetenek',
  'settings.skillsEmpty': 'Soldan bir yetenek seçin veya yeni bir yetenek oluşturun.',
  'settings.skillsEdit': 'Düzenle',
  'settings.skillsDelete': 'Sil',
  'settings.skillsDeleteConfirm': 'Silmeyi onayla',
  'settings.skillsName': 'Ad',
  'settings.skillsTriggers': 'Tetikleyiciler (virgül veya yeni satır ile ayrılmış)',
  'settings.skillsDescription': 'Açıklama',
  'settings.skillsBody': 'SKILL.md gövdesi',
  'settings.skillsCreate': 'Oluştur',
  'settings.skillsSave': 'Kaydet',
  'settings.skillsSaving': 'Kaydediliyor…',
  'settings.skillsFiles': 'Dosyalar',
  'settings.skillsNoFiles': 'Bu yetenek klasöründe dosya yok.',
  'settings.skillsNameRequired': 'Beceri adı gereklidir.',
  'settings.skillsBodyRequired': 'Beceri içeriği gereklidir.',
  'settings.designSystems': 'Tasarım sistemleri',
  'settings.designSystemsHint': 'Mevcut tasarım sistemlerini görün ve etkinleştirin',
  'settings.designSystemsInstalled': 'Yüklü',
  'settings.designSystemsAdd': 'Tasarım sistemi ekle',
  'settings.designSystemsHiddenCount': '{count} ana galeriden gizlendi',
  'settings.designSystemsShowAll': 'Tümünü göster',
  'settings.designSystemsShowHidden': 'Gizlenenleri göster',
  'settings.designSystemsSource': 'Kaynak',
  'settings.designSystemsSourceLocal': 'Yerel',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'shadcn kayıt referansı',
  'settings.designSystemsImportShadcn': 'shadcn’den içe aktar',
  'settings.designSystemsStructure': 'Yapı',
  'settings.designSystemsModeHybrid': 'Hibrit',
  'settings.designSystemsModeNormalized': 'Normalize',
  'settings.designSystemsModeVerbatim': 'Olduğu gibi',
  'settings.designSystemsCraft': 'Zanaat',
  'settings.designSystemsCraftColor': 'Renk',
  'settings.designSystemsCraftAccessibility': 'Erişilebilirlik',
  'settings.designSystemsGithubUrl': 'GitHub URL’si',
  'settings.designSystemsProjectPath': 'Proje yolu',
  'settings.designSystemsImportGithub': 'GitHub’dan içe aktar',
  'settings.designSystemsImportProject': 'Projeden içe aktar',
  'settings.designSystemsImportedStatus': '{title} içe aktarıldı',
  'settings.designSystemsViewImported': 'İçe aktarılan tasarım sistemini görüntüle',
  'settings.designSystemsCategory': 'Kategori',
  'settings.designSystemsAllCategories': 'Tüm kategoriler',
  'settings.designSystemsShowInHomeGallery': 'Ana galeride göster',
  'settings.projectLocations': 'Proje konumları',
  'settings.projectLocationsHint': 'Çalışma alanı depolama kökleri',
  'settings.projectLocationsDescription': 'Birden fazla DANIA Studio proje klasörü içerebilen çalışma tabanları ekleyin. Yeni projeler seçilen tabanın içinde bir klasör olarak kaydedilir.',
  'settings.projectLocationsSaveError': 'Proje konumları kaydedilemedi. Her yolun erişilebilir bir klasör olduğunu kontrol edin.',
  'settings.projectLocationsSaved': 'Proje konumları kaydedildi.',
  'settings.projectLocationsScanError': 'Proje konumları taranamadı.',
  'settings.projectLocationsScanComplete': 'Tarama tamamlandı: {imported} içe aktarıldı, {existing} zaten kayıtlı.',
  'settings.projectLocationsNoFolderSelected': 'Klasör seçilmedi.',
  'settings.projectLocationsDuplicate': 'Bu çalışma tabanı zaten eklendi.',
  'settings.projectLocationsWorkBaseMeta': 'Çalışma tabanı · projeler burada alt klasörler olarak oluşturulur',
  'settings.projectLocationsAddFolder': 'Klasör ekle…',
  'settings.projectLocationsDefaultBadge': 'Varsayılan konum',
  'settings.projectLocationsMakeDefault': 'Varsayılan yap',
  'settings.projectLocationsDefaultSaved': 'Varsayılan proje konumu güncellendi.',
  'settings.librarySkills': 'Beceriler',
  'settings.libraryDesignSystems': 'Tasarım sistemleri',
  'settings.librarySearch': 'Ara...',
  'settings.libraryAll': 'Tümü',
  'settings.libraryPreview': 'Önizleme',
  'settings.libraryPreviewClose': 'Kapat',
  'settings.libraryLoading': 'Yükleniyor...',
  'settings.libraryNoResults': 'Aramanızla eşleşen öğe bulunamadı.',
  'settings.libraryEnabled': 'Etkin',
  'settings.libraryDisabled': 'Devre dışı',
  'settings.connectorsNavHint': 'Harici sistem bağlantıları',
  'settings.connectorsHint': 'Bu cihaz için bağlayıcı ve araç sağlayıcı ayarlarını yönetin.',
  'settings.connectorsComposioApiKey': 'Composio API anahtarı',
  'settings.connectorsSavedTitle': 'Yerel daemon’a kaydedildi',
  'settings.connectorsSavedWithTail': 'Kaydedildi · ••••{tail}',
  'settings.connectorsSaved': 'Kaydedildi',
  'settings.connectorsGetApiKey': 'API anahtarı al',
  'settings.connectorsReplaceKeyPlaceholder': 'Kaydedilmiş anahtarı değiştirmek için yeni anahtar yapıştırın',
  'settings.connectorsApiKeyPlaceholder': 'Composio API anahtarını yapıştırın',
  'settings.connectorsClear': 'Temizle',
  'settings.connectorsClearConfirmTitle': 'Kaydedilmiş Composio API anahtarı temizlensin mi?',
  'settings.connectorsClearConfirmBody': 'Anahtarı kaldırmak bu çalışma alanına bağlı tüm Composio bağlayıcılarını koparır. Bağlı hesaplar, OAuth izinleri ve araç erişimleri tamamen kaldırılır.',
  'settings.connectorsClearConfirmContinue': 'Devam et',
  'settings.connectorsClearFinalTitle': 'Bu işlem tüm bağlayıcıların bağlantısını keser',
  'settings.connectorsClearFinalBody': 'Geri alınamaz. Yeni bir anahtar yapıştırdıktan sonra her entegrasyonu sıfırdan yeniden bağlamanız gerekir.',
  'settings.connectorsClearFinalConfirm': 'Anahtarı sil ve bağlantıyı kes',
  'settings.connectorsClearArming': 'Bir saniye…',
  'settings.connectorsClearCancel': 'İptal',
  'settings.connectorsSaveKey': 'Anahtarı kaydet',
  'settings.connectorsSaveKeyTitle': 'Bu anahtarı yerel daemon’a gönder',
  'settings.connectorsKeySaving': 'Kaydediliyor…',
  'settings.connectorsKeySaved': 'Kaydedildi ✓',
  'settings.connectorsKeyError': 'Anahtar kaydedilemedi. Yerel daemon’ın çalıştığını doğrulayın ve tekrar deneyin.',
  'settings.connectorsHelpSaved': 'Anahtarınız aşağıdaki kataloğu açar ve yerel daemon’da kalır. Değiştirmek için yeni anahtar yapıştırın veya kaldırmak için temizleyin.',
  'settings.connectorsHelpUnsaved': 'Kaydedilmemiş değişiklikler — bu kimlik bilgisini yerel daemon’a kaydetmek ve aşağıdaki kataloğu açmak için Anahtarı kaydet’e tıklayın.',
  'settings.connectorsHelpEmpty': 'Aşağıdaki kataloğu açmak için bir anahtar ekleyin. Anahtarlar daemon’da yerel olarak saklanır ve ortam değişkenleriyle gönderilmez.',
  'settings.connectorsLoadingSavedKey': 'Yerel daemon’da kayıtlı anahtar aranıyor…',
  'settings.autosaveSaving': 'Kaydediliyor…',
  'settings.autosaveSaved': 'Tüm değişiklikler kaydedildi',
  'settings.autosaveError': 'Değişiklikler kaydedilemedi. Yerel daemon çevrimdışı olabilir.',
  'settings.libraryToggleLabel': 'Değiştir',
  'settings.memory': 'Bellek',
  'settings.memoryHint': 'Personal facts auto-extracted from chats',
  'settings.customInstructionsTitle': 'Genel kurallar',
  'settings.customInstructionsHint': 'DANIA\'ın her sohbette uyması gereken sabit talimatlar. Gerçekleri, tercihleri ve proje bağlamını bellek olarak kaydedin.',
  'settings.customInstructionsPlaceholder': 'örn. "Her zaman TypeScript kullan. Fonksiyonel bileşenleri tercih et. Yanıtları kısa tut."',
  'settings.memoryDescription': 'Auto-extracted facts about you and your preferences. Saved as Markdown files and folded into every chat.',
  'settings.memoryEnabled': 'Etkin',
  'settings.memoryDisabled': 'Devre dışı',
  'settings.memoryEnableLabel': 'Bellek eklemeyi etkinleştir',
  'settings.memoryDisabledBanner': 'Bellek şu anda KAPALI. Mevcut gerçekler diskte korunur ancak yeni sohbetlere dahil edilmez ve yeni turlar yeni hiçbir şey çıkarmaz.',
  'settings.memoryNew': 'Yeni bellek',
  'settings.memoryEdit': 'Düzenle',
  'settings.memoryDelete': 'Sil',
  'settings.memoryPreview': 'Önizleme',
  'settings.memoryEmpty': 'Henüz bellek yok.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Koyu modu tercih ederim',
  'settings.memoryName': 'Name',
  'settings.memoryDesc': 'One-line description',
  'settings.memoryBody': 'Memory body (Markdown supported)',
  'settings.memoryBodyHint': 'Lead with the rule itself; add Why and How to apply lines.',
  'settings.memoryStartersLabel': 'Başlangıç noktası mı lazım? Formu doldurmak için tıklayın:',
  'settings.memoryStarterUserName': 'Rolüm',
  'settings.memoryStarterUserDesc': 'Bir SaaS tasarım aracı üzerinde çalışan bir frontend mühendisiyim',
  'settings.memoryStarterUserBody': '- Rol: kıdemli frontend mühendisi\n- Stack: React, TypeScript, Vite\n- Alan: tasarım / iş birliği araçları\n- Saat dilimi: GMT+8 (Asia/Shanghai)\n\nNe zaman uygulanır: herhangi bir sohbet — örnekleri web frontend etrafında kurgulayın.',
  'settings.memoryStarterFeedbackName': 'Arayüz tercihleri',
  'settings.memoryStarterFeedbackDesc': 'Koyu mod, büyük gövde metni, düşük bilgi yoğunluğu',
  'settings.memoryStarterFeedbackBody': '- Tema: varsayılan olarak koyu\n- Gövde metni: ≥ 18px\n- Bilgi yoğunluğu: boşluğu tercih edin, ekran başına daha az öğe\n\nNeden: uzun oturumlarda daha az göz yorgunluğu.\nNe zaman uygulanır: ne zaman UI, web sayfaları veya slaytlar oluştursanız.',
  'settings.memoryStarterProjectName': 'Mevcut proje',
  'settings.memoryStarterProjectDesc': 'DANIA Studio v0.5 — sohbet odaklı tasarım editörü',
  'settings.memoryStarterProjectBody': '- Hedef: sohbet odaklı düzenleyiciyi bu çeyrekte yayınlamak\n- Öncelikler: akış tabanlı render, yerel çok modlu, offline-first\n- Stack: Next.js 16, Express daemon, SQLite\n\nNe zaman uygulanır: bu projeyle ilgili her konuşmada.',
  'settings.memorySaveHint': 'Otomatik kaydedilmez — uygulamak için Oluştur / Kaydet\'e tıklayın.',
  'settings.memoryIndexSaveHint': 'Dizindeki düzenlemeler otomatik kaydedilmez — uygulamak için Dizini kaydet\'e tıklayın.',
  'settings.memoryIndexUnsaved': 'Kaydedilmemiş değişiklikler',
  'settings.memoryFlashCreated': '✓ Bellek oluşturuldu',
  'settings.memoryFlashSaved': '✓ Bellek kaydedildi',
  'settings.memoryFlashDeleted': '✓ Bellek silindi',
  'settings.memoryFlashIndexSaved': '✓ Dizin kaydedildi',
  'settings.memoryFlashPathCopied': '✓ Yol kopyalandı',
  'settings.memoryNameLabel': 'Başlık',
  'settings.memoryTypeLabel': 'Tür',
  'settings.memoryDescLabel': 'Açıklama',
  'settings.memoryBodyLabel': 'İçerik',
  'settings.memoryTypeUser': 'Kullanıcı',
  'settings.memoryTypeFeedback': 'Geri bildirim',
  'settings.memoryTypeProject': 'Proje',
  'settings.memoryTypeReference': 'Referans',
  'artifact.odCardTaskBriefChip': 'Bellek uygulandı · özeti gör',
  'artifact.odCardScorecardTitle': 'Öz denetim',
  'artifact.odCardScorecardStatusPass': 'Geçti',
  'artifact.odCardScorecardStatusPartial': 'Kısmen',
  'artifact.odCardScorecardStatusFail': 'Düzeltme gerekiyor',
  'artifact.odCardRuleKicker': 'Önerilen kural',
  'artifact.odCardRuleNameLabel': 'Ad',
  'artifact.odCardRuleDescriptionLabel': 'Açıklama',
  'artifact.odCardRuleAssertionLabel': 'Geçerli olmalı',
  'artifact.odCardRuleCheckLabel': 'Nasıl denetlenir',
  'artifact.odCardRuleRationaleLabel': 'Neden',
  'artifact.odCardRuleKeep': 'Sakla',
  'artifact.odCardRuleEdit': 'Düzenle',
  'artifact.odCardRuleDone': 'Tamam',
  'artifact.odCardRuleDiscard': 'Vazgeç',
  'artifact.odCardRuleSaving': 'Kaydediliyor…',
  'artifact.odCardRuleSaved': '“{name}” kural olarak kaydedildi',
  'artifact.odCardRuleError': 'Kural kaydedilemedi. Tekrar deneyin.',
  'artifact.odCardBrandAssistDone': 'Browser assist confirmed',
  'artifact.odCardBrandAssistKicker': 'Browser assist needed: {reason}',
  'artifact.odCardBrandAssistBody': 'Open Browser and clear any human check. Then click More, choose Download Page, wait for the saved snapshot success, and use the left Next Step card to continue extraction.',
  'artifact.odCardBrandAssistError': 'Could not start browser assist. Try again.',
  'artifact.odCardBrandAssistWorking': 'Starting...',
  'artifact.odCardBrandAssistConfirm': 'Open browser assist',
  'settings.memoryTypeProfile': 'Profil',
  'settings.memoryTypeRule': 'Kural',
  'settings.memoryTabMemories': 'Anılar',
  'settings.memoryTabMemoriesCaption': 'Kaydedilen belleği görüntüleyin ve yönetin',
  'settings.memoryTabHow': 'Nasıl çalışır',
  'settings.memoryTabHowCaption': 'İki döngü ve kontrolleri',
  'settings.memoryAddDisclosure': 'Anı ekleyin veya içe aktarın',
  'settings.memoryAddDisclosureHint': 'Profil, manuel giriş veya bağlı uygulamalar',
  'settings.memoryProfileTab': 'Çalışma profili',
  'settings.memoryProfileTabCaption': 'Kim olduğunuz ve varsayılanlarınız',
  'settings.memoryProfileTitle': 'Çalışma profiliniz',
  'settings.memoryProfileHint':
    'Sizinle ve varsayılanlarınızla ilgili birkaç bilgi. Bellek bunu her görevden önce ekler, böylece ajan kısa bir istekten ne demek istediğinizi çıkarır.',
  'settings.memoryProfileName': 'Çalışma profili',
  'settings.memoryProfileDescription':
    'Asistanın yeniden kullanması gereken rol, şirket, alan, hedef kitle, beğeni ve varsayılanlar.',
  'settings.memoryProfileSave': 'Profili kaydet',
  'settings.memoryProfileSaving': 'Kaydediliyor…',
  'settings.memoryProfileSaved': 'Profil kaydedildi',
  'settings.memoryProfileRole': 'Rol',
  'settings.memoryProfileRolePlaceholder': 'örn. Kurucu, tasarımcı, ürün yöneticisi',
  'settings.memoryProfileCompany': 'Şirket / Ekip',
  'settings.memoryProfileCompanyPlaceholder': 'örn. Acme, büyüme ekibi',
  'settings.memoryProfileDomain': 'Alan',
  'settings.memoryProfileDomainPlaceholder': 'örn. B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'Birincil hedef kitle',
  'settings.memoryProfileAudiencePlaceholder': 'örn. yöneticiler, mühendisler, son kullanıcılar',
  'settings.memoryProfileAesthetic': 'Estetik / beğeni',
  'settings.memoryProfileAestheticPlaceholder':
    'örn. sade ve editöryel, açık arka planlar, bol boşluk',
  'settings.memoryProfileDeliverables': 'Varsayılan çıktılar',
  'settings.memoryProfileDeliverablesPlaceholder': 'örn. açılış sayfaları, sunumlar, tek sayfalıklar',
  'settings.memoryProfileLocale': 'Yerel ayar / Dil',
  'settings.memoryProfileLocalePlaceholder': 'örn. İngilizce (ABD), Basitleştirilmiş Çince',
  'settings.memoryProfileGoals': 'Güncel hedefler',
  'settings.memoryProfileGoalsPlaceholder':
    'örn. yeni fiyatlandırma sayfasını yayına al, deneme akışında dönüşümü artır',
  'settings.memoryHooksTitle': 'Bellek kancaları',
  'settings.memoryHooksHint':
    'Belleğin hangi kısımlarının otomatik çalışacağını seçin. Yukarıdaki ana anahtar hepsini kapatır.',
  'settings.memoryHooksProfileLabel': 'Profilimi kullan',
  'settings.memoryHooksProfileDesc': 'Çalışma profilinizi her göreve ekleyin.',
  'settings.memoryHooksRewriteLabel': 'Kısa istekleri genişlet',
  'settings.memoryHooksRewriteDesc': 'ÖN: kısa bir isteği tam bir görev özetine genişletir.',
  'settings.memoryHooksVerifyLabel': 'Çıktıyı öz-doğrula',
  'settings.memoryHooksVerifyDesc': 'SON: sonucu kurallarınıza göre denetler, ardından bir puan kartı gösterir.',
  'settings.memoryHooksExtractionLabel': 'Sohbetlerden öğren',
  'settings.memoryHooksExtractionDesc': 'Sohbet turlarından yararlı bilgileri ve tercihleri yakalar.',
  'settings.memoryIndex': 'MEMORY.md (dizin)',
  'settings.memoryIndexSave': 'Dizini kaydet',
  'settings.memoryIndexReset': 'Sıfırla',
  'settings.memoryToastChanged': 'Bellek güncellendi',
  'settings.memoryToastClickHint': 'Görüntüle',
  'settings.memoryAll': 'Tümü',
  'settings.memoryExtractions': 'Çıkarım geçmişi',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'Henüz çıkarım yok. Bir sonraki sohbet turu bu listeyi dolduracak.',
  'settings.memoryExtractionsRefresh': 'Yenile',
  'settings.memoryExtractionsRefreshing': 'Yenileniyor…',
  'settings.memoryExtractionPhaseRunning': 'Çalışıyor…',
  'settings.memoryExtractionPhaseSuccess': 'Başarılı',
  'settings.memoryExtractionPhaseSkipped': 'Atlandı',
  'settings.memoryExtractionPhaseFailed': 'Başarısız',
  'settings.memoryExtractionSkipNoProvider': 'LLM bellek çıkarımı için yapılandırılmış API key yok.',
  'settings.memoryExtractionSkipDisabled': 'Bellek devre dışı.',
  'settings.memoryExtractionSkipEmpty': 'Boş kullanıcı mesajı — çıkarılacak bir şey yok.',
  'settings.memoryExtractionSkipNoMatch': 'Bu turda hiçbir regex deseni eşleşmedi.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'medya ayarları',
  'settings.memoryExtractionProviderOverride': 'bellek ayarları',
  'settings.memoryExtractionProposed': 'önerilen',
  'settings.memoryExtractionWritten': 'yazıldı',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Sil',
  'settings.memoryExtractionsClear': 'Temizle',
  'settings.memoryExtractionsClearTitle': 'Tüm çıkarım geçmişini temizle',
  'settings.memoryExtractionsClearConfirm': 'Tüm çıkarım geçmişi temizlensin mi? Bu işlem geri alınamaz.',
  'settings.memoryNoProviderBannerTitle': 'LLM bellek çıkarımı çalışmıyor',
  'settings.memoryNoProviderBannerBody': 'Bellek çıkarıcı için API key bulunamadı. LLM tabanlı çıkarımı etkinleştirmek için Medya sağlayıcıları altına bir OpenAI key ekleyin veya ortamda ANTHROPIC_API_KEY / OPENAI_API_KEY değişkenini ayarlayın. Sezgisel regex çıkarımı hâlâ etkin.',
  'settings.libraryInstall': 'Yükle',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Yerel yol',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Yükle',
  'settings.libraryUninstall': 'Kaldır',
  'settings.libraryBuiltIn': 'Yerleşik',
  'settings.libraryInstalled': 'Yüklü',
  'notify.successTitle': 'Görev tamamlandı',
  'notify.failureTitle': 'Görev başarısız oldu',
  'notify.successBody': 'Bir tur tamamlandı.',
  'notify.failureBody': 'Görev bir hata ile sona erdi.',
  'updater.available': 'Güncelleme mevcut',
  'updater.availableBody': 'DANIA Studio {version} mevcut. Yükleyici açılmadan önce indirilecek.',
  'updater.checking': 'Güncellemeler denetleniyor',
  'updater.download': 'Güncellemeyi indir',
  'updater.downloading': 'Güncelleme indiriliyor',
  'updater.downloadingPercent': 'Güncelleme indiriliyor {percent}%',
  'updater.done': 'Tamam',
  'updater.failed': 'Güncelleme başarısız',
  'updater.installerOpenBody': 'Yükleyici açık. Güncellemeyi tamamlayabilmeniz için DANIA Studio kapatılıyor.',
  'updater.installerOpened': 'Yükleyici açıldı',
  'updater.later': 'Daha sonra',
  'updater.openFailedFallback': 'Yükleyici açılamadı.',
  'updater.installRestart': 'Install and restart',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'Güncellemeyi yükle',
  'updater.opening': 'Yükleyici açılıyor...',
  'updater.payloadReadyGeneric': 'A new DANIA Studio update is ready. DANIA Studio will close and restart automatically.',
  'updater.payloadReadyVersion': 'DANIA Studio {version} is ready. DANIA Studio will close and restart automatically.',
  'updater.quitButton': 'DANIA Studio’dan çık',
  'updater.quitFailedBody': 'Yükleyici açık, ancak DANIA Studio kapatılamadı. Uygulamayı değiştirmeden önce DANIA Studio’dan çıkın.',
  'updater.quitFailedTitle': 'Çıkılamadı',
  'updater.quitting': 'Çıkılıyor...',
  'updater.ready': 'Güncelleme hazır',
  'updater.readyGeneric': 'Yeni bir sürüm hazır. DANIA Studio kapanıp yükleyiciyi açacak.',
  'updater.readyVersion': 'DANIA Studio {version} hazır. DANIA Studio kapanıp yükleyiciyi açacak.',
  'updater.upToDate': 'Zaten en son sürümdesiniz.',
  'newsletter.label': 'Bülten (isteğe bağlı)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'Otomasyon',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Günlük bağlayıcı özeti',
  'settings.orbit.lede': 'Bağlayıcı etkinliğini bir zamanlamaya göre topla ve sonucu yenilenebilir bir live artifact olarak yayımla.',
  'settings.orbit.statusOnTitle': 'Zamanlanmış günlük çalıştırmalar açık',
  'settings.orbit.statusOffTitle': 'Zamanlanmış günlük çalıştırmalar kapalı',
  'settings.orbit.statusActive': 'Aktif',
  'settings.orbit.statusOff': 'Kapalı',
  'settings.orbit.runTitle': 'Bir Orbit çalıştırması başlat ve canlı konuşmayı aç',
  'settings.orbit.running': 'Çalışıyor…',
  'settings.orbit.runOpen': 'Şimdi çalıştır',
  'settings.orbit.dailySummaryTitle': 'Günlük özet',
  'settings.orbit.dailySummarySub': 'Zamanlanan yerel saatte günde bir kez çalışır.',
  'settings.orbit.on': 'Açık',
  'settings.orbit.off': 'Kapalı',
  'settings.orbit.runTimeTitle': 'Çalıştırma zamanı',
  'settings.orbit.runTimeSub': 'Varsayılan 08:00. daemon zamanlamasına uygulamak için kaydet.',
  'settings.orbit.runTimeAria': 'Günlük Orbit çalıştırma zamanı',
  'settings.orbit.nextRun': 'Sonraki çalıştırma',
  'settings.orbit.nextRunScheduledAfterSave': 'Kaydettikten sonra zamanlanır',
  'settings.orbit.schedule': 'Zamanlama',
  'settings.orbit.pausedManualOnly': 'Duraklatıldı — yalnızca manuel çalıştırmalar',
  'settings.orbit.templateTitle': 'Prompt şablonu',
  'settings.orbit.templateMissing': '{id} şablonu yüklü değil.',
  'settings.orbit.templateMissingOption': '{id} (eksik)',
  'settings.orbit.templateMissingInstall': 'Promptu yönlendirmek için bir Orbit skill yükleyin.',
  'settings.orbit.templateMissingPickAnother': 'Açılır menüden başka bir şablon seçin.',
  'settings.orbit.templateResetTitle': '{id} değerine sıfırla',
  'settings.orbit.templateReset': 'Sıfırla',
  'settings.orbit.templateHelp': 'Orbit’i bir skill ile yönlendir — seçilen şablonun örnek promptu her Orbit çalıştırmasına eklenir, böylece özetler o şablonun biçimini izler.',
  'settings.orbit.templateAria': 'Orbit prompt şablonu',
  'settings.orbit.templatesLoading': 'Şablonlar yükleniyor…',
  'settings.orbit.templatesOptgroup': 'Orbit skill şablonları',
  'settings.orbit.lastRun': 'Son çalıştırma',
  'settings.orbit.triggerManual': 'Manuel',
  'settings.orbit.triggerScheduled': 'Zamanlandı',
  'settings.orbit.meterAria': '{checked} kontrolden {succeeded} başarılı, {skipped} atlandı, {failed} başarısız',
  'settings.orbit.countChecked': 'Kontrol edildi',
  'settings.orbit.countSucceeded': 'Başarılı',
  'settings.orbit.countSkipped': 'Atlandı',
  'settings.orbit.countFailed': 'Başarısız',
  'settings.orbit.runError': 'Orbit çalıştırılamadı. Yerel daemon’ın çalıştığından ve bağlayıcıların yapılandırıldığından emin olun.',
  'settings.orbit.gateAriaLabel': 'Orbit’i kullanmak için bağlayıcılar gerekiyor',
  'settings.orbit.gateEyebrow': 'Kurulum gerekli',
  'settings.orbit.gateTitle': 'Orbit’i çalıştırmak için bir araç bağlayın',
  'settings.orbit.gateBody': 'Orbit, bağlayıcılarınızın etkinliğini özetler. Henüz hiçbir şey bağlamadınız — Orbit’in raporlayacak bir şeyi olması için en az bir entegrasyon ekleyin.',
  'settings.orbit.gateBodyNoKey': 'Orbit, bağlayıcılarınızın etkinliğini özetler ve bağlayıcılar Composio üzerinden çalışır. Kataloğu açmak ve ilk entegrasyonunuzu seçmek için Bağlayıcılar bölümüne bir Composio API anahtarı ekleyin.',
  'settings.orbit.gateAction': 'Bağlayıcıları aç',
  'settings.orbit.gateActionNoKey': 'Composio’yu yapılandır',
  'settings.orbit.gateLoading': 'Bağlayıcılarınız kontrol ediliyor…',
  'settings.orbit.controlsLockedBadge': 'Kilitli',
  'settings.orbit.controlsLockedHint': 'Orbit\'in zamanlama ve şablon kontrollerini açmak için bir araç bağlayın.',
  'settings.orbit.artifactKickerLive': 'canlı yapıt',
  'settings.orbit.artifactKickerLegacy': 'Eski özet',
  'settings.orbit.artifactTitle': 'Günlük Orbit etkinlik özeti',
  'settings.orbit.artifactMetaLive': 'Bağlayıcı etkinliğinden oluşturulan yenilenebilir HTML artifact.',
  'settings.orbit.artifactMetaLegacy': 'live artifact desteği etkinleştirilmeden önce oluşturuldu — bir tane yayımlamak için Orbit’i yeniden çalıştırın.',
  'settings.orbit.copyMarkdownTitle': 'Markdown özetini panoya kopyala',
  'settings.orbit.copied': 'Kopyalandı',
  'settings.orbit.copy': 'Kopyala',
  'settings.orbit.openArtifact': 'Artifact aç',
  'settings.orbit.sourceMarkdown': 'Kaynak Markdown',
  'settings.memoryModelInlineHintByokNeutral': 'Bellek, sohbetten ayrı bir model kullanır. Varsayılan olarak sohbet modelinizi kullanır.',
  'diagnostics.exportTitle': 'Tanılama dışa aktar',
  'diagnostics.exportButton': 'Tanılama dışa aktar',
  'diagnostics.exportHint': 'Son uygulama günlüklerini ve makine bilgilerini ekibe gönderebileceğiniz bir zip dosyasında paketler.',
  'diagnostics.exporting': 'Dışa aktarılıyor…',
  'diagnostics.exportSuccess': 'Tanılama {path} konumuna kaydedildi',
  'diagnostics.exportFailed': 'Tanılama dışa aktarılamadı: {message}',
  'automations.eyebrow': 'Zamanlanmış agent oturumları',
  'automations.title': 'Otomasyonlar',
  'automations.lede': 'Proje çalışmaları, Orbit özetleri ve canlı yapılar için yinelenen konuşmalar planlayın.',
  'automations.summaryAria': 'Otomasyon özeti',
  'automations.metricActive': 'Etkin',
  'automations.metricPaused': 'Duraklatıldı',
  'automations.metricTemplates': 'Şablonlar',
  'automations.newAutomation': 'Yeni otomasyon',
  'automations.yourAutomations': 'Otomasyonlarınız',
  'automations.loading': 'Yükleniyor',
  'automations.emptyTitle': 'Henüz otomasyon yok',
  'automations.emptyBody': 'Bir şablondan oluşturun veya boş bir zamanlamayla başlayın.',
  'automations.targetNewEachRun': 'Her çalıştırmada yeni proje',
  'automations.lastRun': 'Son çalıştırma {time}',
  'automations.openResult': 'Sonucu aç',
  'automations.run': 'Çalıştır',
  'automations.runNowTitle': 'Şimdi çalıştır ve konuşmayı aç',
  'automations.history': 'Geçmiş',
  'automations.hideHistory': 'Geçmişi gizle',
  'automations.edit': 'Düzenle',
  'automations.pause': 'Duraklat',
  'automations.resume': 'Sürdür',
  'automations.deleteAria': 'Otomasyonu sil',
  'automations.deleteTitle': 'Bu otomasyonu sil',
  'automations.deleteConfirm': 'Bu otomasyon silinsin mi? Geçmiş çalıştırmalar ve projeleri korunur.',
  'automations.proposalsTitle': 'Evrim önerileri',
  'automations.proposalsSub': 'Otomasyon çıktısını belleği, becerileri veya tasarım sistemlerini değiştirmeden önce inceleyin.',
  'automations.proposalsPending': '{n} beklemede',
  'automations.apply': 'Uygula',
  'automations.reject': 'Reddet',
  'automations.proposalsDismissReason': 'Otomasyonlar\'da yoksayıldı',
  'automations.templatesTitle': 'Şablonlar',
  'automations.templatesSub': 'Orbit ve canlı yapılar, aynı otomasyon akışı içindeki şablonlardır.',
  'automations.templatesCount': '{total} içinden {filtered}',
  'automations.templateFiltersAria': 'Şablon filtreleri',
  'automations.templatesEmptyTitle': 'Bu kategoride henüz şablon yok.',
  'automations.templatesEmptyBody': 'Farklı bir filtre deneyin veya boş bir otomasyondan başlayın.',
  'automations.useTemplate': 'Şablonu kullan',
  'automations.runHistoryLoading': 'Çalıştırma geçmişi yükleniyor...',
  'automations.runHistoryEmpty': 'Henüz çalıştırma yok.',
  'automations.runHistoryTitle': 'Çalıştırma geçmişi',
  'automations.runHistoryLatest': 'Son 10',
  'automations.crystallize': 'Kristalleştir',
  'automations.crystallizing': 'Kristalleştiriliyor',
  'automations.crystallizeTitle': 'Bu çalıştırmadan beceri ve bellek önerileri taslağı oluştur',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'Konuşmayı aç',
  'automations.runHistoryAria': 'Otomasyon çalıştırma geçmişi',
  'automations.proposalsAria': 'Otomasyon evrim önerileri',
  'automations.templatesAria': 'Otomasyon şablonları',
  'automations.runInProgress': 'Sürüyor',
  'automations.scheduleStatusPaused': 'Duraklatıldı',
  'automations.nextRunManualOnly': 'Yalnızca elle',
  'automations.nextRunScheduled': 'Zamanlandı',
  'automations.nextRunAt': 'Sonraki {time}',
  'automations.statusSucceeded': 'Başarılı',
  'automations.statusFailed': 'Başarısız',
  'automations.statusRunning': 'Çalışıyor',
  'automations.statusQueued': 'Sıraya alındı',
  'automations.statusCanceled': 'İptal edildi',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Canlı yapı',
  'automations.kindAutomation': 'Otomasyon',
  'automations.proposalTargetMemory': 'Bellek',
  'automations.proposalTargetDesignSystem': 'Tasarım sistemi',
  'automations.proposalTargetSkill': 'Beceri',
  'automations.proposalTargetTemplate': 'Otomasyon şablonu',
  'automations.proposalActionCreate': 'Oluştur',
  'automations.proposalActionUpdate': 'Güncelle',
  'automations.proposalActionMerge': 'Birleştir',
  'automations.proposalActionMove': 'Taşı',
  'automations.proposalActionDelete': 'Sil',
  'automations.proposalActionPromote': 'Yükselt',
  'automations.filterAll': 'Tümü',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Canlı yapılar',
  'automations.filterMemory': 'Bellek',
  'automations.filterDesignSystems': 'Tasarım sistemleri',
  'automations.filterSkills': 'Beceriler',
  'automations.filterConnectors': 'Bağlayıcılar',
  'automations.filterCompression': 'Sıkıştırma',
  'automations.filterRelease': 'Sürüm',
  'automations.filterQuality': 'Kalite',
  'automations.tpl.memoryRefresh.title': 'Son çalışmalardan proje belleğini yenile.',
  'automations.tpl.memoryRefresh.desc': 'Yinelenen kararları, tercihleri ve geri bildirimleri yeniden kullanılabilir bellek güncellemelerine dönüştürür.',
  'automations.tpl.designSystemRefresh.title': 'Tasarım sistemlerini gönderilen yapılardan güncelle.',
  'automations.tpl.designSystemRefresh.desc': 'Son tasarım çalışmaları genelinde yeniden kullanılabilir token\'ları, bileşenleri ve kuralları bulur.',
  'automations.tpl.liveArtifactRegistry.title': 'Canlı yapıları denetle ve eski sürümleri yenile.',
  'automations.tpl.liveArtifactRegistry.desc': 'Kalıcı panoları, raporları ve önizlemeleri çoğaltmak yerine güncel tutar.',
  'automations.tpl.orbitDashboard.title': 'Bir bağlayıcı etkinlik panosu oluştur.',
  'automations.tpl.orbitDashboard.desc': 'Seçili bağlayıcıları Orbit tarzı bir canlı panoda toplar.',
  'automations.tpl.releaseNotes.title': 'Gönderilen tasarım çalışmasından sürüm notları taslağı oluştur.',
  'automations.tpl.releaseNotes.desc': 'Birleştirilen PR\'leri, yapıları ve ürüne yönelik değişiklikleri sürüm notlarına bağlar.',
  'automations.tpl.qualityRegressionWatch.title': 'Tasarım ve uygulama gerilemelerini izle.',
  'automations.tpl.qualityRegressionWatch.desc': 'Son değişiklikleri kıyaslamalarla, izlerle ve kabul edilen referanslarla karşılaştırır.',
  'automations.tpl.orbitDaily.title': 'Günlük bağlayıcı özeti.',
  'automations.tpl.orbitDaily.desc': 'Bir bağlayıcı etkinlik özetini zamanlanmış olarak yeniler.',
  'automations.tpl.liveStatusBoard.title': 'Canlı bir durum yapısını güncel tut.',
  'automations.tpl.liveStatusBoard.desc': 'Her çalıştırmada yeni bir rapor oluşturmak yerine tek bir kalıcı yapıyı günceller.',
  'dsManager.areaAria': 'Tasarım sistemleri alanı',
  'dsManager.tabDesignSystem': 'Tasarım sistemi',
  'dsManager.tabTemplate': 'Şablon',
  'dsManager.sourceAria': 'Tasarım sistemi kaynağı',
  'dsManager.templateSourceAria': 'Şablon kaynağı',
  'dsManager.yourSystems': 'Sistemleriniz',
  'dsManager.officialPresets': 'Resmi hazır ayarlar',
  'dsManager.enterprise': 'Kurumsal',
  'dsManager.yourTemplates': 'Şablonlarınız',
  'dsManager.yourSystemsAria': 'Tasarım sistemleriniz',
  'dsManager.eyebrowDesignSystems': 'Tasarım Sistemleri',
  'dsManager.yourSystemsHeading': 'Sistemleriniz',
  'dsManager.filterAria': 'Tasarım sistemlerini filtrele',
  'dsManager.filterAll': 'Tümü',
  'dsManager.filterPublished': 'Yayımlandı',
  'dsManager.filterDraft': 'Taslak',
  'dsManager.createTitle': 'Yeni tasarım sistemi oluştur',
  'dsManager.createBody': 'DANIA Studio\'a markanızı, ürününüzü, kodunuzu, varlıklarınızı ve tasarım referanslarınızı öğretin.',
  'dsManager.createAction': 'Oluştur',
  'dsManager.emptyMine': 'Henüz tasarım sistemi yok. Gerçek ürün bağlamından bir tane oluşturun, taslağı inceleyin, ardından gelecekteki projeler için yayımlayın.',
  'dsManager.badgeDefault': 'Varsayılan',
  'dsManager.rowMetaUpdated': 'Siz · güncellendi {date}',
  'dsManager.edit': 'Düzenle',
  'dsManager.openSystem': 'Aç',
  'dsManager.editWithAgent': 'Agent ile düzenle',
  'dsManager.downloadTitle': 'Tasarım sistemini indir (.zip + SKILLS.md)',
  'dsManager.downloadAria': '{title} öğesini .zip olarak indir',
  'dsManager.downloadFailed': 'Tasarım sistemi indirilemedi. Lütfen tekrar deneyin.',
  'dsManager.deleteConfirm': '“{title}” silinsin mi? Bu işlem tasarım sistemi taslağını bu cihazdan kaldırır.',
  'dsManager.makeDefault': 'Varsayılan yap',
  'dsManager.statusPublished': 'Yayımlandı',
  'dsManager.statusDraft': 'Taslak',
  'dsManager.openSystemAria': '{title} öğesini aç',
  'dsManager.deleteSystemAria': '{title} öğesini sil',
  'dsManager.presetsAria': 'Resmi tasarım sistemi hazır ayarları',
  'dsManager.eyebrowLibrary': 'Kitaplık',
  'dsManager.eyebrowTemplates': 'Şablonlar',
  'dsManager.yourTemplatesAria': 'Şablonlarınız',
  'dsManager.emptyTemplates': 'Henüz şablon yok. Şablon yayımlama etkinleştirildiğinde, oluşturulan herhangi bir projeden Paylaş aracılığıyla bir tane oluşturun.',
  'dsManager.templateDescFallback': 'Bir projeden oluşturuldu',
  'dsManager.comingSoonBadge': 'Yakında',
  'dsManager.enterpriseDsTitle': 'Kurumsal tasarım sistemleri',
  'dsManager.enterpriseDsBody': 'Paylaşılan ekip tasarım sistemleri ve yönetişimli marka kitaplıkları yakında geliyor.',
  'dsManager.enterpriseTplTitle': 'Kurumsal şablonlar',
  'dsManager.enterpriseTplBody': 'Ekip onaylı şablonlar ve kuruluş genelinde yayımlama yakında geliyor.',
  'settings.instructionsTitle': 'Yönergeler / Kurallar',
  'settings.instructionsSubtitle': 'Asistanın izlemesi gereken sabit davranış',
  'settings.instructionsNavSub': 'Sabit asistan davranışı',
  'settings.customInstructionsDesc': 'DANIA Studio\'ın her sohbette izlediği sabit yönergeler. Bunlar kayıtlı bellekler değildir; gerçekler, tercihler ve proje bağlamı için Bellek\'i kullanın.',
  'mcpClient.forwardedToLabel': 'İletildiği yer:',
  'mcpClient.notForwardedToLabel': 'İletilmediği yer:',
  'mcpClient.forwardedAcpNote': 'stdio olarak işaretlenen ACP adaptörleri bu listeden yalnızca stdio MCP sunucularını alır; HTTP ve SSE girdileri başlatma sırasında düşürülür.',
  'mcpClient.notForwardedNote': 'Bu agent\'lar için MCP sunucularını agent\'ın kendi yapılandırma dosyasında ayarlayın (ör. ~/.codex/config.toml, ~/.gemini/settings.json); aşağıdaki sunucular orada sessizce kullanılmaz.',

  // Brands library + extraction
  'brand.libraryTitle': 'Marka Kiti',
  'brand.librarySubtitle': 'Teach DANIA Studio your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'Bir web sitesi yapıştır ya da aşağıdan bir marka seç; renklerini, yazı tiplerini ve logosunu çıkaralım.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'Marka Kiti',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'Bir kez oluştur, her yerde inşa et',
  'onboarding.buildBody': 'DANIA Studio markanı yeniden kullanılabilir bir tasarım sistemine dönüştürür ve oluşturduğun her şeyi markaya uygun ve tutarlı tutar.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'Tasarım sistemi oluştur',
  'onboarding.buildHome': 'Ana sayfaya git',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. DANIA Studio first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.heading': 'Sevdiğin bir markadan başla',
  'brandPicker.subtext': 'Kitini doğrudan web sitesinden çıkarmak için herhangi bir markaya tıkla.',
  'brandPicker.quickPicksLabel': 'Popüler markalar — çıkarmak için tıkla',
  'brandPicker.searchPlaceholder': 'Marka ara…',
  'brandPicker.allCategories': 'Tümü',
  'brandPicker.extractAction': 'Çıkar',
  'brandPicker.showMore': 'Daha fazla göster',
  'brandPicker.opening': 'Çıkarma başlatılıyor — {brand} açılıyor…',
  'ds.kitVisualize': 'Görselleştir',
  'ds.kitEdit': 'Düzenle',
  'ds.kitSource': 'Kaynak',
  'ds.saveDesignMd': 'DESIGN.md kaydet',
  'ds.saving': 'Kaydediliyor…',
  'ds.copyDesignMd': 'DESIGN.md dosyasını kopyala',
  'ds.editDesignMd': 'DESIGN.md dosyasını düzenle',
  'ds.openDesignMd': 'DESIGN.md dosyasını aç',
  'ds.copyDesignMdModule': '{module} bölümünü kopyala',
  'ds.editDesignMdModule': '{module} bölümünü düzenle',
  'ds.openDesignMdModule': '{module} bölümünü aç',
  'ds.uploadMd': 'MD yükle',
  'ds.uploadFont': 'Font dosyası ekle',
  'ds.pasteImage': 'Görüntü yapıştır',
  'ds.refresh': 'Yenile',
  'ds.download': 'İndir',
  'ds.importFolder': 'Klasör içe aktar',
  'ds.reset': 'Sıfırla',
  'ds.editingDesignMdHint': 'Bu Markdown düzenlendiğinde işlenen kit modülleri güncellenir.',
  'ds.editingModuleHint': 'Yalnızca {module} modülü düzenleniyor.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'Modülü kaydet',
  'ds.uploadLogo': 'Logo yükle',
  'ds.uploadImage': 'Görüntü yükle',
  'ds.uploading': 'Yükleniyor…',
  'ds.moduleEmptyLogo': 'Henüz logo yok',
  'ds.moduleEmptyFonts': 'Yakalanmış font yok.',
  'ds.actionDone': 'Tamamlandı',
  'ds.actionFailed': 'Bir şeyler ters gitti. Lütfen tekrar deneyin.',
  'ds.uploadDone': 'Yüklendi',
  'ds.uploadFailed': 'Yükleme başarısız. Lütfen tekrar deneyin.',
  'ds.deleteLogo': 'Logoyu sil',
  'ds.deleteImage': '{caption} öğesini sil',
  'ds.deleteProjectConfirm': '“{title}” silinsin mi? Bu işlem bu tasarım sistemini ve projesini bu cihazdan kalıcı olarak kaldırır.',
  'ds.deleteProjectAction': '{title} öğesini sil',
  'ds.editColor': '{name} düzenle',
  'ds.colorLabel': 'Renk',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Hex değeri',
  'ds.saveColor': 'Rengi kaydet',
  'ds.invalidHexColor': '#FF6A3D gibi geçerli bir Hex rengi girin.',
  'ds.colorSaveFailed': 'Bu renk kaydedilemedi.',
  'ds.colorResetFailed': 'Bu renk sıfırlanamadı.',
  'ds.designMdSectionLabel': '{module} DESIGN.md bölümü',
  'ds.kitErrorTitle': 'Bu görünümde bir sorun oluştu.',
  'ds.kitErrorRetry': 'Yeniden yükle',
  'ds.shortcutsLabel': 'Klavye kısayolları',
  'ds.shortcutsHint': 'Kısayollar: E düzenle · C kopyala · U yükle · R yenile · ⌫ logoyu sil',
  'ds.moduleEmptyImages': 'Henüz görüntü yok',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'DANIA Studio is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so DANIA Studio can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
};
